import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type Account = {
  __typename?: 'Account';
  createdAt: Scalars['Datetime']['output'];
  featureFlags?: Maybe<Array<AccountFeatureFlag>>;
  id: Scalars['ID']['output'];
  links: AccountLinks;
  loginCustomization?: Maybe<LoginCustomization>;
  name: Scalars['String']['output'];
  preferences?: Maybe<AccountPreferences>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type AccountFeatureFlag = {
  __typename?: 'AccountFeatureFlag';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<AccountFeatureFlagTranslations>;
  name: Scalars['String']['output'];
};

export type AccountFeatureFlagTranslations = {
  __typename?: 'AccountFeatureFlagTranslations';
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
};

export type AccountLinks = {
  __typename?: 'AccountLinks';
  panel: Scalars['String']['output'];
  pwa: Scalars['String']['output'];
};

export type AccountPreferences = {
  __typename?: 'AccountPreferences';
  deadlineViolationReasons?: Maybe<DeadlineViolationReasonsPreferences>;
  forms?: Maybe<FormsPreferences>;
  integration?: Maybe<IntegrationPreferences>;
  maintenances?: Maybe<MaintenancesPreferences>;
  openMaintenance?: Maybe<OpenMaintenancePreferences>;
  other?: Maybe<OtherPreferences>;
  pwa?: Maybe<PwaPreferences>;
  quotations?: Maybe<QuotationsPreferences>;
  recurrences?: Maybe<RecurrencesPreferences>;
  storages?: Maybe<StoragesPreferences>;
};

export type AccountPreferencesInput = {
  deadlineViolationReasons?: InputMaybe<DeadlineViolationReasonsPreferencesInput>;
  forms?: InputMaybe<FormsPreferencesInput>;
  integration?: InputMaybe<IntegrationPreferencesInput>;
  maintenances?: InputMaybe<MaintenancesPreferencesInput>;
  openMaintenance?: InputMaybe<OpenMaintenancePreferencesInput>;
  pwa?: InputMaybe<PwaPreferencesInput>;
  quotations?: InputMaybe<QuotationsPreferencesInput>;
  recurrences?: InputMaybe<RecurrencesPreferencesInput>;
  storages?: InputMaybe<StoragesPreferencesInput>;
};

export enum AccountQuotationsTotalAndQuantityByProductServiceOrderByInput {
  ProductServiceNameAsc = 'productServiceName_asc',
  ProductServiceNameDesc = 'productServiceName_desc',
  QuantityAsc = 'quantity_asc',
  QuantityDesc = 'quantity_desc',
  TotalAsc = 'total_asc',
  TotalDesc = 'total_desc'
}

export type ActiveContractInput = {
  id: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
};

export type AddLocationToGroupInput = {
  items: Array<AddLocationToGroupInputItem>;
};

export type AddLocationToGroupInputItem = {
  groupId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};

export type AddMaintenancesToPaymentInput = {
  maintenanceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentId: Scalars['ID']['input'];
};

export type AddQuotationsToPaymentInput = {
  paymentId: Scalars['ID']['input'];
  quotationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AddSegmentToGroupInput = {
  items: Array<AddSegmentToGroupInputItem>;
};

export type AddSegmentToGroupInputItem = {
  groupId: Scalars['ID']['input'];
  segmentId: Scalars['ID']['input'];
};

export type AddUsersToGroupsInput = {
  items: Array<AddUsersToGroupsInputItem>;
};

export type AddUsersToGroupsInputItem = {
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  coords?: Maybe<AddressCoords>;
  country?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
};

export type AddressCoords = {
  __typename?: 'AddressCoords';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type AddressCoordsInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type AddressGeocodeInput = {
  formattedAddress: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  coords: AddressCoordsInput;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  prefix: Scalars['String']['output'];
  user: User;
};

export enum ApiKeyOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type ApiKeyPagedResult = {
  __typename?: 'ApiKeyPagedResult';
  items: Array<ApiKey>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApiKeyWhereInput = {
  name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type Approval = {
  __typename?: 'Approval';
  company: Company;
  createdAt: Scalars['Datetime']['output'];
  equipment?: Maybe<ApprovalEquipment>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['Datetime']['output']>;
  resolvedBy?: Maybe<User>;
  status: ApprovalStatus;
};

export type ApprovalEquipment = {
  __typename?: 'ApprovalEquipment';
  archived: Scalars['Boolean']['output'];
  attachments?: Maybe<Array<Maybe<EquipmentAttachment>>>;
  createdAt: Scalars['Datetime']['output'];
  customFields?: Maybe<Array<Maybe<EquipmentCustomField>>>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  location: Location;
  locationEnvironment?: Maybe<LocationEnvironment>;
  locationSector?: Maybe<LocationSector>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  originalEquipmentId: Scalars['ID']['output'];
  qrCode?: Maybe<Scalars['String']['output']>;
  type: EquipmentType;
};

export enum ApprovalOrderByInput {
  CompanyNameAsc = 'companyName_asc',
  CompanyNameDesc = 'companyName_desc',
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  LocationNameAsc = 'locationName_asc',
  LocationNameDesc = 'locationName_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  NumberAsc = 'number_asc',
  NumberDesc = 'number_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  TypeNameAsc = 'typeName_asc',
  TypeNameDesc = 'typeName_desc'
}

export type ApprovalPagedResult = {
  __typename?: 'ApprovalPagedResult';
  items: Array<Approval>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ApprovalStatus {
  Approved = 'approved',
  Canceled = 'canceled',
  Pending = 'pending',
  Refused = 'refused'
}

export type ApprovalWhereInput = {
  company_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  equipmentType_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  location_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  number_contains?: InputMaybe<Scalars['String']['input']>;
  originalEquipmentId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  qrCode_contains?: InputMaybe<Scalars['String']['input']>;
  status_in?: InputMaybe<Array<InputMaybe<ApprovalStatus>>>;
};

export type ApproveQuotationInput = {
  approvedMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ArchiveLocationEnvironmentInput = {
  archiveEquipments?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type ArchiveLocationSectorInput = {
  archiveEquipments: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type ArchivedWarrantyTemplateInput = {
  id: Scalars['ID']['input'];
  unlink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: MaintenanceAttachmentType;
};

export type AttachmentAllowedExtension = {
  __typename?: 'AttachmentAllowedExtension';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AttachmentAllowedExtensionResult = {
  __typename?: 'AttachmentAllowedExtensionResult';
  items: Array<AttachmentAllowedExtension>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  action: AuditLogAction;
  applicationName: AuditLogApplicationName;
  browser?: Maybe<Scalars['String']['output']>;
  clientIpAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  metadata?: Maybe<AuditLogMetadata>;
  operatingSystem?: Maybe<Scalars['String']['output']>;
  type: AuditLogType;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export enum AuditLogAction {
  Archived = 'archived',
  Created = 'created',
  Deleted = 'deleted',
  Disabled = 'disabled',
  Enabled = 'enabled',
  Sent = 'sent',
  Unarchived = 'unarchived',
  Updated = 'updated'
}

export enum AuditLogApplicationName {
  Lorgan = 'lorgan',
  Sammathnaur = 'sammathnaur'
}

export type AuditLogMetadata = {
  __typename?: 'AuditLogMetadata';
  change?: Maybe<AuditLogMetadataChange>;
  company?: Maybe<Company>;
  emailStatus?: Maybe<AuditLogMetadataEmailStatus>;
  group?: Maybe<Group>;
  permission?: Maybe<Permission>;
  preference?: Maybe<Scalars['String']['output']>;
  responseFromSesType?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum AuditLogMetadataChange {
  AddedAllMessageTypes = 'addedAllMessageTypes',
  AddedMessageType = 'addedMessageType',
  AuthenticationPassword = 'authenticationPassword',
  AuthenticationType = 'authenticationType',
  AuthenticationUsername = 'authenticationUsername',
  ClientId = 'clientId',
  LinkedUser = 'linkedUser',
  Mfa = 'mfa',
  OpenIdConfigurationEndpoint = 'openIdConfigurationEndpoint',
  Password = 'password',
  Permission = 'permission',
  Preference = 'preference',
  RemovedMessageType = 'removedMessageType',
  Role = 'role',
  TenantId = 'tenantId',
  Type = 'type',
  UnlinkedUser = 'unlinkedUser',
  Url = 'url'
}

export enum AuditLogMetadataEmailStatus {
  Error = 'error',
  Success = 'success'
}

export type AuditLogPagedResult = {
  __typename?: 'AuditLogPagedResult';
  items: Array<AuditLog>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AuditLogType {
  AccountPreference = 'accountPreference',
  Company = 'company',
  Group = 'group',
  IntegrationKey = 'integrationKey',
  LoginCustomization = 'loginCustomization',
  ResetPasswordEmail = 'resetPasswordEmail',
  User = 'user',
  Webhook = 'webhook'
}

export enum AuditLogsOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc'
}

export type AuditLogsWhereInput = {
  createdAtGte?: InputMaybe<Scalars['Datetime']['input']>;
  createdAtLte?: InputMaybe<Scalars['Datetime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  typeIn?: InputMaybe<Array<AuditLogType>>;
};

export type AuthenticatedUser = {
  __typename?: 'AuthenticatedUser';
  account?: Maybe<Account>;
  accounts: Array<Account>;
  authenticationInfo?: Maybe<AuthenticationInfo>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailHash?: Maybe<Scalars['String']['output']>;
  fieldNewsEmailHash?: Maybe<Scalars['String']['output']>;
  groups: Array<Group>;
  id?: Maybe<Scalars['ID']['output']>;
  loginIntegrationEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferences>;
  role?: Maybe<UserRole>;
  type?: Maybe<UserType>;
  typeUserPwa?: Maybe<UserPwa>;
};

export type AuthenticationInfo = {
  __typename?: 'AuthenticationInfo';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<UserAuthenticationStatus>;
};

export type Author = {
  __typename?: 'Author';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CommentPostedByTypeEnum>;
};

export type AuthorInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CommentPostedByTypeEnum>;
};

export type AverageItem = {
  __typename?: 'AverageItem';
  average?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CancelContractInput = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type CancelMaintenanceInput = {
  cancellationReason: Scalars['String']['input'];
};

export type CancelTicketInput = {
  cancellationReason: Scalars['String']['input'];
};

export type ClosedQuestionAnswerStatistics = {
  __typename?: 'ClosedQuestionAnswerStatistics';
  count?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ColorInput = {
  background: Scalars['String']['input'];
  class: Scalars['String']['input'];
  foreground: Scalars['String']['input'];
};

export type Comment = {
  __typename?: 'Comment';
  archived?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  postedBy?: Maybe<Author>;
  type?: Maybe<CommentTypeEnum>;
};

export type CommentInput = {
  maintenanceId?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  postedBy?: InputMaybe<AuthorInput>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CommentTypeEnum>;
};

export enum CommentPostedByTypeEnum {
  Collaborator = 'collaborator',
  Company = 'company',
  Integration = 'integration',
  User = 'user'
}

export enum CommentTypeEnum {
  Collaborator = 'collaborator',
  Company = 'company',
  Internal = 'internal',
  Public = 'public'
}

export type Company = {
  __typename?: 'Company';
  address?: Maybe<CompanyAddress>;
  archived: Scalars['Boolean']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  fieldAccount?: Maybe<CompanyFieldAccount>;
  fieldAccountId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastLoginAt?: Maybe<Scalars['Datetime']['output']>;
  name: Scalars['String']['output'];
  preferences?: Maybe<CompanyPreferences>;
  stats?: Maybe<CompanyStats>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export type CompanyAddress = {
  __typename?: 'CompanyAddress';
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  coords?: Maybe<AddressCoords>;
  countryCode?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CompanyAddressInput = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  coords: AddressCoordsInput;
  countryCode: Scalars['String']['input'];
  neighborhood: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type CompanyFieldAccount = {
  __typename?: 'CompanyFieldAccount';
  accountType?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<CompanyFieldAccountManager>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type CompanyFieldAccountManager = {
  __typename?: 'CompanyFieldAccountManager';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyInput = {
  address?: InputMaybe<CompanyAddressInput>;
  archived: Scalars['Boolean']['input'];
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  fieldAccountId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  preferences?: InputMaybe<CompanyPreferencesInput>;
};

export type CompanyOrderByDistanceInput = {
  direction: Direction;
  distance: AddressCoordsInput;
};

export enum CompanyOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type CompanyPagedResult = {
  __typename?: 'CompanyPagedResult';
  items: Array<Company>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyPreferences = {
  __typename?: 'CompanyPreferences';
  allowOpenMaintenanceForMaintenanceTypeIds?: Maybe<Array<Scalars['ID']['output']>>;
  featureAllowCompanyCreateRecurrence?: Maybe<Scalars['Boolean']['output']>;
  featureAssignedEmployeeRequired?: Maybe<Scalars['Boolean']['output']>;
  featureDisableCreateEquipment?: Maybe<Scalars['Boolean']['output']>;
  featureDisableCreateEquipmentByApp?: Maybe<Scalars['Boolean']['output']>;
  featureDisableEditTaskStatus?: Maybe<Scalars['Boolean']['output']>;
  featureHideCancelTicketButton?: Maybe<Scalars['Boolean']['output']>;
  featurePendenciesEnabled?: Maybe<Scalars['Boolean']['output']>;
  featureQuotationServiceOrderRequired?: Maybe<Scalars['Boolean']['output']>;
  featureRecurrenceAssignedEmployeeRequired?: Maybe<Scalars['Boolean']['output']>;
  featureStorageControlEnabledByCMMS?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyPreferencesInput = {
  allowOpenMaintenanceForMaintenanceTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  featureAllowCompanyCreateRecurrence?: InputMaybe<Scalars['Boolean']['input']>;
  featureAssignedEmployeeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  featureDisableCreateEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  featureDisableCreateEquipmentByApp?: InputMaybe<Scalars['Boolean']['input']>;
  featureDisableEditTaskStatus?: InputMaybe<Scalars['Boolean']['input']>;
  featureHideCancelTicketButton?: InputMaybe<Scalars['Boolean']['input']>;
  featurePendenciesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  featureQuotationServiceOrderRequired?: InputMaybe<Scalars['Boolean']['input']>;
  featureRecurrenceAssignedEmployeeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  featureStorageControlEnabledByCMMS?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyStats = {
  __typename?: 'CompanyStats';
  averageRating?: Maybe<Scalars['Float']['output']>;
  lastMaintenance?: Maybe<Maintenance>;
  lastRating?: Maybe<TaskRating>;
  totalMaintenances?: Maybe<Scalars['Int']['output']>;
};

export type CompanyWhereInput = {
  account_type?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  document_number_contains?: InputMaybe<Scalars['String']['input']>;
  email_contains?: InputMaybe<Scalars['String']['input']>;
  field_account_id_contains?: InputMaybe<Scalars['String']['input']>;
  field_account_id_exist?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  manager_name_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CompletionProgressResponse = {
  __typename?: 'CompletionProgressResponse';
  completed: Scalars['Int']['output'];
  progressPercentage: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
};

export type ContactEmail = {
  __typename?: 'ContactEmail';
  contactType: EmailContactTypeEnum;
  createdAt: Scalars['Datetime']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
};

export type ContactPhone = {
  __typename?: 'ContactPhone';
  contactType: PhoneContactTypeEnum;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  primary: Scalars['Boolean']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  archived: Scalars['Boolean']['output'];
  attachments?: Maybe<Array<ContractAttachment>>;
  cancelationReason?: Maybe<Scalars['String']['output']>;
  company: Company;
  configuration?: Maybe<ContractConfiguration>;
  contractItems: Array<ContractItem>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<ContractUser>;
  dashboard?: Maybe<ContractDashboard>;
  description?: Maybe<Scalars['String']['output']>;
  endAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startAt: Scalars['Datetime']['output'];
  status: ContractStatusEnum;
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<ContractUser>;
};

export type ContractAttachment = {
  __typename?: 'ContractAttachment';
  bucketName: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<ContractUser>;
  fileKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<ContractUser>;
};

export type ContractAttachmentCreateInput = {
  bucketName: Scalars['String']['input'];
  contractId: Scalars['ID']['input'];
  fileKey: Scalars['String']['input'];
  path: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type ContractAttachmentUpdateInput = {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContractConfiguration = {
  __typename?: 'ContractConfiguration';
  uniqueByEntity: Scalars['Boolean']['output'];
};

export type ContractDashboard = {
  __typename?: 'ContractDashboard';
  activities: ContractDashboardActivities;
  deadlines: ContractDashboardDeadlines;
  maintenanceTypesSummary: Array<ContractDashboardMaintenanceTypeSummary>;
  progress: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ContractDashboardActivities = {
  __typename?: 'ContractDashboardActivities';
  completedMaintenances: Scalars['Int']['output'];
  completedOccurrences: Scalars['Int']['output'];
  totalMaintenances: Scalars['Int']['output'];
  totalOccurrences: Scalars['Int']['output'];
};

export type ContractDashboardDeadlines = {
  __typename?: 'ContractDashboardDeadlines';
  atRisk: Scalars['Int']['output'];
  avgResolutionTimeMinutes: Scalars['Int']['output'];
  completedOnTime: Scalars['Int']['output'];
  completedWithViolation: Scalars['Int']['output'];
  maintenancesResolvedOnTimePercent: Scalars['Int']['output'];
  onTime: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  topViolationReasons: Array<ContractDashboardViolationReason>;
  violated: Scalars['Int']['output'];
};

export type ContractDashboardMaintenanceTypeSummary = {
  __typename?: 'ContractDashboardMaintenanceTypeSummary';
  completed: Scalars['Int']['output'];
  maintenanceTypeId: Scalars['ID']['output'];
  maintenanceTypeName: Scalars['String']['output'];
  planned: Scalars['Int']['output'];
};

export type ContractDashboardViolationReason = {
  __typename?: 'ContractDashboardViolationReason';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type ContractIdentifierResult = {
  __typename?: 'ContractIdentifierResult';
  identifier: Scalars['String']['output'];
};

export type ContractItem = {
  __typename?: 'ContractItem';
  configuration?: Maybe<ContractItemConfiguration>;
  contract: Contract;
  deadlineContract?: Maybe<DeadlineContract>;
  endAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  itemLocations: Array<ContractItemLocation>;
  maintenanceType?: Maybe<MaintenanceType>;
  productsServices?: Maybe<Array<ProductService>>;
  repeatEvery?: Maybe<Scalars['Int']['output']>;
  repeatInterval?: Maybe<RecurrenceIntervalEnum>;
  segment?: Maybe<Segment>;
  skipFriday?: Maybe<Scalars['Boolean']['output']>;
  startAt?: Maybe<Scalars['Datetime']['output']>;
};

export type ContractItemConfiguration = {
  __typename?: 'ContractItemConfiguration';
  isNonRecurring: Scalars['Boolean']['output'];
};

export type ContractItemConfigurationInput = {
  isNonRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  uniqueByEntity?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractItemLocation = {
  __typename?: 'ContractItemLocation';
  location: Location;
  locationEquipments?: Maybe<Array<ContractItemLocationEquipment>>;
  locationSectors?: Maybe<Array<ContractItemLocationSector>>;
  recurrence?: Maybe<Recurrence>;
};

export type ContractItemLocationEnvironment = {
  __typename?: 'ContractItemLocationEnvironment';
  environment: LocationEnvironment;
  locationSectorEnvironmentEquipments?: Maybe<Array<ContractItemLocationEquipment>>;
  recurrence?: Maybe<Recurrence>;
};

export type ContractItemLocationEquipment = {
  __typename?: 'ContractItemLocationEquipment';
  equipment: Equipment;
  recurrence?: Maybe<Recurrence>;
};

export type ContractItemLocationSector = {
  __typename?: 'ContractItemLocationSector';
  locationSectorEnvironments?: Maybe<Array<ContractItemLocationEnvironment>>;
  locationSectorEquipments?: Maybe<Array<ContractItemLocationEquipment>>;
  recurrence?: Maybe<Recurrence>;
  sector: LocationSector;
};

export enum ContractOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  EndeddAtAsc = 'endeddAt_asc',
  EndeddAtDesc = 'endeddAt_desc',
  IdentifierAsc = 'identifier_asc',
  IdentifierDesc = 'identifier_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  StartedAtAsc = 'startedAt_asc',
  StartedAtDesc = 'startedAt_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc'
}

export type ContractPagedResult = {
  __typename?: 'ContractPagedResult';
  items: Array<Maybe<Contract>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractProductServiceInput = {
  productServiceId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
  type?: InputMaybe<ProductServiceType>;
};

export enum ContractStatusEnum {
  Active = 'active',
  Canceled = 'canceled',
  Draft = 'draft',
  Expired = 'expired',
  Paused = 'paused'
}

export enum ContractStatusWhereEnum {
  Active = 'active',
  Canceled = 'canceled',
  Expired = 'expired'
}

export type ContractUser = {
  __typename?: 'ContractUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ContractWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endedAtGte?: InputMaybe<Scalars['Datetime']['input']>;
  endedAtLte?: InputMaybe<Scalars['Datetime']['input']>;
  identifierContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  startedAtAtGte?: InputMaybe<Scalars['Datetime']['input']>;
  startedAtLte?: InputMaybe<Scalars['Datetime']['input']>;
  statusIn?: InputMaybe<Array<ContractStatusWhereEnum>>;
};

export type CoordinatesGeocodeInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Course = {
  __typename?: 'Course';
  archived: Scalars['Boolean']['output'];
  category: CourseCategory;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastSectionPosition?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  progress?: Maybe<CourseProgress>;
  sections: Array<CourseSection>;
  type: CoursesTypesEnum;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: User;
};


export type CourseSectionsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CourseCategory = {
  __typename?: 'CourseCategory';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CourseCategoryPagedResult = {
  __typename?: 'CourseCategoryPagedResult';
  items: Array<CourseCategory>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CourseOrderByEnum {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type CourseProgress = {
  __typename?: 'CourseProgress';
  account: Account;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  course: Course;
  currentSection?: Maybe<CourseSection>;
  id: Scalars['ID']['output'];
  progressPercentage: Scalars['Float']['output'];
  startedAt: Scalars['Datetime']['output'];
  user: User;
};

export type CourseSection = {
  __typename?: 'CourseSection';
  archived: Scalars['Boolean']['output'];
  contents: Array<PartialCourseSectionContent>;
  course: Course;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  progress?: Maybe<CourseSectionProgress>;
};


export type CourseSectionContentsArgs = {
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CourseSectionContent = {
  __typename?: 'CourseSectionContent';
  archived: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  contentPreview: Scalars['String']['output'];
  course: Course;
  courseSection: CourseSection;
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  draft: Scalars['Boolean']['output'];
  extraFiles: Array<CourseSectionContentFile>;
  id: Scalars['ID']['output'];
  mainFile?: Maybe<CourseSectionContentFile>;
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  progress?: Maybe<CourseSectionContentProgress>;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: User;
};

export type CourseSectionContentFile = {
  __typename?: 'CourseSectionContentFile';
  course: Course;
  courseSectionContent: CourseSectionContent;
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: CourseSectionContentFileTypeEnum;
};

export enum CourseSectionContentFileTypeEnum {
  Extra = 'extra',
  Main = 'main'
}

export enum CourseSectionContentOrderByEnum {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type CourseSectionContentPagedResult = {
  __typename?: 'CourseSectionContentPagedResult';
  items: Array<CourseSectionContent>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseSectionContentProgress = {
  __typename?: 'CourseSectionContentProgress';
  account: Account;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  courseSectionContent: CourseSectionContent;
  courseSectionProgress: CourseSectionProgress;
  id: Scalars['ID']['output'];
  startedAt: Scalars['Datetime']['output'];
  user: User;
};

export type CourseSectionContentWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  contentContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
};

export type CourseSectionProgress = {
  __typename?: 'CourseSectionProgress';
  account: Account;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  courseProgress: CourseProgress;
  courseSection: CourseSection;
  currentSectionContent?: Maybe<CourseSectionContent>;
  id: Scalars['ID']['output'];
  progressPercentage: Scalars['Float']['output'];
  startedAt: Scalars['Datetime']['output'];
  user: User;
};

export type CourseWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  categoryNameContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CoursesTypesEnum>;
};

export type CoursesCategoryWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
};

export type CoursesCmmsForUser = {
  __typename?: 'CoursesCmmsForUser';
  cmms_id: Scalars['ID']['output'];
  cmms_name: Scalars['String']['output'];
  courses: Array<Course>;
};

export type CoursesForUser = {
  __typename?: 'CoursesForUser';
  /** Courses from the user's company */
  cmmsToFsm: Array<CoursesCmmsForUser>;
  /** Courses from the user's company */
  fsm: Array<Course>;
  /** Global courses from Field (meta) */
  globalFsm: Array<Course>;
};

export type CoursesPagedResult = {
  __typename?: 'CoursesPagedResult';
  items: Array<Course>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CoursesTypesEnum {
  /** Empresas que fazem as gestao de equipamentos ou locais fazendo treinamentos para elas mesmas */
  Cmms = 'cmms',
  /** Empresas que fazem as gestao de equipamentos ou locais fazendo treinamentos para seus fornecedores */
  CmmsFsm = 'cmms_fsm',
  /** Empresas com time de campo fazendo treinamentos para elas mesmas */
  Fsm = 'fsm',
  /** Field fazendo treinamentos para  empresas que fazem as gestao de equipamentos ou locais fazendo treinamentos para elas mesmas */
  GlobalCmms = 'global_cmms',
  /** Field fazendo treinamentos para empresas que prestam serviço em campo */
  GlobalFsm = 'global_fsm'
}

export type CreateApiKeyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateApiKeyResult = {
  __typename?: 'CreateApiKeyResult';
  createdAt: Scalars['Datetime']['output'];
  deletedAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  plainTextApiKey: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  user: User;
};

export type CreateContractInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  configuration?: InputMaybe<ContractItemConfigurationInput>;
  contractItems: Array<CreateContractItemInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startAt: Scalars['String']['input'];
};

export type CreateContractItemInput = {
  configuration?: InputMaybe<ContractItemConfigurationInput>;
  deadlineContractId?: InputMaybe<Scalars['ID']['input']>;
  endAt?: InputMaybe<Scalars['String']['input']>;
  itemLocation: Array<CreateContractItemLocationInput>;
  maintenanceTypeId: Scalars['ID']['input'];
  productsServices?: InputMaybe<Array<ContractProductServiceInput>>;
  repeatEvery?: InputMaybe<Scalars['Int']['input']>;
  repeatInterval?: InputMaybe<RecurrenceIntervalEnum>;
  segmentId: Scalars['ID']['input'];
  skipFriday?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractItemLocationEnvironmentInput = {
  environmentId: Scalars['ID']['input'];
  equipments?: InputMaybe<Array<CreateContractItemLocationEquipmentInput>>;
};

export type CreateContractItemLocationEquipmentInput = {
  equipmentId: Scalars['ID']['input'];
};

export type CreateContractItemLocationInput = {
  equipments?: InputMaybe<Array<CreateContractItemLocationEquipmentInput>>;
  locationId: Scalars['ID']['input'];
  sectors?: InputMaybe<Array<CreateContractItemLocationSectorInput>>;
};

export type CreateContractItemLocationSectorInput = {
  environments?: InputMaybe<Array<CreateContractItemLocationEnvironmentInput>>;
  equipments?: InputMaybe<Array<CreateContractItemLocationEquipmentInput>>;
  sectorId: Scalars['ID']['input'];
};

export type CreateCourseInput = {
  categoryId: Scalars['ID']['input'];
  coverPath: Scalars['String']['input'];
  coverSize: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  type: CoursesTypesEnum;
};

export type CreateCourseSectionContentFileInput = {
  courseSectionContentId: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: CourseSectionContentFileTypeEnum;
};

export type CreateCourseSectionContentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  courseSectionId: Scalars['ID']['input'];
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Float']['input'];
};

export type CreateCourseSectionInput = {
  courseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Float']['input'];
};

export type CreateCoursesCategoryInput = {
  name: Scalars['String']['input'];
};

export type CreateDeadlineViolationReasonInput = {
  color: Scalars['String']['input'];
  deadlineContractIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateEquipmentInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  customFields?: InputMaybe<Array<EquipmentCustomFieldInput>>;
  equipmentTypeId: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  installedAt?: InputMaybe<Scalars['Date']['input']>;
  locationEnvironmentId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
  locationSectorId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  purchasedAt?: InputMaybe<Scalars['Date']['input']>;
  qrCode: Scalars['String']['input'];
};

export type CreateExpenseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  receiptRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateExportInput = {
  companyWhere?: InputMaybe<CompanyWhereInput>;
  dashboardFormsAnswersDetailWhere?: InputMaybe<DashboardFormsAnswersDetailWhereInput>;
  dashboardProductsServicesTopCompaniesWhere?: InputMaybe<DashboardQuotationsWhereInput>;
  equipmentWhere?: InputMaybe<EquipmentWhereInput>;
  groupWhere?: InputMaybe<GroupWhereInput>;
  language: Scalars['String']['input'];
  locationInclude?: InputMaybe<Array<LocationIncludeInput>>;
  locationWhere?: InputMaybe<LocationWhereInput>;
  maintenanceImrWhere?: InputMaybe<MaintenanceImrWhereInput>;
  maintenanceWhere?: InputMaybe<MaintenanceWhereInput>;
  paymentInclude?: InputMaybe<Array<PaymentIncludeInput>>;
  paymentWhere?: InputMaybe<PaymentWhereInput>;
  pendencyWhere?: InputMaybe<PendenciesWhereInput>;
  productServiceWhere?: InputMaybe<ProductServiceWhereInput>;
  productTypeWhere?: InputMaybe<ProductTypeWhereInput>;
  productWhere?: InputMaybe<ProductsWhereInput>;
  quotationWhere?: InputMaybe<QuotationWhereInput>;
  recurrenceWhere?: InputMaybe<RecurrenceWhereInput>;
  serviceWhere?: InputMaybe<ServiceWhereInput>;
  storageMovementWhere?: InputMaybe<StoragesMovementsWhereInput>;
  storageProductsWhere?: InputMaybe<StorageProductsWhereInput>;
  storageWhere?: InputMaybe<StoragesWhereInput>;
  timezone: Scalars['String']['input'];
  type: ExportTypeEnum;
  userWhere?: InputMaybe<UserWhereInput>;
};

export type CreateFilterInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreateFormAnswerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  questions: Array<CreateQuestionAnswerInput>;
  reference: Scalars['ID']['input'];
};

export type CreateGuestInput = {
  address: GuestAddressInput;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  documentNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  sendInviteEmail: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
};

export type CreateImportInput = {
  bucketName: Scalars['String']['input'];
  fileKey: Scalars['String']['input'];
  type: ImportType;
};

export type CreateInviteInput = {
  emails: Array<Scalars['String']['input']>;
};

export type CreateInviteResult = {
  __typename?: 'CreateInviteResult';
  alreadyAccepted: Array<Scalars['String']['output']>;
  alreadyPending: Array<Scalars['String']['output']>;
  created: Array<Invite>;
};

export type CreateLocationEnvironmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locationSectorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  qrCode: Scalars['String']['input'];
};

export type CreateLocationSectorInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateMaintenanceTypeInput = {
  archived: Scalars['Boolean']['input'];
  availableOnApp: Scalars['Boolean']['input'];
  mobileStartCompleteTaskValidationRadiusMeters?: InputMaybe<Scalars['Int']['input']>;
  mobileStartCompleteTaskValidationRadiusOn?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ratingFormId?: InputMaybe<Scalars['ID']['input']>;
  sendEmailEmployeeRouteTrackingLinkWhenOnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailOrderReportLinkWhenCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailTaskRatingLinkWhenCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  signatureRequired: Scalars['Boolean']['input'];
  ticketFormId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePaymentInput = {
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  maintenanceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  number: Scalars['String']['input'];
  quotationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: PaymentTypeEnum;
};

export type CreatePendencyEventNoteInput = {
  message: Scalars['String']['input'];
  pendencyId: Scalars['ID']['input'];
};

export type CreatePendencyEventReplyInput = {
  attachments?: InputMaybe<Array<PendencyEventAttachmentInput>>;
  message: Scalars['String']['input'];
  pendencyId: Scalars['ID']['input'];
};

export type CreatePendencyInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  maintenanceId?: InputMaybe<Scalars['ID']['input']>;
  pendencyTypeId: Scalars['ID']['input'];
  readerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  treatmentType?: InputMaybe<PendencyTreatmentType>;
};

export type CreatePendencyTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateProductCompanyInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  preferences?: InputMaybe<ProductServiceCompanyPreferencesInput>;
  productId: Scalars['ID']['input'];
  value: Scalars['Float']['input'];
  valueType: ProductServiceValueType;
};

export type CreateProductInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<ProductServiceCompanyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  measure: ProductServiceMeasure;
  name: Scalars['String']['input'];
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  qrCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateQuestionAnswerInput = {
  answer: Scalars['String']['input'];
  conditions?: InputMaybe<Array<QuestionConditionInput>>;
  id: Scalars['ID']['input'];
  options?: InputMaybe<Array<QuestionAnswerOptionInput>>;
  position: Scalars['Int']['input'];
  required: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  type: QuestionTypeEnum;
};

export type CreateQuotationLabelInput = {
  labelId: Scalars['ID']['input'];
  quotationId: Scalars['ID']['input'];
};

export type CreateServiceInput = {
  companies?: InputMaybe<Array<ProductServiceCompanyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateStorageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateStorageMovementInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  products: Array<InputMaybe<MovementProductInput>>;
  relatedStorageId?: InputMaybe<Scalars['ID']['input']>;
  storageId: Scalars['ID']['input'];
  type: StorageMovementType;
};

export type CreateWarrantyInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  coverageDurationDays?: InputMaybe<Scalars['Int']['input']>;
  coverageStartedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipmentId?: InputMaybe<Scalars['ID']['input']>;
  extendedCoverageDurationDays?: InputMaybe<Scalars['Int']['input']>;
  extendedValue?: InputMaybe<Scalars['Float']['input']>;
  maintenanceId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  warrantyTemplateId: Scalars['ID']['input'];
};

export type CreateWarrantyTemplateInput = {
  archived: Scalars['Boolean']['input'];
  attachments?: InputMaybe<Array<WarrantyAttachmentInput>>;
  coverageDurationDays: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  extendedCoverageDurationDays: Scalars['Int']['input'];
  extendedValue: Scalars['Float']['input'];
  maintenanceTypesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export enum CreatedAtOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc'
}

export type Criteria = {
  __typename?: 'Criteria';
  id: Scalars['ID']['output'];
  ruleName: CriteriaRuleName;
  value: CriteriaValue;
};

export type CriteriaDataByCompany = {
  __typename?: 'CriteriaDataByCompany';
  company: Company;
  criteriasResult: Array<CriteriaDataByCompanyResult>;
};

export type CriteriaDataByCompanyResult = {
  __typename?: 'CriteriaDataByCompanyResult';
  id?: Maybe<Scalars['ID']['output']>;
  ruleName: CriteriaRuleName;
  value: Scalars['Float']['output'];
};

export type CriteriaGroup = {
  __typename?: 'CriteriaGroup';
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  criterias: Array<Criteria>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export type CriteriaGroupInput = {
  criterias: Array<CriteriaInput>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CriteriaInput = {
  ruleName: CriteriaRuleName;
  value: CriteriaValueInput;
};

export enum CriteriaRuleName {
  AcceptedPercentage = 'accepted_percentage',
  AverageCloseTimeInDays = 'average_close_time_in_days',
  AverageRating = 'average_rating',
  AverageResponseTimeInDays = 'average_response_time_in_days',
  CompletedPercentage = 'completed_percentage',
  InProgressInterval = 'in_progress_interval',
  IncompletedPercentage = 'incompleted_percentage',
  OnNegotiationInterval = 'on_negotiation_interval',
  PendingInterval = 'pending_interval',
  RefusedPercentage = 'refused_percentage',
  ReportedInterval = 'reported_interval',
  RequestedInterval = 'requested_interval',
  ResponseInterval = 'response_interval',
  ResponseOnTimePercentage = 'response_on_time_percentage',
  ResponseOnTimePercentageByRange = 'response_on_time_percentage_by_range',
  ScheduledInterval = 'scheduled_interval',
  SolutionInterval = 'solution_interval',
  SolutionOnTimePercentage = 'solution_on_time_percentage',
  SolutionOnTimePercentageByRange = 'solution_on_time_percentage_by_range'
}

export type CriteriaValue = CriteriaValuePercentRange | CriteriaValuePoints | CriteriaValueResultThreshold;

export type CriteriaValueInput = {
  maintenanceTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  percentRange?: InputMaybe<Array<CriteriaValueRangesInput>>;
  points?: InputMaybe<Scalars['Int']['input']>;
  resultThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type CriteriaValuePercentRange = {
  __typename?: 'CriteriaValuePercentRange';
  maintenanceTypeIds?: Maybe<Array<Scalars['ID']['output']>>;
  percentRange?: Maybe<Array<Maybe<CriteriaValueRanges>>>;
};

export type CriteriaValuePoints = {
  __typename?: 'CriteriaValuePoints';
  maintenanceTypeIds?: Maybe<Array<Scalars['ID']['output']>>;
  points?: Maybe<Scalars['Int']['output']>;
};

export type CriteriaValueRanges = {
  __typename?: 'CriteriaValueRanges';
  discount: Scalars['Int']['output'];
  end: Scalars['Int']['output'];
  points?: Maybe<Scalars['Int']['output']>;
  start: Scalars['Int']['output'];
};

export type CriteriaValueRangesInput = {
  discount: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
  points: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
};

export type CriteriaValueResultThreshold = {
  __typename?: 'CriteriaValueResultThreshold';
  maintenanceTypeIds?: Maybe<Array<Scalars['ID']['output']>>;
  points?: Maybe<Scalars['Int']['output']>;
  resultThreshold: Scalars['Float']['output'];
};

export type CriteriasGroups = {
  __typename?: 'CriteriasGroups';
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export type CriteriasGroupsDataWhereInput = {
  closedAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  closedAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['Datetime']['input']>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduledAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  scheduledAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['Datetime']['input']>;
  typeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum CriteriasGroupsOrderByInput {
  AcceptedPercentage = 'accepted_percentage',
  AverageCloseTimeInDays = 'average_close_time_in_days',
  AverageRating = 'average_rating',
  AverageResponseTimeInDays = 'average_response_time_in_days',
  CompletedPercentage = 'completed_percentage',
  InProgressInterval = 'in_progress_interval',
  IncompletedPercentage = 'incompleted_percentage',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  OnNegotiationInterval = 'on_negotiation_interval',
  PendingInterval = 'pending_interval',
  RefusedPercentage = 'refused_percentage',
  ReportedInterval = 'reported_interval',
  RequestedInterval = 'requested_interval',
  ResponseInterval = 'response_interval',
  ResponseOnTimePercentage = 'response_on_time_percentage',
  ResponseOnTimePercentageByRange = 'response_on_time_percentage_by_range',
  ScheduledInterval = 'scheduled_interval',
  SolutionInterval = 'solution_interval',
  SolutionOnTimePercentage = 'solution_on_time_percentage',
  SolutionOnTimePercentageByRange = 'solution_on_time_percentage_by_range'
}

export type CriteriasGroupsPagedResult = {
  __typename?: 'CriteriasGroupsPagedResult';
  items: Array<Maybe<CriteriasGroups>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CriteriasGroupsWhereInput = {
  name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type CurrentMaintenanceInprogressByEmployee = {
  employeeUuid: Scalars['ID']['input'];
};

export type CursorPageInfo = {
  __typename?: 'CursorPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type CustomFieldOptionInput = {
  value: Scalars['String']['input'];
};

export enum CustomFieldType {
  Date = 'date',
  MultipleChoice = 'multipleChoice',
  Number = 'number',
  Question = 'question'
}

export type DashboardAverageResult = {
  __typename?: 'DashboardAverageResult';
  items: Array<ResultAverageItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardCompanyResult = {
  __typename?: 'DashboardCompanyResult';
  items: Array<ResultCompanyItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardFormsAnswersDetailItem = {
  __typename?: 'DashboardFormsAnswersDetailItem';
  answers: Array<QuestionAnswerStatistics>;
  position: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: QuestionTypeEnum;
};

export type DashboardFormsAnswersDetailResult = {
  __typename?: 'DashboardFormsAnswersDetailResult';
  items: Array<DashboardFormsAnswersDetailItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardFormsAnswersDetailWhereInput = {
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  formAnswer_contains?: InputMaybe<Scalars['String']['input']>;
  formId_eq: Scalars['ID']['input'];
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DashboardFormsAnswersItem = {
  __typename?: 'DashboardFormsAnswersItem';
  formAnswerCount: Scalars['Int']['output'];
  formId: Scalars['ID']['output'];
  formName: Scalars['String']['output'];
};

export type DashboardFormsAnswersResult = {
  __typename?: 'DashboardFormsAnswersResult';
  items: Array<DashboardFormsAnswersItem>;
  pageInfo?: Maybe<PageInfo>;
  reportName: Scalars['String']['output'];
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DashboardFormsAnswersWhereInput = {
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  formAnswer_contains?: InputMaybe<Scalars['String']['input']>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DashboardHistoryResult = {
  __typename?: 'DashboardHistoryResult';
  items: Array<ResultHistoryItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardInput = {
  closedAt_gte?: InputMaybe<Scalars['Date']['input']>;
  closedAt_lte?: InputMaybe<Scalars['Date']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  equipmentId_in?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['Datetime']['input']>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  openedAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  openedAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  scheduledAt_gte?: InputMaybe<Scalars['Date']['input']>;
  scheduledAt_lte?: InputMaybe<Scalars['Date']['input']>;
  scheduled_at_gte?: InputMaybe<Scalars['Date']['input']>;
  scheduled_at_lte?: InputMaybe<Scalars['Date']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['Datetime']['input']>;
  typeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  type_in?: InputMaybe<Array<MaintenanceTypeEnum>>;
};

export type DashboardMaintenancesAverageDeadlinesItem = {
  __typename?: 'DashboardMaintenancesAverageDeadlinesItem';
  averageCloseTimeInDays: Scalars['Float']['output'];
  averageResponseTimeInDays: Scalars['Float']['output'];
  closedOnTimeCount: Scalars['Float']['output'];
  closedOnTimePercentage: Scalars['Float']['output'];
  closedOutTimeCount: Scalars['Float']['output'];
  fistVisitOnTimeCount: Scalars['Float']['output'];
  fistVisitOutTimeCount: Scalars['Float']['output'];
  maintenanceCount: Scalars['Int']['output'];
  responseOnTimePercentage: Scalars['Float']['output'];
  withoutDeadlineCount: Scalars['Float']['output'];
};

export type DashboardMaintenancesAverageDeadlinesResult = {
  __typename?: 'DashboardMaintenancesAverageDeadlinesResult';
  item: DashboardMaintenancesAverageDeadlinesItem;
  reportName: Scalars['String']['output'];
};

export type DashboardMaintenancesClosedInPeriodByMonthItem = {
  __typename?: 'DashboardMaintenancesClosedInPeriodByMonthItem';
  closedInPeriodCount: Scalars['Float']['output'];
  closedOutPeriodCount: Scalars['Float']['output'];
  month: Scalars['String']['output'];
};

export type DashboardMaintenancesClosedInPeriodByMonthResult = {
  __typename?: 'DashboardMaintenancesClosedInPeriodByMonthResult';
  items: Array<DashboardMaintenancesClosedInPeriodByMonthItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardMaintenancesCompletedTimelineItem = {
  __typename?: 'DashboardMaintenancesCompletedTimelineItem';
  closedAt: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type DashboardMaintenancesCompletedTimelineResult = {
  __typename?: 'DashboardMaintenancesCompletedTimelineResult';
  items: Array<Maybe<DashboardMaintenancesCompletedTimelineItem>>;
  reportName: Scalars['String']['output'];
};

export type DashboardMaintenancesDeadlineByDayItem = {
  __typename?: 'DashboardMaintenancesDeadlineByDayItem';
  closedInPeriodCount: Scalars['Float']['output'];
  closedOutPeriodCount: Scalars['Float']['output'];
  day: Scalars['String']['output'];
  firstVisitInPeriodCount: Scalars['Float']['output'];
  firstVisitOutPeriodCount: Scalars['Float']['output'];
};

export type DashboardMaintenancesDeadlinesByDayResult = {
  __typename?: 'DashboardMaintenancesDeadlinesByDayResult';
  items: Array<DashboardMaintenancesDeadlineByDayItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardMaintenancesFirstVisitInPeriodByMonthItem = {
  __typename?: 'DashboardMaintenancesFirstVisitInPeriodByMonthItem';
  firstVisitInPeriodCount: Scalars['Float']['output'];
  firstVisitOutPeriodCount: Scalars['Float']['output'];
  month: Scalars['String']['output'];
};

export type DashboardMaintenancesFirstVisitInPeriodByMonthResult = {
  __typename?: 'DashboardMaintenancesFirstVisitInPeriodByMonthResult';
  items: Array<Maybe<DashboardMaintenancesFirstVisitInPeriodByMonthItem>>;
  reportName: Scalars['String']['output'];
};

export type DashboardMaintenancesLineChartWhereInput = {
  closedAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  closedAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['Datetime']['input']>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduledAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  scheduledAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeZone: Scalars['String']['input'];
  to?: InputMaybe<Scalars['Datetime']['input']>;
  typeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  type_in?: InputMaybe<Array<MaintenanceTypeEnum>>;
};

export type DashboardMaintenancesTimelineWhereInput = {
  closedAt_gte?: InputMaybe<Scalars['Date']['input']>;
  closedAt_lte?: InputMaybe<Scalars['Date']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interval: TimelineIntervalEnum;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduledAt_gte?: InputMaybe<Scalars['Date']['input']>;
  scheduledAt_lte?: InputMaybe<Scalars['Date']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  typeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  type_in?: InputMaybe<Array<MaintenanceTypeEnum>>;
};

export type DashboardProductsByStorageResult = {
  __typename?: 'DashboardProductsByStorageResult';
  items: Array<ResultItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardQuotationsWhereInput = {
  agreementAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  agreementAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  productServiceId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DashboardRatingTasksResult = {
  __typename?: 'DashboardRatingTasksResult';
  items?: Maybe<Array<DashboardRatingsTask>>;
  reportName: Scalars['String']['output'];
};

export type DashboardRatingsAverageTimelineItem = {
  __typename?: 'DashboardRatingsAverageTimelineItem';
  averageRating: Scalars['Float']['output'];
  completedAt: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type DashboardRatingsAverageTimelineResult = {
  __typename?: 'DashboardRatingsAverageTimelineResult';
  items: Array<DashboardRatingsAverageTimelineItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardRatingsByTimelineWhereInput = {
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  interval: TimelineIntervalEnum;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DashboardRatingsItem = {
  __typename?: 'DashboardRatingsItem';
  averageRating: Scalars['Float']['output'];
  fiveStarsCount: Scalars['Int']['output'];
  fourStarsCount: Scalars['Int']['output'];
  negativeCount: Scalars['Int']['output'];
  oneStarCount: Scalars['Int']['output'];
  positiveCount: Scalars['Int']['output'];
  threeStarsCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  twoStarsCount: Scalars['Int']['output'];
};

export type DashboardRatingsLineChartWhere = {
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  completedAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  completedAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeZone: Scalars['String']['input'];
};

export type DashboardRatingsResult = {
  __typename?: 'DashboardRatingsResult';
  item: DashboardRatingsItem;
  reportName: Scalars['String']['output'];
};

export type DashboardRatingsTask = {
  __typename?: 'DashboardRatingsTask';
  id: Scalars['ID']['output'];
  maintenance: Maintenance;
  ratingStars: Scalars['Int']['output'];
};

export enum DashboardRatingsTasksOrderByInput {
  RatingStarsAsc = 'ratingStars_asc',
  RatingStarsDesc = 'ratingStars_desc'
}

export type DashboardRatingsTasksWhereInput = {
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  completedAt_gte: Scalars['Datetime']['input'];
  completedAt_lte: Scalars['Datetime']['input'];
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  rating_in: Array<Scalars['Int']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DashboardRatingsWhereInput = {
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  completedAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  completedAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  openedAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  openedAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  scheduledAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  scheduledAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DashboardResult = {
  __typename?: 'DashboardResult';
  items: Array<ResultItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardStorageMovementsByDayItem = {
  __typename?: 'DashboardStorageMovementsByDayItem';
  date: Scalars['String']['output'];
  entryCount: Scalars['Int']['output'];
  finalCount: Scalars['Int']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  removeCount: Scalars['Int']['output'];
  storageId: Scalars['String']['output'];
  storageName: Scalars['String']['output'];
  transferCount: Scalars['Int']['output'];
};

export type DashboardStorageMovementsByDayResult = {
  __typename?: 'DashboardStorageMovementsByDayResult';
  items: Array<DashboardStorageMovementsByDayItem>;
  reportName: Scalars['String']['output'];
};

export type DashboardStorageMovementsByTypeItem = {
  __typename?: 'DashboardStorageMovementsByTypeItem';
  entryCount: Scalars['Int']['output'];
  removeCount: Scalars['Int']['output'];
  transferCount: Scalars['Int']['output'];
};

export type DashboardStorageMovementsByTypeResult = {
  __typename?: 'DashboardStorageMovementsByTypeResult';
  item: DashboardStorageMovementsByTypeItem;
  reportName: Scalars['String']['output'];
};

export type DashboardStorageWhereInput = {
  from: Scalars['Datetime']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  storageId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  to: Scalars['Datetime']['input'];
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars['Datetime']['input']>;
  to?: InputMaybe<Scalars['Datetime']['input']>;
};

export type DeadlineContract = {
  __typename?: 'DeadlineContract';
  archived: Scalars['Boolean']['output'];
  considerHoliday: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  customInterval?: Maybe<DeadlineContractInterval>;
  deadlineViolationReasons?: Maybe<Array<DeadlineViolationReason>>;
  description: Scalars['String']['output'];
  hasCustomInterval: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  responseDeadline: DeadlineContractResponseSolution;
  responseRisk: DeadlineContractResponseSolution;
  solutionDeadline: DeadlineContractResponseSolution;
  solutionRisk: DeadlineContractResponseSolution;
  updatedAt: Scalars['Datetime']['output'];
};

export type DeadlineContractInput = {
  considerHoliday: Scalars['Boolean']['input'];
  customInterval?: InputMaybe<DeadlineContractIntervalInput>;
  customIntervalTimezone?: InputMaybe<Scalars['String']['input']>;
  deadlineViolationReasonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  responseDeadline: DeadlineContractResponseSolutionInput;
  responseRisk: DeadlineContractResponseSolutionInput;
  solutionDeadline: DeadlineContractResponseSolutionInput;
  solutionRisk: DeadlineContractResponseSolutionInput;
};

export type DeadlineContractInterval = {
  __typename?: 'DeadlineContractInterval';
  friday?: Maybe<DeadlineContractIntervalTimeRange>;
  monday?: Maybe<DeadlineContractIntervalTimeRange>;
  saturday?: Maybe<DeadlineContractIntervalTimeRange>;
  sunday?: Maybe<DeadlineContractIntervalTimeRange>;
  thursday?: Maybe<DeadlineContractIntervalTimeRange>;
  tuesday?: Maybe<DeadlineContractIntervalTimeRange>;
  wednesday?: Maybe<DeadlineContractIntervalTimeRange>;
};

export type DeadlineContractIntervalInput = {
  friday?: InputMaybe<DeadlineContractIntervalTimeRangeInput>;
  monday?: InputMaybe<DeadlineContractIntervalTimeRangeInput>;
  saturday?: InputMaybe<DeadlineContractIntervalTimeRangeInput>;
  sunday?: InputMaybe<DeadlineContractIntervalTimeRangeInput>;
  thursday?: InputMaybe<DeadlineContractIntervalTimeRangeInput>;
  tuesday?: InputMaybe<DeadlineContractIntervalTimeRangeInput>;
  wednesday?: InputMaybe<DeadlineContractIntervalTimeRangeInput>;
};

export type DeadlineContractIntervalTimeRange = {
  __typename?: 'DeadlineContractIntervalTimeRange';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type DeadlineContractIntervalTimeRangeInput = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export enum DeadlineContractOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type DeadlineContractPagedResult = {
  __typename?: 'DeadlineContractPagedResult';
  items: Array<DeadlineContract>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeadlineContractResponseSolution = {
  __typename?: 'DeadlineContractResponseSolution';
  unity: DeadlineContractResponseSolutionUnityEnum;
  valueInMinutes: Scalars['Int']['output'];
};

export type DeadlineContractResponseSolutionInput = {
  unity: DeadlineContractResponseSolutionUnityEnum;
  valueInMinutes: Scalars['Int']['input'];
};

export enum DeadlineContractResponseSolutionUnityEnum {
  Days = 'days',
  Hours = 'hours',
  Minutes = 'minutes'
}

export type DeadlineContractViolationReason = {
  __typename?: 'DeadlineContractViolationReason';
  deadlineViolationReason: DeadlineViolationReason;
  linkedBy: MaintenanceDeadlineContractViolationReasonLinkedBy;
};

export type DeadlineContractWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type DeadlineViolationReason = {
  __typename?: 'DeadlineViolationReason';
  archived: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  deadlineContracts?: Maybe<Array<DeadlineContract>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export enum DeadlineViolationReasonOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type DeadlineViolationReasonPagedResult = {
  __typename?: 'DeadlineViolationReasonPagedResult';
  items: Array<DeadlineViolationReason>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeadlineViolationReasonWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  deadlineContractIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
};

export type DeadlineViolationReasonsPreferences = {
  __typename?: 'DeadlineViolationReasonsPreferences';
  featureDisableAddDeadlineViolationReason?: Maybe<Scalars['Boolean']['output']>;
};

export type DeadlineViolationReasonsPreferencesInput = {
  featureDisableAddDeadlineViolationReason: Scalars['Boolean']['input'];
};

export type DeadlinesWhereInput = {
  closedAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  closedAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  openedAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  openedAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  scheduledAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  scheduledAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export enum Direction {
  Asc = 'asc',
  Desc = 'desc'
}

export type Download = {
  __typename?: 'Download';
  expiresAt: Scalars['Datetime']['output'];
  signedUrl: Scalars['String']['output'];
};

export enum EmailContactTypeEnum {
  Personal = 'personal',
  Work = 'work'
}

export type EmailInput = {
  contactType: EmailContactTypeEnum;
  emailAddress: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  primary: Scalars['Boolean']['input'];
};

export type Employee = {
  __typename?: 'Employee';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type EmployeesPositionWhereInput = {
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EmployeesPositionsResult = {
  __typename?: 'EmployeesPositionsResult';
  company?: Maybe<Company>;
  coords?: Maybe<AddressCoords>;
  employee?: Maybe<Employee>;
  id: Scalars['Int']['output'];
};

export type Equipment = {
  __typename?: 'Equipment';
  archived: Scalars['Boolean']['output'];
  attachments?: Maybe<Array<Maybe<EquipmentAttachment>>>;
  createdAt: Scalars['Datetime']['output'];
  customFields?: Maybe<Array<Maybe<EquipmentCustomField>>>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  installedAt?: Maybe<Scalars['Date']['output']>;
  location: Location;
  locationEnvironment?: Maybe<LocationEnvironment>;
  locationSector?: Maybe<LocationSector>;
  logs: Array<EquipmentLog>;
  maintenances?: Maybe<Array<Maybe<Maintenance>>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  purchasedAt?: Maybe<Scalars['Date']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  type: EquipmentType;
  updatedAt: Scalars['Datetime']['output'];
  warranties: Array<Warranty>;
  warrantySummary?: Maybe<WarrantySummary>;
};

export type EquipmentAttachment = {
  __typename?: 'EquipmentAttachment';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  equipmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type EquipmentAttachmentInput = {
  equipmentId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EquipmentCustomField = {
  __typename?: 'EquipmentCustomField';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type EquipmentCustomFieldInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EquipmentLog = {
  __typename?: 'EquipmentLog';
  clientApplicationName?: Maybe<Scalars['String']['output']>;
  clientIpAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  snapshot: EquipmentSnapshot;
  updatedBy?: Maybe<User>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export enum EquipmentOrderByInput {
  CompanyNameAsc = 'companyName_asc',
  CompanyNameDesc = 'companyName_desc',
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  LocationNameAsc = 'locationName_asc',
  LocationNameDesc = 'locationName_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  NumberAsc = 'number_asc',
  NumberDesc = 'number_desc',
  TypeNameAsc = 'typeName_asc',
  TypeNameDesc = 'typeName_desc',
  WarrantyEndDateAsc = 'warrantyEndDate_asc',
  WarrantyEndDateDesc = 'warrantyEndDate_desc',
  WarrantyStartDateAsc = 'warrantyStartDate_asc',
  WarrantyStartDateDesc = 'warrantyStartDate_desc',
  WarrantyStatusAsc = 'warrantyStatus_asc',
  WarrantyStatusDesc = 'warrantyStatus_desc'
}

export type EquipmentPagedResult = {
  __typename?: 'EquipmentPagedResult';
  items: Array<Equipment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EquipmentSnapshot = {
  __typename?: 'EquipmentSnapshot';
  archived: Scalars['Boolean']['output'];
  attachments?: Maybe<Array<EquipmentAttachment>>;
  customFields?: Maybe<Array<EquipmentCustomField>>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  installedAt?: Maybe<Scalars['Date']['output']>;
  location: Location;
  locationEnvironment?: Maybe<LocationEnvironment>;
  locationSector?: Maybe<LocationSector>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  purchasedAt?: Maybe<Scalars['Date']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  type: EquipmentType;
};

export type EquipmentType = {
  __typename?: 'EquipmentType';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  customFields: Array<EquipmentTypeCustomField>;
  equipmentTypeForms: Array<EquipmentTypeForm>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preferences?: Maybe<EquipmentTypePreferences>;
  segment: Segment;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export type EquipmentTypeCustomField = {
  __typename?: 'EquipmentTypeCustomField';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options: Array<CustomFieldOption>;
  position: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  type?: Maybe<CustomFieldType>;
};

export type EquipmentTypeCustomFieldInput = {
  name: Scalars['String']['input'];
  options: Array<CustomFieldOptionInput>;
  required: Scalars['Boolean']['input'];
  type?: InputMaybe<CustomFieldType>;
};

export type EquipmentTypeForm = {
  __typename?: 'EquipmentTypeForm';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  form: Form;
  id: Scalars['ID']['output'];
  maintenanceType?: Maybe<MaintenanceType>;
  requiredComplete: Scalars['Boolean']['output'];
  requiredReport: Scalars['Boolean']['output'];
};

export type EquipmentTypeFormInput = {
  formId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  maintenanceTypeId?: InputMaybe<Scalars['ID']['input']>;
  requiredComplete: Scalars['Boolean']['input'];
  requiredReport: Scalars['Boolean']['input'];
};

export type EquipmentTypeInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  customFields?: InputMaybe<Array<EquipmentTypeCustomFieldInput>>;
  equipmentTypeForms?: InputMaybe<Array<EquipmentTypeFormInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<EquipmentTypePreferencesInput>;
  segmentId?: InputMaybe<Scalars['ID']['input']>;
};

export enum EquipmentTypeOrderByInput {
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type EquipmentTypePagedResult = {
  __typename?: 'EquipmentTypePagedResult';
  items: Array<EquipmentType>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EquipmentTypePreferences = {
  __typename?: 'EquipmentTypePreferences';
  featureAutoApproveEquipments?: Maybe<Scalars['Boolean']['output']>;
};

export type EquipmentTypePreferencesInput = {
  featureAutoApproveEquipments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EquipmentTypeWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EquipmentWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  equipmentTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasLocationEnvironment?: InputMaybe<Scalars['Boolean']['input']>;
  hasLocationSector?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationEnvironmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationSectorId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_or_number_contains?: InputMaybe<Scalars['String']['input']>;
  name_or_number_or_sector_or_environment_contains?: InputMaybe<Scalars['String']['input']>;
  number_contains?: InputMaybe<Scalars['String']['input']>;
  number_eq?: InputMaybe<Scalars['String']['input']>;
  qrCode_contains?: InputMaybe<Scalars['String']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  warrantyEndDateGte?: InputMaybe<Scalars['Date']['input']>;
  warrantyStartDateLte?: InputMaybe<Scalars['Date']['input']>;
  warrantyStatusIn?: InputMaybe<Array<InputMaybe<WarrantyStatus>>>;
};

export enum EquipmentWithOutOrderByInput {
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type EquipmentWithOutWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  numberEq?: InputMaybe<Scalars['String']['input']>;
  qrCodeEq?: InputMaybe<Scalars['String']['input']>;
};

export type Expense = {
  __typename?: 'Expense';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxValue?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  receiptRequired?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export enum ExpenseOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type ExpensePagedResult = {
  __typename?: 'ExpensePagedResult';
  items: Array<Expense>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExpenseWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEquals?: InputMaybe<Scalars['String']['input']>;
};

export type Export = {
  __typename?: 'Export';
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  download?: Maybe<Download>;
  expiredAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  messageId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Datetime']['output']>;
  status: ExportStatusEnum;
  timezone: Scalars['String']['output'];
  type: ExportTypeEnum;
  updatedAt: Scalars['Datetime']['output'];
  wheres?: Maybe<Scalars['JSON']['output']>;
};

export type ExportEquipmentsResult = {
  __typename?: 'ExportEquipmentsResult';
  code?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExportGroupsResult = {
  __typename?: 'ExportGroupsResult';
  code?: Maybe<Scalars['String']['output']>;
};

export type ExportLocationsResult = {
  __typename?: 'ExportLocationsResult';
  code?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExportPagedResult = {
  __typename?: 'ExportPagedResult';
  items: Array<Export>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExportProductServiceResult = {
  __typename?: 'ExportProductServiceResult';
  code?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExportQuotationsResult = {
  __typename?: 'ExportQuotationsResult';
  code?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExportRecurrencesResult = {
  __typename?: 'ExportRecurrencesResult';
  code?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ExportStatusEnum {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'inProgress',
  Pending = 'pending'
}

export enum ExportTypeEnum {
  Companies = 'companies',
  Equipments = 'equipments',
  FormAnswers = 'formAnswers',
  Groups = 'groups',
  Locations = 'locations',
  Maintenances = 'maintenances',
  MaintenancesImr = 'maintenancesImr',
  Payments = 'payments',
  Pendencies = 'pendencies',
  Products = 'products',
  ProductsServices = 'productsServices',
  ProductsServicesTopCompanies = 'productsServicesTopCompanies',
  ProductsTypes = 'productsTypes',
  Quotations = 'quotations',
  Recurrences = 'recurrences',
  Services = 'services',
  Storages = 'storages',
  StoragesMovements = 'storagesMovements',
  StoragesProducts = 'storagesProducts',
  StoragesProductsExternal = 'storagesProductsExternal',
  Users = 'users'
}

export type ExportUsersResult = {
  __typename?: 'ExportUsersResult';
  code?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ExportsOrderByInput {
  CompletedAtAsc = 'completedAt_asc',
  CompletedAtDesc = 'completedAt_desc',
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc'
}

export type ExportsWhereInput = {
  completedAtGte?: InputMaybe<Scalars['Datetime']['input']>;
  completedAtLte?: InputMaybe<Scalars['Datetime']['input']>;
  createdAtGte?: InputMaybe<Scalars['Datetime']['input']>;
  createdAtLte?: InputMaybe<Scalars['Datetime']['input']>;
  statusIn?: InputMaybe<Array<ExportStatusEnum>>;
  typeIn?: InputMaybe<Array<ExportTypeEnum>>;
};

export type ExternalProduct = {
  __typename?: 'ExternalProduct';
  archived: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  measure?: Maybe<ProductServiceMeasure>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  productType?: Maybe<ExternalProductType>;
  qrCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type ExternalProductPagedResult = {
  __typename?: 'ExternalProductPagedResult';
  items: Array<ExternalProduct>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalProductType = {
  __typename?: 'ExternalProductType';
  archived: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type ExternalStorage = {
  __typename?: 'ExternalStorage';
  archived: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<ExternalStorageEmployee>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  storageProduct?: Maybe<StorageProduct>;
};

export type ExternalStorageEmployee = {
  __typename?: 'ExternalStorageEmployee';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ExternalStorageMovement = {
  __typename?: 'ExternalStorageMovement';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  oldQuantity: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
};

export type ExternalStoragePagedResult = {
  __typename?: 'ExternalStoragePagedResult';
  items: Array<ExternalStorage>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalStorageProduct = {
  __typename?: 'ExternalStorageProduct';
  company?: Maybe<Company>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  minimalQuantity?: Maybe<Scalars['Float']['output']>;
  minimalQuantityAtRisk?: Maybe<Scalars['Float']['output']>;
  product: ExternalProduct;
  quantity: Scalars['Float']['output'];
  status?: Maybe<StorageProductStatus>;
  storage: ExternalStorage;
};

export type ExternalStorageProductPagedResult = {
  __typename?: 'ExternalStorageProductPagedResult';
  items: Array<ExternalStorageProduct>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalStorageProductV2WhereInput = {
  fsmAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  productCodeContains?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productMeasureIn?: InputMaybe<Array<ProductServiceMeasure>>;
  productNameContains?: InputMaybe<Scalars['String']['input']>;
  productNameOrCodeContains?: InputMaybe<Scalars['String']['input']>;
  sammathnaurProductId?: InputMaybe<Scalars['ID']['input']>;
  statusIn?: InputMaybe<Array<StorageProductStatus>>;
  storageId?: InputMaybe<Scalars['ID']['input']>;
  storageNameContains?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalStorageProductWhereInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  storageId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ExternalStorageProductsOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  QuantityAsc = 'quantity_asc',
  QuantityDesc = 'quantity_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  TotalValueAsc = 'totalValue_asc',
  TotalValueDesc = 'totalValue_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type ExternalStorageWhereInput = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export enum ExternalStoragesOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type ExternalStoragesWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  hasLinkedEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<AccountFeatureFlagTranslations>;
  enableForNewAccount: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum FeatureFlagLevel {
  Global = 'global',
  User = 'user'
}

export type Filter = {
  __typename?: 'Filter';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: FiltersTypeEnum;
  value?: Maybe<Scalars['String']['output']>;
};

export enum FiltersTypeEnum {
  Maintenances = 'maintenances'
}

export type FiltersWhereInput = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  type: FiltersTypeEnum;
};

export type Form = {
  __typename?: 'Form';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  logs: Array<FormLog>;
  name: Scalars['String']['output'];
  questions: Array<Question>;
  questionsCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export type FormAnswer = {
  __typename?: 'FormAnswer';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  equipment?: Maybe<Equipment>;
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  questionAnswers?: Maybe<Array<QuestionAnswer>>;
  status?: Maybe<FormAnswerStatusEnum>;
  tag?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export enum FormAnswerStatusEnum {
  Done = 'done',
  Pending = 'pending'
}

export type FormAnswersExportResult = {
  __typename?: 'FormAnswersExportResult';
  code?: Maybe<Scalars['String']['output']>;
};

export type FormInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  questions: Array<QuestionInput>;
};

export type FormLog = {
  __typename?: 'FormLog';
  clientApplicationName?: Maybe<Scalars['String']['output']>;
  clientIpAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  snapshot: FormSnapshot;
  updatedBy?: Maybe<User>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export enum FormOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  QuestionsCountAsc = 'questionsCount_asc',
  QuestionsCountDesc = 'questionsCount_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type FormPagedResult = {
  __typename?: 'FormPagedResult';
  items: Array<Maybe<Form>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FormSnapshot = {
  __typename?: 'FormSnapshot';
  archived: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  questions: Array<FormSnapshotQuestion>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export type FormSnapshotCondition = {
  __typename?: 'FormSnapshotCondition';
  operator?: Maybe<OperatorEnum>;
  question?: Maybe<QuestionReference>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FormSnapshotOption = {
  __typename?: 'FormSnapshotOption';
  id?: Maybe<Scalars['ID']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FormSnapshotQuestion = {
  __typename?: 'FormSnapshotQuestion';
  conditions?: Maybe<Array<Maybe<FormSnapshotCondition>>>;
  id?: Maybe<Scalars['ID']['output']>;
  options?: Maybe<Array<Maybe<FormSnapshotOption>>>;
  position?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<QuestionTypeEnum>;
};

export type FormWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type FormsPreferences = {
  __typename?: 'FormsPreferences';
  featureFormsWithScoredOptions?: Maybe<Scalars['Boolean']['output']>;
  questionOptionsLimit?: Maybe<Scalars['Int']['output']>;
  questionsLimit?: Maybe<Scalars['Int']['output']>;
};

export type FormsPreferencesInput = {
  featureFormsWithScoredOptions: Scalars['Boolean']['input'];
};

export type GenerateMaintenanceNumberInput = {
  corporateAccountUuid: Scalars['String']['input'];
};

export type GenerateTicketNumberInput = {
  corporateAccountUuid: Scalars['String']['input'];
};

export type Group = {
  __typename?: 'Group';
  archived?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  default: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationsConnection: LocationPagedResult;
  locked: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<Permission>;
  segmentsConnection: SegmentPagedResult;
  type?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};


export type GroupLocationsConnectionArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<LocationOrderByObjectInput>;
  where?: InputMaybe<LocationWhereInput>;
};


export type GroupSegmentsConnectionArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<SegmentOrderByInput>;
  where?: InputMaybe<SegmentWhereInput>;
};

export type GroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['ID']['input']>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type GroupLocation = {
  __typename?: 'GroupLocation';
  group: Group;
  location: Location;
};

export enum GroupOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type GroupPagedResult = {
  __typename?: 'GroupPagedResult';
  items: Array<Group>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupSegment = {
  __typename?: 'GroupSegment';
  group: Group;
  segment: Segment;
};

export type GroupWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameOrDescription_contains?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_or_description_contains?: InputMaybe<Scalars['String']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Guest = {
  __typename?: 'Guest';
  documentNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<GuestLocation>;
  locations: Array<Location>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type GuestAddressInput = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  coords: AddressCoordsInput;
  name: Scalars['String']['input'];
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type GuestLocation = {
  __typename?: 'GuestLocation';
  address?: Maybe<Address>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<User>;
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export enum GuestOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  LastLoginAtAsc = 'lastLoginAt_asc',
  LastLoginAtDesc = 'lastLoginAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type GuestWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  mfaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameOrEmailContains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UserWhereType>;
};

export type Import = {
  __typename?: 'Import';
  bucketName: Scalars['String']['output'];
  createRowsCount: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  deleteRowsCount: Scalars['Int']['output'];
  download?: Maybe<Download>;
  fileKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invalidRowsCount: Scalars['Int']['output'];
  language?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<ImportNote>;
  processedRowsCount: Scalars['Int']['output'];
  status: ImportStatus;
  totalRowsCount: Scalars['Int']['output'];
  type: ImportType;
  updateRowsCount: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: User;
  validRowsCount: Scalars['Int']['output'];
};

export type ImportNote = {
  __typename?: 'ImportNote';
  errors?: Maybe<Array<ImportNoteDetail>>;
  warnings?: Maybe<Array<ImportNoteDetail>>;
};

export type ImportNoteDetail = {
  __typename?: 'ImportNoteDetail';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSON']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum ImportOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc'
}

export type ImportPagedResult = {
  __typename?: 'ImportPagedResult';
  items: Array<Import>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ImportStatus {
  ImportError = 'import_error',
  ImportInProgress = 'import_in_progress',
  ImportPartialSuccess = 'import_partial_success',
  ImportQueued = 'import_queued',
  ImportSuccess = 'import_success',
  ValidationError = 'validation_error',
  ValidationInProgress = 'validation_in_progress',
  ValidationPending = 'validation_pending',
  ValidationQueued = 'validation_queued',
  ValidationSuccess = 'validation_success'
}

export enum ImportType {
  ArchiveMaintenance = 'archive_maintenance',
  ArchiveRecurrence = 'archive_recurrence',
  CancelMaintenance = 'cancel_maintenance',
  Environment = 'environment',
  Equipment = 'equipment',
  Group = 'group',
  Location = 'location',
  LocationServiceProvider = 'location_service_provider',
  Maintenance = 'maintenance',
  Product = 'product',
  ProductService = 'product_service',
  ProductType = 'product_type',
  Recurrence = 'recurrence',
  Sector = 'sector',
  Service = 'service',
  Storage = 'storage',
  StorageMovement = 'storage_movement',
  StorageProduct = 'storage_product',
  User = 'user',
  Warranty = 'warranty'
}

export type ImportWhereInput = {
  status_in?: InputMaybe<Array<ImportStatus>>;
  type_in?: InputMaybe<Array<ImportType>>;
};

export type IntegrationPreferences = {
  __typename?: 'IntegrationPreferences';
  lockMaintenanceAfterCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationPreferencesInput = {
  lockMaintenanceAfterCompleted: Scalars['Boolean']['input'];
};

export enum IntervalInput {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly'
}

export type Invite = {
  __typename?: 'Invite';
  acceptedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  email: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  refusedAt?: Maybe<Scalars['Datetime']['output']>;
  sendEmailResult: Array<Maybe<Scalars['JSON']['output']>>;
  sentAt?: Maybe<Scalars['Datetime']['output']>;
  status: InviteStatus;
};

export enum InviteStatus {
  Accepted = 'accepted',
  Expired = 'expired',
  Pending = 'pending',
  Refused = 'refused'
}

export type InvitesWhereInput = {
  email_contains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InviteStatus>;
};

export type Journey = {
  __typename?: 'Journey';
  account_id: Scalars['ID']['output'];
  form_answers: Array<JourneyAnswer>;
  form_submitted_by: User;
  id: Scalars['ID']['output'];
  overallProgress?: Maybe<Scalars['Int']['output']>;
  status: JourneyStatusEnum;
  steps?: Maybe<JourneySteps>;
};

export type JourneyAccountRules = {
  __typename?: 'JourneyAccountRules';
  permissionGroups?: Maybe<Scalars['Boolean']['output']>;
  users?: Maybe<Scalars['Boolean']['output']>;
};

export type JourneyAnswer = {
  __typename?: 'JourneyAnswer';
  optionKey: Scalars['String']['output'];
  questionKey: JourneyQuestionKeyEnum;
};

export type JourneyAnswerInput = {
  optionKey: Scalars['String']['input'];
  questionKey: JourneyQuestionKeyEnum;
};

export type JourneyCostResource = {
  __typename?: 'JourneyCostResource';
  expenses?: Maybe<Scalars['Boolean']['output']>;
  services?: Maybe<Scalars['Boolean']['output']>;
};

export type JourneyFormQuestion = {
  __typename?: 'JourneyFormQuestion';
  key: JourneyQuestionKeyEnum;
  metadata: Scalars['JSON']['output'];
  options: Array<JourneyFormQuestionOption>;
  position: Scalars['Int']['output'];
  translations: Array<JourneyQuestionTranslation>;
};

export type JourneyFormQuestionOption = {
  __typename?: 'JourneyFormQuestionOption';
  is_recommended: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  translations: Array<JourneyQuestionOptionTranslation>;
};

export type JourneyOperationsStructure = {
  __typename?: 'JourneyOperationsStructure';
  equipment?: Maybe<Scalars['Boolean']['output']>;
  equipmentTypes?: Maybe<Scalars['Boolean']['output']>;
};

export enum JourneyQuestionKeyEnum {
  Contracts = 'contracts',
  Deadlines = 'deadlines',
  Equipments = 'equipments',
  Expenses = 'expenses',
  Services = 'services',
  Stock = 'stock',
  Warranties = 'warranties'
}

export type JourneyQuestionOptionTranslation = {
  __typename?: 'JourneyQuestionOptionTranslation';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  locale: LocaleEnum;
};

export type JourneyQuestionTranslation = {
  __typename?: 'JourneyQuestionTranslation';
  description: Scalars['String']['output'];
  locale: LocaleEnum;
  title: Scalars['String']['output'];
};

export type JourneyRules = {
  __typename?: 'JourneyRules';
  contracts?: Maybe<Scalars['Boolean']['output']>;
  deadlines?: Maybe<Scalars['Boolean']['output']>;
  warranties?: Maybe<Scalars['Boolean']['output']>;
};

export type JourneyStandardization = {
  __typename?: 'JourneyStandardization';
  form?: Maybe<Scalars['Boolean']['output']>;
};

export enum JourneyStatusEnum {
  Completed = 'completed',
  InProgress = 'in_progress'
}

export type JourneyStepConfiguration = {
  __typename?: 'JourneyStepConfiguration';
  accountRules?: Maybe<JourneyAccountRules>;
  progress: Scalars['Float']['output'];
};

export type JourneyStepEssential = {
  __typename?: 'JourneyStepEssential';
  companies?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Scalars['Boolean']['output']>;
  maintenanceType?: Maybe<Scalars['Boolean']['output']>;
  progress: Scalars['Float']['output'];
  segments?: Maybe<Scalars['Boolean']['output']>;
};

export type JourneyStepOperation = {
  __typename?: 'JourneyStepOperation';
  costResource?: Maybe<JourneyCostResource>;
  operationsStructure?: Maybe<JourneyOperationsStructure>;
  progress: Scalars['Float']['output'];
  rules?: Maybe<JourneyRules>;
  standardization?: Maybe<JourneyStandardization>;
  stockControl?: Maybe<JourneyStockControl>;
};

export type JourneySteps = {
  __typename?: 'JourneySteps';
  configuration: JourneyStepConfiguration;
  essential: JourneyStepEssential;
  operation: JourneyStepOperation;
};

export type JourneyStockControl = {
  __typename?: 'JourneyStockControl';
  products?: Maybe<Scalars['Boolean']['output']>;
  storageMovements?: Maybe<Scalars['Boolean']['output']>;
  storageProducts?: Maybe<Scalars['Boolean']['output']>;
};

export type Label = {
  __typename?: 'Label';
  archived: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: LabelTypeEnum;
};

export type LabelInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LabelTypeEnum>;
};

export enum LabelOrderByField {
  CreatedAt = 'createdAt',
  Name = 'name'
}

export type LabelOrderByInput = {
  column: LabelOrderByField;
  direction: Direction;
  operator?: InputMaybe<Operator>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LabelPagedResult = {
  __typename?: 'LabelPagedResult';
  items: Array<Label>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum LabelTypeEnum {
  Maintenance = 'maintenance',
  Quotation = 'quotation'
}

export type LabelWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LabelTypeEnum>;
};

export type LastMaintenanceCompletedByEmployeeInput = {
  employeeUuid: Scalars['ID']['input'];
};

export type LinkAllLocationsToGroupInput = {
  groupId: Scalars['ID']['input'];
};

export type LinkAllUsersToGroupInput = {
  groupId: Scalars['ID']['input'];
};

export type LinkEquipmentToLocationSectorAndEnvironmentInput = {
  items: Array<LinkEquipmentToLocationSectorAndEnvironmentItem>;
};

export type LinkEquipmentToLocationSectorAndEnvironmentItem = {
  equipmentId: Scalars['ID']['input'];
  locationEnvironmentId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['ID']['input'];
  locationSectorId?: InputMaybe<Scalars['ID']['input']>;
};

export type LinkGuestAccountInput = {
  slug: Scalars['String']['input'];
};

export enum LocaleEnum {
  En = 'en',
  Es = 'es',
  Pt = 'pt'
}

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Address>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  contact?: Maybe<LocationContact>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<User>;
  default?: Maybe<Scalars['Boolean']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  equipments: Array<Equipment>;
  group?: Maybe<LocationGroup>;
  groupsConnection: GroupPagedResult;
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  maintenances: Array<Maintenance>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  sectors: Array<LocationSector>;
  segments?: Maybe<Array<Maybe<Segment>>>;
  serviceProviders: Array<LocationServiceProvider>;
  serviceProvidersConnection: ServiceProviderPagedResult;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};


export type LocationGroupsConnectionArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<GroupOrderByInput>;
  where?: InputMaybe<GroupWhereInput>;
};


export type LocationServiceProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
};


export type LocationServiceProvidersConnectionArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<ServiceProviderOrderByEnum>;
  where?: InputMaybe<ServiceProviderWhereInput>;
};

export type LocationContact = {
  __typename?: 'LocationContact';
  emails: Array<ContactEmail>;
  phones: Array<ContactPhone>;
};

export type LocationContactInput = {
  emails?: InputMaybe<Array<EmailInput>>;
  phones?: InputMaybe<Array<PhoneInput>>;
};

export type LocationCursorPagedResult = {
  __typename?: 'LocationCursorPagedResult';
  items: Array<Location>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationEnvironment = {
  __typename?: 'LocationEnvironment';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  equipments?: Maybe<Array<Equipment>>;
  id: Scalars['ID']['output'];
  locationSector: LocationSector;
  maintenances: LocationEnvironmentMaintenancesPagedResult;
  name: Scalars['String']['output'];
  qrCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<User>;
};


export type LocationEnvironmentMaintenancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationEnvironmentMaintenancesPagedResult = {
  __typename?: 'LocationEnvironmentMaintenancesPagedResult';
  items: Array<Maintenance>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum LocationEnvironmentOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type LocationEnvironmentWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationSectorId?: InputMaybe<Scalars['ID']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  qrCodeEq?: InputMaybe<Scalars['String']['input']>;
};

export type LocationEnvironmentsPagedResult = {
  __typename?: 'LocationEnvironmentsPagedResult';
  items: Array<LocationEnvironment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationGroup = {
  __typename?: 'LocationGroup';
  archived?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LocationGroupInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export enum LocationGroupOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type LocationGroupPagedResult = {
  __typename?: 'LocationGroupPagedResult';
  items: Array<LocationGroup>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationGroupWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
};

export enum LocationIncludeInput {
  Companies = 'companies',
  LocationEnvironments = 'locationEnvironments',
  LocationSectors = 'locationSectors',
  Locations = 'locations'
}

export type LocationInput = {
  address: AddressInput;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<LocationContactInput>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceProviders?: InputMaybe<Array<LocationServiceProviderInput>>;
};

export enum LocationOrderByField {
  Coords = 'coords',
  CreatedAt = 'createdAt',
  FormattedAddress = 'formattedAddress',
  Name = 'name',
  StreetName = 'streetName'
}

export type LocationOrderByObjectInput = {
  column: LocationOrderByField;
  direction: Direction;
  operator?: InputMaybe<Operator>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LocationPagedResult = {
  __typename?: 'LocationPagedResult';
  items: Array<Location>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationSector = {
  __typename?: 'LocationSector';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  equipmentsWithoutEnvironment?: Maybe<Array<Equipment>>;
  id: Scalars['ID']['output'];
  location: Location;
  locationEnvironments: Array<LocationEnvironment>;
  maintenances: LocationSectorMaintenancesPagedResult;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<User>;
};


export type LocationSectorMaintenancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationSectorMaintenancesPagedResult = {
  __typename?: 'LocationSectorMaintenancesPagedResult';
  items: Array<Maintenance>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum LocationSectorOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type LocationSectorWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  nameOrEnvironmentNameContains?: InputMaybe<Scalars['String']['input']>;
};

export type LocationSectorsPagedResult = {
  __typename?: 'LocationSectorsPagedResult';
  items: Array<LocationSector>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationServiceProvider = {
  __typename?: 'LocationServiceProvider';
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  deadlineContract?: Maybe<DeadlineContract>;
  id: Scalars['ID']['output'];
  maintenancesTypes: Array<MaintenanceType>;
  segment: Segment;
};

export type LocationServiceProviderInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  deadlineContractId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maintenanceTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentId: Scalars['ID']['input'];
};

export type LocationWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentNumber_contains?: InputMaybe<Scalars['String']['input']>;
  formattedAddressOrDocumentNumber_contains?: InputMaybe<Scalars['String']['input']>;
  formatted_address_similar?: InputMaybe<Scalars['String']['input']>;
  groupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
};

export enum LocationsByCursorOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc'
}

export type LocationsByCursorWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  sectorEnvironmentEquipmentNameOrNumberContains?: InputMaybe<Scalars['String']['input']>;
  warrantyEndDateGte?: InputMaybe<Scalars['Date']['input']>;
  warrantyStartDateLte?: InputMaybe<Scalars['Date']['input']>;
  warrantyStatusIn?: InputMaybe<Array<WarrantyStatus>>;
};

export type LocationsPermissionsInput = {
  groupsId: Array<Scalars['ID']['input']>;
  segmentId: Scalars['ID']['input'];
};

export type LoginCustomization = {
  __typename?: 'LoginCustomization';
  accountId?: Maybe<Scalars['ID']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  allowGuests?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<LoginCustomizationColor>;
  description?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  openIdConfigurationEndpoint?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type LoginCustomizationColor = {
  __typename?: 'LoginCustomizationColor';
  background?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  foreground?: Maybe<Scalars['String']['output']>;
};

export type LoginCustomizationInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  color: ColorInput;
  description?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  openIdConfigurationEndpoint?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type Maintenance = {
  __typename?: 'Maintenance';
  address?: Maybe<MaintenanceAddress>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  assignee?: Maybe<User>;
  attachments: Array<Attachment>;
  closedAt?: Maybe<Scalars['Datetime']['output']>;
  comments: Array<Comment>;
  company?: Maybe<Company>;
  companyScheduleSuggestion?: Maybe<ScheduleDatetime>;
  contract?: Maybe<Contract>;
  deadlineAt?: Maybe<Scalars['Datetime']['output']>;
  deadlineContract?: Maybe<MaintenanceDeadlineContract>;
  deadlineType?: Maybe<MaintenanceDeadlineType>;
  durationInMinutes?: Maybe<Scalars['Int']['output']>;
  equipments: Array<Equipment>;
  firstVisitDeadlineAt?: Maybe<Scalars['Datetime']['output']>;
  firstVisitStartedAt?: Maybe<Scalars['Datetime']['output']>;
  formAnswers: Array<FormAnswer>;
  forms?: Maybe<Array<Form>>;
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  location?: Maybe<Location>;
  locationEnvironments: Array<LocationEnvironment>;
  locationSectors: Array<LocationSector>;
  logs: Array<MaintenanceLog>;
  logsConnection: MaintenanceLogConnectionResult;
  maintenanceType?: Maybe<MaintenanceType>;
  message?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['Datetime']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  payment?: Maybe<Payment>;
  /**  @deprecated Use tasksConnection instead  */
  pendencies: PendenciesPagedResult;
  previousMaintenance?: Maybe<Maintenance>;
  problem?: Maybe<Problem>;
  productsServices: MaintenanceProductServicePagedResult;
  productsTotalValue?: Maybe<Scalars['Float']['output']>;
  quotations: Array<Quotation>;
  rating?: Maybe<Rating>;
  ratingAverage?: Maybe<Scalars['Float']['output']>;
  reopenedAt?: Maybe<Scalars['Datetime']['output']>;
  requester?: Maybe<User>;
  responseDeadlineStatus?: Maybe<MaintenanceDeadlineStatus>;
  scheduleSuggestions?: Maybe<Array<ScheduleDatetime>>;
  scheduleSuggestionsStatus?: Maybe<MaintenanceScheduleSuggestionStatus>;
  scheduled?: Maybe<ScheduleDatetime>;
  segment: Segment;
  servicesTotalValue?: Maybe<Scalars['Float']['output']>;
  soUrl?: Maybe<Scalars['String']['output']>;
  solutionDeadlineStatus?: Maybe<MaintenanceDeadlineStatus>;
  status: MaintenanceStatus;
  statusDescription?: Maybe<Scalars['String']['output']>;
  /**  @deprecated Use logsConnection instead  */
  tasks: Array<Task>;
  tasksConnection: TaskConnectionResult;
  ticket?: Maybe<Ticket>;
  totalValue?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
  visitCount?: Maybe<Scalars['Int']['output']>;
  warranties: Array<Warranty>;
  warrantyStatus?: Maybe<WarrantyMaintenanceStatus>;
  warrantySummary?: Maybe<WarrantySummary>;
  weight: Scalars['Int']['output'];
};


export type MaintenanceCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  where?: InputMaybe<MaintenanceCommentWhereInput>;
};


export type MaintenanceEquipmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
};


export type MaintenanceLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
};


export type MaintenanceLogsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type MaintenancePendenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type MaintenanceProductsServicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MaintenanceProductServiceOrderByInput>;
  where?: InputMaybe<MaintenanceProductServiceWhereInput>;
};


export type MaintenanceTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
};


export type MaintenanceTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type MaintenanceAddress = {
  __typename?: 'MaintenanceAddress';
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  coords: AddressCoords;
  neighborhood: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type MaintenanceAddressInput = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  coords: AddressCoordsInput;
  neighborhood: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type MaintenanceAttachmentCreateInput = {
  maintenanceId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MaintenanceAttachmentType>;
};

export type MaintenanceAttachmentInput = {
  path: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum MaintenanceAttachmentType {
  Integration = 'integration',
  Request = 'request'
}

export type MaintenanceCommentWhereInput = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  authorType?: InputMaybe<CommentPostedByTypeEnum>;
  type?: InputMaybe<CommentTypeEnum>;
};

export type MaintenanceCreateInput = {
  address?: InputMaybe<MaintenanceAddressInput>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<MaintenanceAttachmentInput>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  deadlineContractId?: InputMaybe<Scalars['ID']['input']>;
  equipmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  forms?: InputMaybe<Array<CreateFormAnswerInput>>;
  locationEnvironmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId: Scalars['ID']['input'];
  locationSectorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  previousMaintenanceId?: InputMaybe<Scalars['ID']['input']>;
  problemId?: InputMaybe<Scalars['ID']['input']>;
  productsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  productsServices?: InputMaybe<Array<MaintenanceProductServiceInput>>;
  scheduleSuggestions?: InputMaybe<Array<MaintenanceScheduleSuggestionInput>>;
  segmentId: Scalars['ID']['input'];
  servicesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<MaintenanceStatus>;
  typeId: Scalars['ID']['input'];
  warranties?: InputMaybe<Array<InputMaybe<CreateWarrantyInput>>>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type MaintenanceDeadlineContract = {
  __typename?: 'MaintenanceDeadlineContract';
  considerHoliday: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  customInterval?: Maybe<DeadlineContractInterval>;
  deadlineStartedAt?: Maybe<Scalars['Datetime']['output']>;
  hasCustomInterval: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originalContract: DeadlineContract;
  responseDeadline: DeadlineContractResponseSolution;
  responseDeadlineViolationReason?: Maybe<DeadlineContractViolationReason>;
  responseRisk: DeadlineContractResponseSolution;
  solutionDeadline: DeadlineContractResponseSolution;
  solutionDeadlineViolationReason?: Maybe<DeadlineContractViolationReason>;
  solutionRisk: DeadlineContractResponseSolution;
};

export enum MaintenanceDeadlineContractViolationReasonLinkedBy {
  Company = 'company',
  Enterprise = 'enterprise'
}

export enum MaintenanceDeadlineStatus {
  AtRisk = 'atRisk',
  CompletedOnTime = 'completedOnTime',
  CompletedWithViolation = 'completedWithViolation',
  NotApplied = 'notApplied',
  Violated = 'violated',
  WithinDeadline = 'withinDeadline'
}

export enum MaintenanceDeadlineStatusInput {
  AtRisk = 'atRisk',
  CompletedOnTime = 'completedOnTime',
  CompletedWithViolation = 'completedWithViolation',
  NotApplied = 'notApplied',
  Violated = 'violated',
  WithinDeadline = 'withinDeadline'
}

export enum MaintenanceDeadlineType {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export type MaintenanceDeadlineViolationReasonsInput = {
  responseDeadlineViolationReasonId?: InputMaybe<Scalars['ID']['input']>;
  solutionDeadlineViolationReasonId?: InputMaybe<Scalars['ID']['input']>;
};

export type MaintenanceExportResult = {
  __typename?: 'MaintenanceExportResult';
  code?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MaintenanceImrWhereInput = {
  yearAndMonth?: InputMaybe<Scalars['String']['input']>;
};

export type MaintenanceItem = {
  __typename?: 'MaintenanceItem';
  date?: Maybe<Scalars['Date']['output']>;
  total: Scalars['Int']['output'];
};

export type MaintenanceLabelCreateInput = {
  labelId: Scalars['ID']['input'];
  maintenanceId: Scalars['ID']['input'];
};

export type MaintenanceLog = {
  __typename?: 'MaintenanceLog';
  address?: Maybe<MaintenanceAddress>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  assignee?: Maybe<User>;
  clientApplicationName?: Maybe<Scalars['String']['output']>;
  clientIpAddress?: Maybe<Scalars['String']['output']>;
  clientSource?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Datetime']['output']>;
  company?: Maybe<Company>;
  companyScheduleSuggestion?: Maybe<ScheduleDatetime>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  deadlineAt?: Maybe<Scalars['Datetime']['output']>;
  deadlineType?: Maybe<MaintenanceDeadlineType>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  maintenanceType?: Maybe<MaintenanceType>;
  message?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['Datetime']['output']>;
  rating?: Maybe<Rating>;
  relocationReason?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<User>;
  scheduleSuggestions?: Maybe<Array<ScheduleDatetime>>;
  scheduleSuggestionsStatus?: Maybe<MaintenanceScheduleSuggestionStatus>;
  scheduled?: Maybe<ScheduleDatetime>;
  segment: Segment;
  status: MaintenanceStatus;
  statusDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<UserSnapshot>;
  visitCount?: Maybe<Scalars['Int']['output']>;
  weight: Scalars['Int']['output'];
};

export type MaintenanceLogConnectionResult = {
  __typename?: 'MaintenanceLogConnectionResult';
  items: Array<MaintenanceLog>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum MaintenanceNumberGeneratorEnum {
  None = 'none',
  Sequential = 'sequential'
}

export type MaintenanceNumberResult = {
  __typename?: 'MaintenanceNumberResult';
  number: Scalars['String']['output'];
};

export enum MaintenanceOrderByInput {
  ClosedAtAsc = 'closedAt_asc',
  ClosedAtDesc = 'closedAt_desc',
  CnpjAsc = 'cnpj_asc',
  CnpjDesc = 'cnpj_desc',
  CompanyAsc = 'company_asc',
  CompanyDesc = 'company_desc',
  LocationAsc = 'location_asc',
  LocationDesc = 'location_desc',
  NumberAsc = 'number_asc',
  NumberDesc = 'number_desc',
  OpenedAtAsc = 'openedAt_asc',
  OpenedAtDesc = 'openedAt_desc',
  PaymentNumberAsc = 'paymentNumber_asc',
  PaymentNumberDesc = 'paymentNumber_desc',
  RequesterAsc = 'requester_asc',
  RequesterDesc = 'requester_desc',
  ScheduledAtAsc = 'scheduledAt_asc',
  ScheduledAtDesc = 'scheduledAt_desc',
  ScheduledTimeAsc = 'scheduledTime_asc',
  ScheduledTimeDesc = 'scheduledTime_desc',
  SegmentAsc = 'segment_asc',
  SegmentDesc = 'segment_desc',
  StarsAsc = 'stars_asc',
  StarsDesc = 'stars_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  TotalValueAsc = 'totalValue_asc',
  TotalValueDesc = 'totalValue_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc',
  VisitCountAsc = 'visitCount_asc',
  VisitCountDesc = 'visitCount_desc',
  WarrantyStatusAsc = 'warrantyStatus_asc',
  WarrantyStatusDesc = 'warrantyStatus_desc'
}

export type MaintenancePagedResult = {
  __typename?: 'MaintenancePagedResult';
  archived?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Maintenance>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MaintenanceProductService = {
  __typename?: 'MaintenanceProductService';
  item: ProductService;
  quantity: Scalars['Float']['output'];
  storage?: Maybe<MaintenanceProductStorage>;
  totalValue: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type MaintenanceProductServiceInput = {
  productServiceId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
  value: Scalars['Float']['input'];
};

export enum MaintenanceProductServiceOrderByInput {
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type MaintenanceProductServicePagedResult = {
  __typename?: 'MaintenanceProductServicePagedResult';
  items: Array<MaintenanceProductService>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalValue: Scalars['Float']['output'];
};

export type MaintenanceProductServiceWhereInput = {
  name_contains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductServiceType>;
};

export type MaintenanceProductStorage = {
  __typename?: 'MaintenanceProductStorage';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MaintenanceScheduleSuggestionInput = {
  date: Scalars['Date']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
};

export enum MaintenanceScheduleSuggestionStatus {
  CorporateAccepted = 'corporateAccepted',
  CorporateRefused = 'corporateRefused',
  CorporateSuggested = 'corporateSuggested',
  StandardSuggested = 'standardSuggested',
  SuggestionStopped = 'suggestionStopped'
}

export type MaintenanceScheduleVolumeItem = {
  __typename?: 'MaintenanceScheduleVolumeItem';
  afternoon: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  evening: Scalars['Int']['output'];
  morning: Scalars['Int']['output'];
  noTime: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum MaintenanceStatus {
  Canceled = 'canceled',
  Done = 'done',
  InProgress = 'inProgress',
  New = 'new',
  OnNegotiation = 'onNegotiation',
  Pending = 'pending',
  Reported = 'reported',
  Requested = 'requested',
  Scheduled = 'scheduled'
}

export type MaintenanceType = {
  __typename?: 'MaintenanceType';
  archived: Scalars['Boolean']['output'];
  availableOnApp: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  maintenanceTypeSegmentForms: Array<Maybe<MaintenanceTypeSegmentForm>>;
  mobileStartCompleteTaskValidationRadiusMeters?: Maybe<Scalars['Float']['output']>;
  mobileStartCompleteTaskValidationRadiusOn: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ratingForm?: Maybe<Form>;
  sendEmailEmployeeRouteTrackingLinkWhenOnRoute: Scalars['Boolean']['output'];
  sendEmailOrderReportLinkWhenCompleted: Scalars['Boolean']['output'];
  sendEmailTaskRatingLinkWhenCompleted: Scalars['Boolean']['output'];
  signatureRequired: Scalars['Boolean']['output'];
  ticketForm?: Maybe<Form>;
  type: MaintenanceTypeEnum;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export enum MaintenanceTypeEnum {
  CorrectiveMaintenance = 'correctiveMaintenance',
  CustomMaintenance = 'customMaintenance',
  PreventiveMaintenance = 'preventiveMaintenance'
}

export enum MaintenanceTypeOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type MaintenanceTypePagedResult = {
  __typename?: 'MaintenanceTypePagedResult';
  items: Array<MaintenanceType>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MaintenanceTypeSegmentForm = {
  __typename?: 'MaintenanceTypeSegmentForm';
  createdAt: Scalars['Datetime']['output'];
  form: Form;
  id: Scalars['ID']['output'];
  requiredComplete: Scalars['Boolean']['output'];
  requiredReport: Scalars['Boolean']['output'];
  requiredStart: Scalars['Boolean']['output'];
  segment: Segment;
};

export type MaintenanceTypeWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availableOnApp?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  segmentId?: InputMaybe<Scalars['ID']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<MaintenanceTypeEnum>>>;
};

export type MaintenanceUpdateInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  closedAt?: InputMaybe<Scalars['Datetime']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  deadlineContractId?: InputMaybe<Scalars['ID']['input']>;
  deadlineViolationReasons?: InputMaybe<MaintenanceDeadlineViolationReasonsInput>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  problemId?: InputMaybe<Scalars['ID']['input']>;
  productsServices?: InputMaybe<Array<MaintenanceProductServiceInput>>;
  scheduledAt?: InputMaybe<Scalars['Date']['input']>;
  scheduledTime?: InputMaybe<Scalars['String']['input']>;
  segmentId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<MaintenanceStatus>;
  statusDescription?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type MaintenanceWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigneeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  closedAt?: InputMaybe<DateRangeInput>;
  closedAt_gte?: InputMaybe<Scalars['Date']['input']>;
  closedAt_lte?: InputMaybe<Scalars['Date']['input']>;
  closedOnPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  closed_at_gte?: InputMaybe<Scalars['Date']['input']>;
  closed_at_lte?: InputMaybe<Scalars['Date']['input']>;
  companyDocumentNumber_contains?: InputMaybe<Scalars['String']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractIdentifier_contains?: InputMaybe<Scalars['String']['input']>;
  equipmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  equipmentNumberContains?: InputMaybe<Scalars['String']['input']>;
  firstVisitStartedOnPeriod?: InputMaybe<Scalars['Boolean']['input']>;
  formAnswer_contains?: InputMaybe<Scalars['String']['input']>;
  hasOrderId?: InputMaybe<Scalars['Boolean']['input']>;
  has_equipments?: InputMaybe<Scalars['Boolean']['input']>;
  has_products?: InputMaybe<Scalars['Boolean']['input']>;
  has_services?: InputMaybe<Scalars['Boolean']['input']>;
  labelId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationEnvironmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationSectorId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationsGroupsId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  message_contains?: InputMaybe<Scalars['String']['input']>;
  numberContains?: InputMaybe<Scalars['String']['input']>;
  numberOrSegmentOrMaintenanceTypeOrLocationContains?: InputMaybe<Scalars['String']['input']>;
  number_contains?: InputMaybe<Scalars['String']['input']>;
  openedAt?: InputMaybe<DateRangeInput>;
  openedAt_gte?: InputMaybe<Scalars['Date']['input']>;
  openedAt_lte?: InputMaybe<Scalars['Date']['input']>;
  opened_at_gte?: InputMaybe<Scalars['Date']['input']>;
  opened_at_lte?: InputMaybe<Scalars['Date']['input']>;
  paymentId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paymentNumber_contains?: InputMaybe<Scalars['String']['input']>;
  paymentStatus_in?: InputMaybe<Array<PaymentStatusEnum>>;
  pendenciesStatus_in?: InputMaybe<Array<PendencyStatus>>;
  pendenciesTreatmentStatus_in?: InputMaybe<Array<PendencyTreatmentStatus>>;
  pendenciesTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  problemId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  productId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  rating_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  requesterId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  responseDeadlineStatus_in?: InputMaybe<Array<MaintenanceDeadlineStatusInput>>;
  scheduledAt?: InputMaybe<DateRangeInput>;
  scheduledAt_gte?: InputMaybe<Scalars['Date']['input']>;
  scheduledAt_lte?: InputMaybe<Scalars['Date']['input']>;
  scheduled_at_gte?: InputMaybe<Scalars['Date']['input']>;
  scheduled_at_lte?: InputMaybe<Scalars['Date']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  serviceId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  solutionDeadlineStatus_in?: InputMaybe<Array<MaintenanceDeadlineStatusInput>>;
  statusIn?: InputMaybe<Array<MaintenanceStatus>>;
  status_in?: InputMaybe<Array<MaintenanceStatus>>;
  typeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  warrantyEndDateGte?: InputMaybe<Scalars['Date']['input']>;
  warrantyMaintenanceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  warrantyStartDateLte?: InputMaybe<Scalars['Date']['input']>;
  warrantyStatusIn?: InputMaybe<Array<InputMaybe<WarrantyStatus>>>;
};

export type MaintenancesPreferences = {
  __typename?: 'MaintenancesPreferences';
  showProductsTab?: Maybe<Scalars['Boolean']['output']>;
  showServicesTab?: Maybe<Scalars['Boolean']['output']>;
};

export type MaintenancesPreferencesInput = {
  showProductsTab?: InputMaybe<Scalars['Boolean']['input']>;
  showServicesTab?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManageFeatureFlagsInput = {
  activate: Scalars['Boolean']['input'];
  featureFlags: Array<Scalars['String']['input']>;
  level?: InputMaybe<FeatureFlagLevel>;
};

export type MarkPaymentAsPaidInput = {
  attachmentsPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentId: Scalars['ID']['input'];
};

export type MoveCourseSectionContentInput = {
  nextSectionContentId?: InputMaybe<Scalars['ID']['input']>;
  previousSectionContentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveCourseSectionInput = {
  nextSectionId?: InputMaybe<Scalars['ID']['input']>;
  previousSectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MovementProductInput = {
  changedQuantity: Scalars['Float']['input'];
  productId: Scalars['ID']['input'];
};

export type MultipleQuestionAnswerStatistics = {
  __typename?: 'MultipleQuestionAnswerStatistics';
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AddUsersToGroups: Array<Maybe<UserGroup>>;
  acceptEquipment: Approval;
  acceptMaintenanceScheduleSuggestions: Maintenance;
  acceptTicket: Ticket;
  activeContract: Contract;
  addLocationToGroup: Array<Maybe<GroupLocation>>;
  addMaintenancesToPayment: Payment;
  addQuotationsToPayment: Payment;
  addSegmentToGroup: Array<Maybe<GroupSegment>>;
  approveQuotation: Quotation;
  archiveCompanyAndUnlinkServiceProvider: Company;
  archiveContract: Contract;
  archiveDeadlineContract: DeadlineContract;
  archiveDeadlineViolationReason: DeadlineViolationReason;
  archiveEquipment: Equipment;
  archiveEquipmentType: EquipmentType;
  archiveExpense: Expense;
  archiveGroup: Group;
  archiveLocation: Location;
  archiveLocationEnvironment: LocationEnvironment;
  archiveLocationSector: LocationSector;
  archiveMaintenance: Maintenance;
  archivePayment: Payment;
  archivePendency: Pendency;
  archivePendencyType: PendencyType;
  archiveProduct: Product;
  archiveProductCompany: ProductCompany;
  archiveProductType: ProductType;
  archiveService: Service;
  archiveStorage: Storage;
  archiveTicket: Ticket;
  archiveTickets: Array<Ticket>;
  archiveUser: User;
  archiveWarrantyTemplate: WarrantyTemplate;
  cancelContract: Contract;
  cancelMaintenance: Maintenance;
  cancelMaintenanceScheduleSuggestions: Maintenance;
  completeContent: CourseSectionContentProgress;
  completeJourney: Journey;
  concludePendency: Pendency;
  createApiKey?: Maybe<CreateApiKeyResult>;
  createContract: Contract;
  createContractAttachment: ContractAttachment;
  createCourse: Course;
  createCourseSection: CourseSection;
  createCourseSectionContent: CourseSectionContent;
  createCourseSectionContentFile: CourseSectionContentFile;
  createCoursesCategory: CourseCategory;
  createCriteriasGroup: CriteriaGroup;
  createDeadlineContract: DeadlineContract;
  createDeadlineViolationReason: DeadlineViolationReason;
  createEquipment: Equipment;
  createEquipmentAttachment: EquipmentAttachment;
  createEquipmentType: EquipmentType;
  createExpense: Expense;
  createExport: Export;
  createFilter: Filter;
  createForm: Form;
  createGroup: Group;
  createGuest: User;
  createImport: Import;
  createInvite: CreateInviteResult;
  createLabel: Label;
  createLocation: Location;
  createLocationEnvironment: LocationEnvironment;
  createLocationGroup: LocationGroup;
  createLocationSector: LocationSector;
  createMaintenance: Maintenance;
  createMaintenanceAttachment: Attachment;
  createMaintenanceComment: Comment;
  createMaintenanceLabels: Array<Maybe<Label>>;
  createMaintenanceType: MaintenanceType;
  createPayment: Payment;
  createPendency: Pendency;
  createPendencyEventNote: PendencyEvent;
  createPendencyEventReply: PendencyEvent;
  createPendencyType: PendencyType;
  createProblem: Problem;
  createProduct: Product;
  createProductCompany: ProductCompany;
  createProductService: ProductService;
  createProductType: ProductType;
  createQuotationLabels: Array<Maybe<Label>>;
  createRecurrence: Recurrence;
  createSegment: Segment;
  createService: Service;
  createStorage: Storage;
  createStorageMovement: Array<StorageMovement>;
  createTicket: Ticket;
  createTicketAttachment: Attachment;
  createUser: User;
  createWarranty: Warranty;
  createWarrantyTemplate: WarrantyTemplate;
  deleteApiKey?: Maybe<ApiKey>;
  deleteContractAttachment: ContractAttachment;
  deleteCourseSectionContentFile: Scalars['Boolean']['output'];
  deleteCriteriasGroup: CriteriaGroup;
  deleteEquipmentAttachment: EquipmentAttachment;
  deletePendencyEventNote: PendencyEvent;
  deleteWebHook?: Maybe<WebHook>;
  /** @deprecated Use the 'createExport' mutation instead. */
  exportEquipments: ExportEquipmentsResult;
  exportFormAnswers: FormAnswersExportResult;
  exportGroups: ExportGroupsResult;
  exportLocations: ExportLocationsResult;
  exportMaintenances: MaintenanceExportResult;
  exportProductsServices: ExportProductServiceResult;
  exportProductsServicesTopCompanies: ProductsServicesTopCompaniesExportResult;
  exportQuotations: ExportQuotationsResult;
  exportRecurrences: ExportRecurrencesResult;
  exportUsers: ExportUsersResult;
  generateContractIdentifier: ContractIdentifierResult;
  generateMaintenanceNumber: MaintenanceNumberResult;
  generateUploadCredential: UploadCredential;
  linkAllLocationsToGroup: Group;
  linkAllUsersToGroup: Group;
  linkEquipmentToLocationSectorAndEnvironment: Array<Equipment>;
  linkGuestToAccount: User;
  manageFeatureFlags?: Maybe<Account>;
  markInviteAsAccepted: Invite;
  markInviteAsRefused: Invite;
  markPaymentAsPaid: Payment;
  moveCourseSection: CourseSection;
  moveCourseSectionContent: CourseSectionContent;
  pauseContract: Contract;
  putWebHook?: Maybe<WebHook>;
  reallocateMaintenance: Maintenance;
  refuseEquipment: Approval;
  rejectQuotation: Quotation;
  rejectTicket: Ticket;
  removeLabel: Label;
  removeLocationFromGroup: Array<Maybe<GroupLocation>>;
  removeMaintenanceComment: Comment;
  removeMaintenanceLabel?: Maybe<Label>;
  removeMaintenancesFromPayment: Payment;
  removeQuotationLabel: Label;
  removeQuotationsFromPayment: Payment;
  removeSegmentFromGroup: Array<Maybe<GroupSegment>>;
  removeUserFromGroup: Array<Maybe<UserGroup>>;
  removeWarranty: Warranty;
  reopenMaintenance: Maintenance;
  resendInvite: Invite;
  saveAccountPreferences?: Maybe<AccountPreferences>;
  setUserPassword: User;
  startContent: CourseSectionContentProgress;
  startImport: Import;
  startImportValidation: Import;
  status?: Maybe<Scalars['String']['output']>;
  submitJourneyForm: Journey;
  transferPendency: Pendency;
  unarchiveContract: Contract;
  unarchiveDeadlineContract: DeadlineContract;
  unarchiveDeadlineViolationReason: DeadlineViolationReason;
  unarchiveEquipment: Equipment;
  unarchiveEquipmentType: EquipmentType;
  unarchiveExpense: Expense;
  unarchiveGroup: Group;
  unarchiveLocation: Location;
  unarchiveLocationEnvironment: LocationEnvironment;
  unarchiveLocationSector: LocationSector;
  unarchiveMaintenance: Maintenance;
  unarchivePayment: Payment;
  unarchivePendency: Pendency;
  unarchivePendencyType: PendencyType;
  unarchiveProduct: Product;
  unarchiveProductCompany: ProductCompany;
  unarchiveProductType: ProductType;
  unarchiveService: Service;
  unarchiveStorage: Storage;
  unarchiveTicket: Ticket;
  unarchiveTickets: Array<Ticket>;
  unarchiveUser: User;
  unarchiveWarrantyTemplate: WarrantyTemplate;
  unpauseContract: Contract;
  updateApiKeyPermissions?: Maybe<ApiKey>;
  updateCompany: Company;
  updateContract: Contract;
  updateContractAttachmentTitle: ContractAttachment;
  updateCourse: Course;
  updateCourseSection: CourseSection;
  updateCourseSectionContent: CourseSectionContent;
  updateCoursesCategory?: Maybe<CourseCategory>;
  updateCriteriasGroup: CriteriaGroup;
  updateDeadlineContract: DeadlineContract;
  updateDeadlineViolationReason: DeadlineViolationReason;
  updateEquipment: Equipment;
  updateEquipmentAttachment: EquipmentAttachment;
  updateEquipmentType: EquipmentType;
  updateExpense: Expense;
  updateExternalStorageProduct: ExternalStorageProduct;
  updateForm: Form;
  updateGroup: Group;
  updateImportFile: Import;
  updateLabel: Label;
  updateLocation: Location;
  updateLocationEnvironment: LocationEnvironment;
  updateLocationGroup: LocationGroup;
  updateLocationSector: LocationSector;
  updateLoginCustomization?: Maybe<LoginCustomization>;
  updateMaintenance: Maintenance;
  updateMaintenanceScheduleSuggestions: Maintenance;
  updateMaintenanceType: MaintenanceType;
  updatePayment: Payment;
  updatePendency: Pendency;
  updatePendencyAssignee: Pendency;
  updatePendencyEventNote: PendencyEvent;
  updatePendencyType: PendencyType;
  updateProblem: Problem;
  updateProduct: Product;
  updateProductCompany: ProductCompany;
  updateProductService: ProductService;
  updateProductType: ProductType;
  updateRecurrence: Recurrence;
  updateSegment: Segment;
  updateService: Service;
  updateStorage: Storage;
  updateStorageMovement: StorageMovement;
  updateStorageProduct: StorageProduct;
  updateUser: User;
  updateWarranty: Warranty;
  updateWarrantyTemplate: WarrantyTemplate;
};


export type MutationAddUsersToGroupsArgs = {
  input: AddUsersToGroupsInput;
};


export type MutationAcceptEquipmentArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAcceptMaintenanceScheduleSuggestionsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActiveContractArgs = {
  input: ActiveContractInput;
};


export type MutationAddLocationToGroupArgs = {
  input: AddLocationToGroupInput;
};


export type MutationAddMaintenancesToPaymentArgs = {
  input: AddMaintenancesToPaymentInput;
};


export type MutationAddQuotationsToPaymentArgs = {
  input: AddQuotationsToPaymentInput;
};


export type MutationAddSegmentToGroupArgs = {
  input: AddSegmentToGroupInput;
};


export type MutationApproveQuotationArgs = {
  input: ApproveQuotationInput;
};


export type MutationArchiveCompanyAndUnlinkServiceProviderArgs = {
  companyId: Scalars['ID']['input'];
};


export type MutationArchiveContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveDeadlineContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveDeadlineViolationReasonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveEquipmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveEquipmentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveLocationEnvironmentArgs = {
  input: ArchiveLocationEnvironmentInput;
};


export type MutationArchiveLocationSectorArgs = {
  input: ArchiveLocationSectorInput;
};


export type MutationArchiveMaintenanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchivePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchivePendencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchivePendencyTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveProductCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveStorageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveTicketsArgs = {
  input: Array<Scalars['ID']['input']>;
};


export type MutationArchiveUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveWarrantyTemplateArgs = {
  input: ArchivedWarrantyTemplateInput;
};


export type MutationCancelContractArgs = {
  input: CancelContractInput;
};


export type MutationCancelMaintenanceArgs = {
  id: Scalars['ID']['input'];
  input: CancelMaintenanceInput;
};


export type MutationCancelMaintenanceScheduleSuggestionsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteContentArgs = {
  contentId: Scalars['ID']['input'];
};


export type MutationConcludePendencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateApiKeyArgs = {
  input?: InputMaybe<CreateApiKeyInput>;
};


export type MutationCreateContractArgs = {
  input: CreateContractInput;
};


export type MutationCreateContractAttachmentArgs = {
  input: ContractAttachmentCreateInput;
};


export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
};


export type MutationCreateCourseSectionArgs = {
  input: CreateCourseSectionInput;
};


export type MutationCreateCourseSectionContentArgs = {
  input: CreateCourseSectionContentInput;
};


export type MutationCreateCourseSectionContentFileArgs = {
  input: CreateCourseSectionContentFileInput;
};


export type MutationCreateCoursesCategoryArgs = {
  input: CreateCoursesCategoryInput;
};


export type MutationCreateCriteriasGroupArgs = {
  input: CriteriaGroupInput;
};


export type MutationCreateDeadlineContractArgs = {
  input: DeadlineContractInput;
};


export type MutationCreateDeadlineViolationReasonArgs = {
  input: CreateDeadlineViolationReasonInput;
};


export type MutationCreateEquipmentArgs = {
  input: CreateEquipmentInput;
};


export type MutationCreateEquipmentAttachmentArgs = {
  input: EquipmentAttachmentInput;
};


export type MutationCreateEquipmentTypeArgs = {
  input: EquipmentTypeInput;
};


export type MutationCreateExpenseArgs = {
  input: CreateExpenseInput;
};


export type MutationCreateExportArgs = {
  input: CreateExportInput;
};


export type MutationCreateFilterArgs = {
  input: CreateFilterInput;
};


export type MutationCreateFormArgs = {
  input: FormInput;
};


export type MutationCreateGroupArgs = {
  input: GroupInput;
};


export type MutationCreateGuestArgs = {
  input: CreateGuestInput;
};


export type MutationCreateImportArgs = {
  input: CreateImportInput;
};


export type MutationCreateInviteArgs = {
  input: CreateInviteInput;
};


export type MutationCreateLabelArgs = {
  input: LabelInput;
};


export type MutationCreateLocationArgs = {
  input: LocationInput;
};


export type MutationCreateLocationEnvironmentArgs = {
  input: CreateLocationEnvironmentInput;
};


export type MutationCreateLocationGroupArgs = {
  input: LocationGroupInput;
};


export type MutationCreateLocationSectorArgs = {
  input: CreateLocationSectorInput;
};


export type MutationCreateMaintenanceArgs = {
  input: MaintenanceCreateInput;
};


export type MutationCreateMaintenanceAttachmentArgs = {
  input: MaintenanceAttachmentCreateInput;
};


export type MutationCreateMaintenanceCommentArgs = {
  input: CommentInput;
};


export type MutationCreateMaintenanceLabelsArgs = {
  input: Array<InputMaybe<MaintenanceLabelCreateInput>>;
};


export type MutationCreateMaintenanceTypeArgs = {
  input: CreateMaintenanceTypeInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreatePendencyArgs = {
  input: CreatePendencyInput;
};


export type MutationCreatePendencyEventNoteArgs = {
  input: CreatePendencyEventNoteInput;
};


export type MutationCreatePendencyEventReplyArgs = {
  input: CreatePendencyEventReplyInput;
};


export type MutationCreatePendencyTypeArgs = {
  input: CreatePendencyTypeInput;
};


export type MutationCreateProblemArgs = {
  input: ProblemInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductCompanyArgs = {
  input: CreateProductCompanyInput;
};


export type MutationCreateProductServiceArgs = {
  input: ProductServiceInput;
};


export type MutationCreateProductTypeArgs = {
  input: CreateProductTypeInput;
};


export type MutationCreateQuotationLabelsArgs = {
  input: Array<InputMaybe<CreateQuotationLabelInput>>;
};


export type MutationCreateRecurrenceArgs = {
  input: RecurrenceCreateInput;
};


export type MutationCreateSegmentArgs = {
  input: SegmentInput;
};


export type MutationCreateServiceArgs = {
  input: CreateServiceInput;
};


export type MutationCreateStorageArgs = {
  input: CreateStorageInput;
};


export type MutationCreateStorageMovementArgs = {
  input: CreateStorageMovementInput;
};


export type MutationCreateTicketArgs = {
  input: TicketCreateInput;
};


export type MutationCreateTicketAttachmentArgs = {
  input: TicketAttachmentCreateInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCreateWarrantyArgs = {
  input: CreateWarrantyInput;
};


export type MutationCreateWarrantyTemplateArgs = {
  input: CreateWarrantyTemplateInput;
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCourseSectionContentFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCriteriasGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEquipmentAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePendencyEventNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWebHookArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportEquipmentsArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<EquipmentWhereInput>;
};


export type MutationExportFormAnswersArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  where: DashboardFormsAnswersDetailWhereInput;
};


export type MutationExportGroupsArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<GroupWhereInput>;
};


export type MutationExportLocationsArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type MutationExportMaintenancesArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  where: MaintenanceWhereInput;
};


export type MutationExportProductsServicesArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProductServiceWhereInput>;
};


export type MutationExportProductsServicesTopCompaniesArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  where: DashboardQuotationsWhereInput;
};


export type MutationExportQuotationsArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<QuotationWhereInput>;
};


export type MutationExportRecurrencesArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<RecurrenceWhereInput>;
};


export type MutationExportUsersArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type MutationGenerateMaintenanceNumberArgs = {
  input: GenerateMaintenanceNumberInput;
};


export type MutationGenerateUploadCredentialArgs = {
  input?: InputMaybe<UploadCredentialInput>;
};


export type MutationLinkAllLocationsToGroupArgs = {
  input: LinkAllLocationsToGroupInput;
};


export type MutationLinkAllUsersToGroupArgs = {
  input: LinkAllUsersToGroupInput;
};


export type MutationLinkEquipmentToLocationSectorAndEnvironmentArgs = {
  input: LinkEquipmentToLocationSectorAndEnvironmentInput;
};


export type MutationLinkGuestToAccountArgs = {
  input?: InputMaybe<LinkGuestAccountInput>;
};


export type MutationManageFeatureFlagsArgs = {
  input?: InputMaybe<ManageFeatureFlagsInput>;
};


export type MutationMarkInviteAsAcceptedArgs = {
  inviteToken: Scalars['String']['input'];
};


export type MutationMarkInviteAsRefusedArgs = {
  inviteToken: Scalars['String']['input'];
};


export type MutationMarkPaymentAsPaidArgs = {
  input: MarkPaymentAsPaidInput;
};


export type MutationMoveCourseSectionArgs = {
  id: Scalars['ID']['input'];
  input: MoveCourseSectionInput;
};


export type MutationMoveCourseSectionContentArgs = {
  id: Scalars['ID']['input'];
  input: MoveCourseSectionContentInput;
};


export type MutationPauseContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPutWebHookArgs = {
  input?: InputMaybe<PutWebHookInput>;
};


export type MutationReallocateMaintenanceArgs = {
  id: Scalars['ID']['input'];
  input: ReallocateMaintenanceInput;
};


export type MutationRefuseEquipmentArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectQuotationArgs = {
  input?: InputMaybe<RejectQuotationInput>;
};


export type MutationRejectTicketArgs = {
  input: TicketRejectInput;
};


export type MutationRemoveLabelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveLocationFromGroupArgs = {
  input: RemoveLocationFromGroupInput;
};


export type MutationRemoveMaintenanceCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveMaintenanceLabelArgs = {
  labelId: Scalars['ID']['input'];
  maintenanceId: Scalars['ID']['input'];
};


export type MutationRemoveMaintenancesFromPaymentArgs = {
  input: RemoveMaintenancesFromPaymentInput;
};


export type MutationRemoveQuotationLabelArgs = {
  input: RemoveQuotationLabelInput;
};


export type MutationRemoveQuotationsFromPaymentArgs = {
  input: RemoveQuotationsFromPaymentInput;
};


export type MutationRemoveSegmentFromGroupArgs = {
  input: RemoveSegmentFromGroupInput;
};


export type MutationRemoveUserFromGroupArgs = {
  input: RemoveUserFromGroupInput;
};


export type MutationRemoveWarrantyArgs = {
  input: RemoveWarrantyInput;
};


export type MutationReopenMaintenanceArgs = {
  id: Scalars['ID']['input'];
  input: ReopenMaintenanceInput;
};


export type MutationResendInviteArgs = {
  inviteId: Scalars['ID']['input'];
};


export type MutationSaveAccountPreferencesArgs = {
  input?: InputMaybe<AccountPreferencesInput>;
};


export type MutationSetUserPasswordArgs = {
  id: Scalars['ID']['input'];
  input: SetUserPasswordInput;
};


export type MutationStartContentArgs = {
  contentId: Scalars['ID']['input'];
};


export type MutationStartImportArgs = {
  input: StartImportInput;
};


export type MutationStartImportValidationArgs = {
  input: StartImportValidationInput;
};


export type MutationSubmitJourneyFormArgs = {
  input: SubmitJourneyFormInput;
};


export type MutationTransferPendencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveDeadlineContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveDeadlineViolationReasonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveEquipmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveEquipmentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveLocationEnvironmentArgs = {
  input: UnarchiveLocationEnvironmentInput;
};


export type MutationUnarchiveLocationSectorArgs = {
  input: UnarchiveLocationSectorInput;
};


export type MutationUnarchiveMaintenanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchivePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchivePendencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchivePendencyTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveProductCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveStorageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveTicketsArgs = {
  input: Array<Scalars['ID']['input']>;
};


export type MutationUnarchiveUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveWarrantyTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnpauseContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateApiKeyPermissionsArgs = {
  id: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['ID']['input'];
  input: CompanyInput;
};


export type MutationUpdateContractArgs = {
  input: UpdateContractInput;
};


export type MutationUpdateContractAttachmentTitleArgs = {
  input: ContractAttachmentUpdateInput;
};


export type MutationUpdateCourseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCourseInput;
};


export type MutationUpdateCourseSectionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCourseSectionInput;
};


export type MutationUpdateCourseSectionContentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCourseSectionContentInput;
};


export type MutationUpdateCoursesCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCoursesCategoryInput;
};


export type MutationUpdateCriteriasGroupArgs = {
  id: Scalars['ID']['input'];
  input: CriteriaGroupInput;
};


export type MutationUpdateDeadlineContractArgs = {
  id: Scalars['ID']['input'];
  input: DeadlineContractInput;
};


export type MutationUpdateDeadlineViolationReasonArgs = {
  input: UpdateDeadlineViolationReasonInput;
};


export type MutationUpdateEquipmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEquipmentInput;
};


export type MutationUpdateEquipmentAttachmentArgs = {
  id: Scalars['ID']['input'];
  input: EquipmentAttachmentInput;
};


export type MutationUpdateEquipmentTypeArgs = {
  id: Scalars['ID']['input'];
  input: EquipmentTypeInput;
};


export type MutationUpdateExpenseArgs = {
  input: UpdateExpenseInput;
};


export type MutationUpdateExternalStorageProductArgs = {
  input: UpdateExternalStorageProductInput;
};


export type MutationUpdateFormArgs = {
  id: Scalars['ID']['input'];
  input: FormInput;
};


export type MutationUpdateGroupArgs = {
  id: Scalars['ID']['input'];
  input: GroupInput;
};


export type MutationUpdateImportFileArgs = {
  input: UpdateImportFileInput;
};


export type MutationUpdateLabelArgs = {
  id: Scalars['ID']['input'];
  input: LabelInput;
};


export type MutationUpdateLocationArgs = {
  id: Scalars['ID']['input'];
  input: LocationInput;
};


export type MutationUpdateLocationEnvironmentArgs = {
  input: UpdateLocationEnvironmentInput;
};


export type MutationUpdateLocationGroupArgs = {
  id: Scalars['ID']['input'];
  input: LocationGroupInput;
};


export type MutationUpdateLocationSectorArgs = {
  input: UpdateLocationSectorInput;
};


export type MutationUpdateLoginCustomizationArgs = {
  input?: InputMaybe<LoginCustomizationInput>;
};


export type MutationUpdateMaintenanceArgs = {
  id: Scalars['ID']['input'];
  input: MaintenanceUpdateInput;
};


export type MutationUpdateMaintenanceScheduleSuggestionsArgs = {
  id: Scalars['ID']['input'];
  suggestions: Array<MaintenanceScheduleSuggestionInput>;
};


export type MutationUpdateMaintenanceTypeArgs = {
  input: UpdateMaintenanceTypeInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdatePendencyArgs = {
  input: UpdatePendencyInput;
};


export type MutationUpdatePendencyAssigneeArgs = {
  input: UpdatePendencyAssigneeInput;
};


export type MutationUpdatePendencyEventNoteArgs = {
  input: UpdatePendencyEventNoteInput;
};


export type MutationUpdatePendencyTypeArgs = {
  input: UpdatePendencyTypeInput;
};


export type MutationUpdateProblemArgs = {
  id: Scalars['ID']['input'];
  input: ProblemInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductCompanyArgs = {
  input: UpdateProductCompanyInput;
};


export type MutationUpdateProductServiceArgs = {
  id: Scalars['ID']['input'];
  input: ProductServiceInput;
};


export type MutationUpdateProductTypeArgs = {
  input: UpdateProductTypeInput;
};


export type MutationUpdateRecurrenceArgs = {
  id: Scalars['ID']['input'];
  input: RecurrenceUpdateInput;
};


export type MutationUpdateSegmentArgs = {
  id: Scalars['ID']['input'];
  input: SegmentInput;
};


export type MutationUpdateServiceArgs = {
  input: UpdateServiceInput;
};


export type MutationUpdateStorageArgs = {
  input: UpdateStorageInput;
};


export type MutationUpdateStorageMovementArgs = {
  input: UpdateStorageMovementInput;
};


export type MutationUpdateStorageProductArgs = {
  input: UpdateStorageProductInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UserInput>;
};


export type MutationUpdateWarrantyArgs = {
  input: UpdateWarrantyInput;
};


export type MutationUpdateWarrantyTemplateArgs = {
  input: UpdateWarrantyTemplateInput;
};

export type NextMaintenanceScheduledByEmployee = {
  employeeUuid: Scalars['ID']['input'];
};

export type NextPaymentNumberResult = {
  __typename?: 'NextPaymentNumberResult';
  number: Scalars['String']['output'];
};

export type NextProductCodeResult = {
  __typename?: 'NextProductCodeResult';
  code: Scalars['String']['output'];
};

export type Occurrence = {
  __typename?: 'Occurrence';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  iteration: Scalars['Int']['output'];
  maintenance?: Maybe<Maintenance>;
  scheduledAt?: Maybe<Scalars['Datetime']['output']>;
  scheduledDate: Scalars['Date']['output'];
  scheduledType?: Maybe<IntervalInput>;
};

export enum OccurrenceOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  IterationAsc = 'iteration_asc',
  IterationDesc = 'iteration_desc',
  ScheduledAtAsc = 'scheduledAt_asc',
  ScheduledAtDesc = 'scheduledAt_desc',
  ScheduledDateAsc = 'scheduledDate_asc',
  ScheduledDateDesc = 'scheduledDate_desc'
}

export type OccurrencePagedResult = {
  __typename?: 'OccurrencePagedResult';
  items: Array<Occurrence>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OccurrenceWhereInput = {
  recurrenceId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OpenMaintenancePreferences = {
  __typename?: 'OpenMaintenancePreferences';
  featureCancelMaintenanceOnApp?: Maybe<Scalars['Boolean']['output']>;
  featureDisableOpenMaintenanceOnApp?: Maybe<Scalars['Boolean']['output']>;
  featureDisableOpenMaintenanceOnPanel?: Maybe<Scalars['Boolean']['output']>;
  featureProblemRequired?: Maybe<Scalars['Boolean']['output']>;
  maintenanceNumberGenerator?: Maybe<MaintenanceNumberGeneratorEnum>;
};

export type OpenMaintenancePreferencesInput = {
  featureCancelMaintenanceOnApp: Scalars['Boolean']['input'];
  featureDisableOpenMaintenanceOnApp: Scalars['Boolean']['input'];
  featureDisableOpenMaintenanceOnPanel: Scalars['Boolean']['input'];
  featureProblemRequired: Scalars['Boolean']['input'];
  maintenanceNumberGenerator: MaintenanceNumberGeneratorEnum;
};

export type OpenQuestionAnswerStatistics = {
  __typename?: 'OpenQuestionAnswerStatistics';
  value?: Maybe<Scalars['String']['output']>;
};

export enum Operator {
  Distance = 'distance'
}

export enum OperatorEnum {
  Equal = 'equal',
  NotEqual = 'notEqual'
}

export type Option = {
  __typename?: 'Option';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OtherPreferences = {
  __typename?: 'OtherPreferences';
  featureLocationsPermissionsEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type PartialCourseSectionContent = {
  __typename?: 'PartialCourseSectionContent';
  archived: Scalars['Boolean']['output'];
  contentLength: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  draft: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mainFile: CourseSectionContentFile;
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  progress?: Maybe<CourseSectionContentProgress>;
};

export type Payment = {
  __typename?: 'Payment';
  archived: Scalars['Boolean']['output'];
  attachments: Array<PaymentAttachment>;
  company: Company;
  createdAt: Scalars['Datetime']['output'];
  createdBy: PaymentUser;
  createdBySystem: PaymentSystemEnum;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maintenancesConnection?: Maybe<MaintenancePagedResult>;
  number: Scalars['String']['output'];
  quotationsConnection?: Maybe<QuotationPagedResult>;
  status: PaymentStatusEnum;
  totalValue: Scalars['Float']['output'];
  treatmentAt?: Maybe<Scalars['Datetime']['output']>;
  treatmentBy?: Maybe<PaymentUser>;
  type: PaymentTypeEnum;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: PaymentUser;
};


export type PaymentMaintenancesConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MaintenanceOrderByInput>;
  where?: InputMaybe<MaintenanceWhereInput>;
};


export type PaymentQuotationsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<QuotationOrderByInput>;
  where?: InputMaybe<QuotationWhereInput>;
};

export type PaymentAttachment = {
  __typename?: 'PaymentAttachment';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export enum PaymentIncludeInput {
  Maintenances = 'maintenances'
}

export type PaymentLog = {
  __typename?: 'PaymentLog';
  autor: PaymentUser;
  clientApplicationName: PaymentLogClientApplicationNameEnum;
  createdAt: Scalars['Datetime']['output'];
  data?: Maybe<PaymentLogData>;
  id: Scalars['ID']['output'];
  payment: Payment;
  type: PaymentLogTypeEnum;
};

export enum PaymentLogClientApplicationNameEnum {
  Mordor = 'mordor',
  Mountdoom = 'mountdoom'
}

export type PaymentLogData = {
  __typename?: 'PaymentLogData';
  cancellationReason?: Maybe<Scalars['String']['output']>;
};

export enum PaymentLogOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc'
}

export enum PaymentLogTypeEnum {
  Approved = 'approved',
  Archived = 'archived',
  Created = 'created',
  Paid = 'paid',
  Rejected = 'rejected',
  Unarchived = 'unarchived'
}

export type PaymentLogWhereInput = {
  paymentId: Scalars['ID']['input'];
};

export type PaymentLogsPagedResult = {
  __typename?: 'PaymentLogsPagedResult';
  items: Array<PaymentLog>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum PaymentOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NumberAsc = 'number_asc',
  NumberDesc = 'number_desc'
}

export type PaymentPagedResult = {
  __typename?: 'PaymentPagedResult';
  items: Array<Payment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum PaymentStatusEnum {
  Approved = 'approved',
  Paid = 'paid',
  Pending = 'pending',
  Rejected = 'rejected'
}

export enum PaymentSystemEnum {
  Cmms = 'cmms',
  Fsm = 'fsm'
}

export enum PaymentTypeEnum {
  Maintenance = 'maintenance',
  Quotation = 'quotation'
}

export type PaymentUser = {
  __typename?: 'PaymentUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: PaymentUserTypeEnum;
};

export enum PaymentUserTypeEnum {
  EyeofsauronUser = 'eyeofsauron_user',
  SammathnaurUser = 'sammathnaur_user'
}

export type PaymentWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateRangeInput>;
  createdBySystemIn?: InputMaybe<Array<PaymentSystemEnum>>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  numberContains?: InputMaybe<Scalars['String']['input']>;
  numberEq?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<PaymentStatusEnum>>;
};

export type PendenciesEventsPagedResult = {
  __typename?: 'PendenciesEventsPagedResult';
  items: Array<PendencyEvent>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum PendenciesOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type PendenciesPagedResult = {
  __typename?: 'PendenciesPagedResult';
  items: Array<Pendency>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PendenciesWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAtGte?: InputMaybe<Scalars['Datetime']['input']>;
  createdAtLte?: InputMaybe<Scalars['Datetime']['input']>;
  identifierContains?: InputMaybe<Scalars['String']['input']>;
  maintenanceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pendencyTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statusIn?: InputMaybe<Array<PendencyStatus>>;
  titleOrDescriptionContains?: InputMaybe<Scalars['String']['input']>;
  treatmentStatusIn?: InputMaybe<Array<PendencyTreatmentStatus>>;
  treatmentTypeIn?: InputMaybe<Array<PendencyTreatmentType>>;
};

export type Pendency = {
  __typename?: 'Pendency';
  archived: Scalars['Boolean']['output'];
  /** @deprecated Use 'assignees' field instead. This field will be removed in a future version. */
  assignee?: Maybe<User>;
  assignees: Array<User>;
  company?: Maybe<Company>;
  createdAt: Scalars['Datetime']['output'];
  createdBy: PendencyChangedBy;
  description?: Maybe<Scalars['String']['output']>;
  events: PendenciesEventsPagedResult;
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  maintenance?: Maybe<Maintenance>;
  pendencyType: PendencyType;
  readers: Array<User>;
  status: PendencyStatus;
  title: Scalars['String']['output'];
  treatmentStatus: PendencyTreatmentStatus;
  treatmentType: PendencyTreatmentType;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<PendencyChangedBy>;
};


export type PendencyEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PendencyEventWhereInput>;
};

export type PendencyChangedBy = {
  __typename?: 'PendencyChangedBy';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type PendencyContent = PendencyEventLog | PendencyEventNote | PendencyEventReply;

export type PendencyEvent = {
  __typename?: 'PendencyEvent';
  content?: Maybe<PendencyContent>;
  createdAt: Scalars['Datetime']['output'];
  createdBy: PendencyEventUser;
  id: Scalars['ID']['output'];
  pendency: Pendency;
  type: PendencyEventType;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<PendencyEventUser>;
};

export type PendencyEventAttachmentInput = {
  bucketName?: InputMaybe<Scalars['String']['input']>;
  fileKey?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type PendencyEventLog = {
  __typename?: 'PendencyEventLog';
  changes?: Maybe<Array<PendencyEventLogChanges>>;
  type: PendencyEventLogType;
};

export type PendencyEventLogChanges = {
  __typename?: 'PendencyEventLogChanges';
  column: PendencyEventLogChangesColumn;
  newValue?: Maybe<PendencyEventLogChangesColumnValue>;
  oldValue?: Maybe<PendencyEventLogChangesColumnValue>;
};

export enum PendencyEventLogChangesColumn {
  AssigneeId = 'assigneeId',
  CompanyId = 'companyId',
  Description = 'description',
  MaintenanceId = 'maintenanceId',
  PendencyTypeId = 'pendencyTypeId',
  Title = 'title',
  TreatmentStatus = 'treatmentStatus',
  TreatmentType = 'treatmentType'
}

export type PendencyEventLogChangesColumnValue = Company | Maintenance | PendencyType | ScalarStringWrapper | User;

export enum PendencyEventLogType {
  PendencyArchived = 'pendencyArchived',
  PendencyCreated = 'pendencyCreated',
  PendencyFinished = 'pendencyFinished',
  PendencyFinishedByRelocation = 'pendencyFinishedByRelocation',
  PendencyUnarchived = 'pendencyUnarchived',
  PendencyUpdated = 'pendencyUpdated'
}

export type PendencyEventNote = {
  __typename?: 'PendencyEventNote';
  message: Scalars['String']['output'];
};

export type PendencyEventReply = {
  __typename?: 'PendencyEventReply';
  attachments?: Maybe<Array<PendencyEventReplyAttachment>>;
  message: Scalars['String']['output'];
};

export type PendencyEventReplyAttachment = {
  __typename?: 'PendencyEventReplyAttachment';
  bucketName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  download?: Maybe<Download>;
  fileKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum PendencyEventType {
  Log = 'log',
  Note = 'note',
  Reply = 'reply'
}

export type PendencyEventUser = {
  __typename?: 'PendencyEventUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  type: PendencyEventUserType;
};

export enum PendencyEventUserType {
  Company = 'company',
  Enterprise = 'enterprise'
}

export type PendencyEventWhereInput = {
  typeIn?: InputMaybe<Array<PendencyEventType>>;
};

export enum PendencyStatus {
  Done = 'done',
  Opened = 'opened'
}

export enum PendencyTreatmentStatus {
  Company = 'company',
  Enterprise = 'enterprise'
}

export enum PendencyTreatmentType {
  External = 'external',
  Internal = 'internal'
}

export type PendencyType = {
  __typename?: 'PendencyType';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: User;
};

export enum PendencyTypeOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type PendencyTypePagedResult = {
  __typename?: 'PendencyTypePagedResult';
  items: Array<PendencyType>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PendencyTypeWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
};

export type Permission = {
  __typename?: 'Permission';
  category: Scalars['String']['output'];
  featureFlag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  translation?: Maybe<PermissionsTranslations>;
  visible: Scalars['Boolean']['output'];
};

export enum PermissionOrderByInput {
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type PermissionTranslation = {
  __typename?: 'PermissionTranslation';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PermissionsCategory = {
  __typename?: 'PermissionsCategory';
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<Permission>;
  translation?: Maybe<PermissionsTranslations>;
};

export type PermissionsTranslations = {
  __typename?: 'PermissionsTranslations';
  en?: Maybe<PermissionTranslation>;
  es?: Maybe<PermissionTranslation>;
  pt?: Maybe<PermissionTranslation>;
};

export enum PhoneContactTypeEnum {
  Cell = 'cell',
  Home = 'home',
  Work = 'work'
}

export type PhoneInput = {
  contactType: PhoneContactTypeEnum;
  name?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  primary: Scalars['Boolean']['input'];
};

export type Problem = {
  __typename?: 'Problem';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maintenancesTypes: Array<MaintenanceType>;
  name: Scalars['String']['output'];
  segments: Array<Segment>;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<User>;
};

export type ProblemInput = {
  archived: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  maintenanceTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ProblemOrderByField {
  CreatedAt = 'createdAt',
  Name = 'name'
}

export type ProblemOrderByInput = {
  column: ProblemOrderByField;
  direction: Direction;
  operator?: InputMaybe<Operator>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProblemPagedResult = {
  __typename?: 'ProblemPagedResult';
  items: Array<Problem>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProblemWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_similar?: InputMaybe<Scalars['String']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Product = {
  __typename?: 'Product';
  archived: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<ProductCompany>>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  measure?: Maybe<ProductServiceMeasure>;
  name: Scalars['String']['output'];
  productCompany?: Maybe<ProductCompany>;
  productType?: Maybe<ProductType>;
  qrCode?: Maybe<Scalars['String']['output']>;
  storages: StorageProductPagedResult;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};


export type ProductProductCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type ProductStoragesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
};

export type ProductCompany = {
  __typename?: 'ProductCompany';
  archived: Scalars['Boolean']['output'];
  company: Company;
  fieldProductServiceId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  preferences?: Maybe<ProductServiceCompanyPreferences>;
  product: Product;
  value: Scalars['Float']['output'];
  valueType: ProductServiceValueType;
};

export type ProductPagedResult = {
  __typename?: 'ProductPagedResult';
  items: Array<Product>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductService = {
  __typename?: 'ProductService';
  archived: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  measure?: Maybe<ProductServiceMeasure>;
  name: Scalars['String']['output'];
  productServiceCompanies: Array<ProductServiceCompany>;
  type: ProductServiceType;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
  value: Scalars['Float']['output'];
};

export type ProductServiceCompany = {
  __typename?: 'ProductServiceCompany';
  archived: Scalars['Boolean']['output'];
  company: Company;
  id: Scalars['ID']['output'];
  preferences?: Maybe<ProductServiceCompanyPreferences>;
  value: Scalars['Float']['output'];
  valueType: ProductServiceValueType;
};

export type ProductServiceCompanyInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  preferences?: InputMaybe<ProductServiceCompanyPreferencesInput>;
  value: Scalars['Float']['input'];
  valueType?: InputMaybe<ProductServiceValueType>;
};

export type ProductServiceCompanyPreferences = {
  __typename?: 'ProductServiceCompanyPreferences';
  allowEditValue?: Maybe<Scalars['Boolean']['output']>;
  weekDayValues?: Maybe<WeekDayValuesType>;
};

export type ProductServiceCompanyPreferencesInput = {
  allowEditValue?: InputMaybe<Scalars['Boolean']['input']>;
  weekDayValues?: InputMaybe<WeekDayValuesInput>;
};

export type ProductServiceInput = {
  archived: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  measure?: InputMaybe<ProductServiceMeasure>;
  name: Scalars['String']['input'];
  productServiceCompanies: Array<ProductServiceCompanyInput>;
  type: ProductServiceType;
};

export enum ProductServiceMeasure {
  Centimeters = 'centimeters',
  Cjt = 'cjt',
  CubicMeters = 'cubic_meters',
  Dislocation = 'dislocation',
  Gram = 'gram',
  Kilogram = 'kilogram',
  Liters = 'liters',
  Meters = 'meters',
  Milliliters = 'milliliters',
  Others = 'others',
  SquareMeters = 'square_meters',
  TonsRefrigeration = 'tons_refrigeration',
  Units = 'units'
}

export enum ProductServiceOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type ProductServicePagedResult = {
  __typename?: 'ProductServicePagedResult';
  items: Array<ProductService>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ProductServiceType {
  Product = 'product',
  Service = 'service'
}

export enum ProductServiceValueType {
  Fixed = 'fixed',
  Hour = 'hour',
  Kilometer = 'kilometer'
}

export type ProductServiceWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  productsIds_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  type_in?: InputMaybe<Array<ProductServiceType>>;
};

export enum ProductStorageOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  QuantityAsc = 'quantity_asc',
  QuantityDesc = 'quantity_desc'
}

export type ProductType = {
  __typename?: 'ProductType';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<User>;
};

export enum ProductTypeOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type ProductTypePagedResult = {
  __typename?: 'ProductTypePagedResult';
  items: Array<ProductType>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductTypeWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductsOrderByInput {
  CodeAsc = 'code_asc',
  CodeDesc = 'code_desc',
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type ProductsServicesTopCompaniesExportResult = {
  __typename?: 'ProductsServicesTopCompaniesExportResult';
  code?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductsServicesTotalValues = {
  __typename?: 'ProductsServicesTotalValues';
  productsTotalValue: Scalars['Float']['output'];
  servicesTotalValue: Scalars['Float']['output'];
};

export type ProductsWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  codeContains?: InputMaybe<Scalars['String']['input']>;
  codeEq?: InputMaybe<Scalars['String']['input']>;
  companyIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  measureIn?: InputMaybe<Array<ProductServiceMeasure>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  typeIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PutWebHookInput = {
  authentication: WebHookAuthenticationInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  messageTypes?: InputMaybe<Array<WebHookMessageType>>;
  url: Scalars['String']['input'];
};

export type PwaPreferences = {
  __typename?: 'PwaPreferences';
  allowGuests?: Maybe<Scalars['Boolean']['output']>;
};

export type PwaPreferencesInput = {
  allowGuests?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  accountFormsAnswers: DashboardFormsAnswersResult;
  accountFormsAnswersDetail: DashboardFormsAnswersDetailResult;
  accountMaintenancesAverageDeadlines: DashboardMaintenancesAverageDeadlinesResult;
  accountMaintenancesCompletedBySources: DashboardResult;
  accountMaintenancesCompletedLineChart: DashboardMaintenancesCompletedTimelineResult;
  accountMaintenancesCompletedTimeline: DashboardMaintenancesCompletedTimelineResult;
  accountMaintenancesDeadlinesByDay: DashboardMaintenancesDeadlinesByDayResult;
  accountMaintenancesPendingTimeInterval: DashboardResult;
  accountMaintenancesSegments: DashboardResult;
  accountMaintenancesStatistics: DashboardResult;
  accountMaintenancesStatus: DashboardResult;
  accountMaintenancesStatusInterval: DashboardResult;
  accountMaintenancesTopPendingTime: DashboardResult;
  accountMaintenancesTypes: DashboardResult;
  accountMaintenancesVolumeCount: DashboardResult;
  accountPreferences?: Maybe<AccountPreferences>;
  accountProductsByStorage: DashboardProductsByStorageResult;
  accountQuotationsApprovalAverageAndPercentage: QuotationsAverageAndPercentageResult;
  accountQuotationsApprovedTopTotal: DashboardResult;
  accountQuotationsByStatus: DashboardResult;
  accountQuotationsPendingTimeInterval: DashboardResult;
  accountQuotationsTopCompanyByProductService: QuotationsTopCompanyByProductServiceResult;
  accountQuotationsTotalAndQuantityByProductService: QuotationsTotalAndQuantityByProductServiceResult;
  accountQuotationsTotalByItemType: QuotationsTotalByItemsTypeResult;
  accountQuotationsTotalByStatus: DashboardResult;
  accountRatingsAverageByTimeline: DashboardRatingsAverageTimelineResult;
  accountRatingsAverageLineChart: DashboardRatingsAverageTimelineResult;
  accountRatingsCount: DashboardRatingsResult;
  accountRatingsTasks: DashboardRatingTasksResult;
  accountStorageMovementsByDay: DashboardStorageMovementsByDayResult;
  accountStorageMovementsByType: DashboardStorageMovementsByTypeResult;
  addressCoordinates?: Maybe<AddressCoords>;
  addressGeocode: Array<Address>;
  addressPostalCode?: Maybe<Address>;
  apiKey?: Maybe<ApiKey>;
  apiKeys: ApiKeyPagedResult;
  approval?: Maybe<Approval>;
  approvals: ApprovalPagedResult;
  attachmentsAllowedExtensions?: Maybe<AttachmentAllowedExtensionResult>;
  auditLog: AuditLog;
  auditLogs: AuditLogPagedResult;
  companies: CompanyPagedResult;
  company?: Maybe<Company>;
  companyByConfig?: Maybe<Company>;
  companyMaintenancesScheduleVolume: Array<MaintenanceScheduleVolumeItem>;
  contract?: Maybe<Contract>;
  contractIdentifierExists: Scalars['Boolean']['output'];
  contracts: ContractPagedResult;
  coordinatesGeocode: Address;
  course: Course;
  courseSectionContent: CourseSectionContent;
  courses: CoursesPagedResult;
  coursesCategories: CourseCategoryPagedResult;
  criteriaGroup: CriteriaGroup;
  criteriasDataByCriteriasGroupId: Array<Maybe<CriteriaDataByCompany>>;
  criteriasGroups: CriteriasGroupsPagedResult;
  currentMaintenanceInprogressByEmployee?: Maybe<Maintenance>;
  deadlineContract: DeadlineContract;
  deadlineContractByConfig?: Maybe<DeadlineContract>;
  deadlineContracts: DeadlineContractPagedResult;
  deadlineViolationReason: DeadlineViolationReason;
  deadlineViolationReasons: DeadlineViolationReasonPagedResult;
  employeesPositions: Array<Maybe<EmployeesPositionsResult>>;
  equipment?: Maybe<Equipment>;
  equipmentType?: Maybe<EquipmentType>;
  equipmentWithoutPermissions?: Maybe<Equipment>;
  equipments: EquipmentPagedResult;
  equipmentsTypes: EquipmentTypePagedResult;
  equipmentsWithoutPermissions: EquipmentPagedResult;
  expense?: Maybe<Expense>;
  expenses: ExpensePagedResult;
  exports: ExportPagedResult;
  externalStorage: ExternalStorage;
  externalStorageProduct: ExternalStorageProduct;
  externalStorageProducts: ExternalStorageProductPagedResult;
  externalStorageProductsV2: ExternalStorageProductPagedResult;
  externalStorages: ExternalStoragePagedResult;
  featureFlags?: Maybe<Array<FeatureFlag>>;
  filters: Array<Maybe<Filter>>;
  form?: Maybe<Form>;
  formAnswers?: Maybe<FormAnswer>;
  forms: FormPagedResult;
  getCompletionProgress: CompletionProgressResponse;
  group?: Maybe<Group>;
  groups: GroupPagedResult;
  guest?: Maybe<User>;
  guests: UserPagedResult;
  import?: Maybe<Import>;
  imports: ImportPagedResult;
  invites: Array<Invite>;
  journey?: Maybe<Journey>;
  journeyFormQuestions: Array<JourneyFormQuestion>;
  label?: Maybe<Label>;
  labels: LabelPagedResult;
  lastMaintenanceCompletedByEmployee?: Maybe<Maintenance>;
  location?: Maybe<Location>;
  locationEnvironment: LocationEnvironment;
  locationEnvironments: LocationEnvironmentsPagedResult;
  locationGroup?: Maybe<LocationGroup>;
  locationSector: LocationSector;
  locationSectors: LocationSectorsPagedResult;
  locations: LocationPagedResult;
  locationsByCursor: LocationCursorPagedResult;
  locationsGroups: LocationGroupPagedResult;
  locationsNew: LocationPagedResult;
  loginCustomization?: Maybe<LoginCustomization>;
  maintenance?: Maybe<Maintenance>;
  maintenanceType: MaintenanceType;
  maintenanceTypes: MaintenanceTypePagedResult;
  maintenances: MaintenancePagedResult;
  me?: Maybe<AuthenticatedUser>;
  nextMaintenanceScheduledByEmployee?: Maybe<Maintenance>;
  nextPaymentNumber: NextPaymentNumberResult;
  nextProductCode: NextProductCodeResult;
  occurrences: OccurrencePagedResult;
  payment?: Maybe<Payment>;
  paymentLogs: PaymentLogsPagedResult;
  payments: PaymentPagedResult;
  pendencies: PendenciesPagedResult;
  pendency: Pendency;
  pendencyEvent: PendencyEvent;
  pendencyType: PendencyType;
  pendencyTypes: PendencyTypePagedResult;
  permissions: Array<Permission>;
  permissionsCategories: Array<PermissionsCategory>;
  problem?: Maybe<Problem>;
  problems: ProblemPagedResult;
  product?: Maybe<Product>;
  productService?: Maybe<ProductService>;
  productType: ProductType;
  productTypes: ProductTypePagedResult;
  products: ProductPagedResult;
  productsServices: ProductServicePagedResult;
  quotation?: Maybe<Quotation>;
  quotations: QuotationPagedResult;
  recurrence: Recurrence;
  recurrences: RecurrencePagedResult;
  requester?: Maybe<User>;
  requesters: UserPagedResult;
  segment?: Maybe<Segment>;
  segments: SegmentPagedResult;
  service?: Maybe<Service>;
  services: ServicePagedResult;
  status?: Maybe<Scalars['String']['output']>;
  storage?: Maybe<Storage>;
  storageMovement?: Maybe<StorageMovement>;
  storageProduct?: Maybe<StorageProduct>;
  storageProducts: StorageProductPagedResult;
  storages: StoragePagedResult;
  storagesMovements: StorageMovementPagedResult;
  ticket?: Maybe<Ticket>;
  tickets?: Maybe<TicketPagedResult>;
  user?: Maybe<User>;
  userLookup: UserLookupResult;
  users: UserPagedResult;
  warrantiesTemplates: WarrantiesTemplatesPagedResult;
  warrantyTemplate?: Maybe<WarrantyTemplate>;
  webHook?: Maybe<WebHook>;
  webHookDeliveries: WebHookDeliveryPagedResult;
  webHookDelivery: WebHookDelivery;
  webHookHealthCheck: WebHookHealthCheck;
  webHooks: WebHookPagedResult;
};


export type QueryAccountFormsAnswersArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: DashboardFormsAnswersWhereInput;
};


export type QueryAccountFormsAnswersDetailArgs = {
  where: DashboardFormsAnswersDetailWhereInput;
};


export type QueryAccountMaintenancesAverageDeadlinesArgs = {
  where: DeadlinesWhereInput;
};


export type QueryAccountMaintenancesCompletedBySourcesArgs = {
  where: DashboardInput;
};


export type QueryAccountMaintenancesCompletedLineChartArgs = {
  where: DashboardMaintenancesLineChartWhereInput;
};


export type QueryAccountMaintenancesCompletedTimelineArgs = {
  where: DashboardMaintenancesTimelineWhereInput;
};


export type QueryAccountMaintenancesDeadlinesByDayArgs = {
  where: DeadlinesWhereInput;
};


export type QueryAccountMaintenancesPendingTimeIntervalArgs = {
  where: DashboardInput;
};


export type QueryAccountMaintenancesSegmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where: DashboardInput;
};


export type QueryAccountMaintenancesStatisticsArgs = {
  where: DashboardInput;
};


export type QueryAccountMaintenancesStatusArgs = {
  where: DashboardInput;
};


export type QueryAccountMaintenancesStatusIntervalArgs = {
  where: DashboardInput;
};


export type QueryAccountMaintenancesTopPendingTimeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where: DashboardInput;
};


export type QueryAccountMaintenancesTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where: DashboardInput;
};


export type QueryAccountMaintenancesVolumeCountArgs = {
  where: DashboardInput;
};


export type QueryAccountProductsByStorageArgs = {
  where: DashboardStorageWhereInput;
};


export type QueryAccountQuotationsApprovalAverageAndPercentageArgs = {
  where: DashboardQuotationsWhereInput;
};


export type QueryAccountQuotationsApprovedTopTotalArgs = {
  where: DashboardQuotationsWhereInput;
};


export type QueryAccountQuotationsByStatusArgs = {
  where: DashboardQuotationsWhereInput;
};


export type QueryAccountQuotationsPendingTimeIntervalArgs = {
  where: DashboardQuotationsWhereInput;
};


export type QueryAccountQuotationsTopCompanyByProductServiceArgs = {
  where: DashboardQuotationsWhereInput;
};


export type QueryAccountQuotationsTotalAndQuantityByProductServiceArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: AccountQuotationsTotalAndQuantityByProductServiceOrderByInput;
  where: DashboardQuotationsWhereInput;
};


export type QueryAccountQuotationsTotalByItemTypeArgs = {
  where: DashboardQuotationsWhereInput;
};


export type QueryAccountQuotationsTotalByStatusArgs = {
  where: DashboardQuotationsWhereInput;
};


export type QueryAccountRatingsAverageByTimelineArgs = {
  where: DashboardRatingsByTimelineWhereInput;
};


export type QueryAccountRatingsAverageLineChartArgs = {
  where: DashboardRatingsLineChartWhere;
};


export type QueryAccountRatingsCountArgs = {
  where: DashboardRatingsWhereInput;
};


export type QueryAccountRatingsTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy: DashboardRatingsTasksOrderByInput;
  where: DashboardRatingsTasksWhereInput;
};


export type QueryAccountStorageMovementsByDayArgs = {
  where: DashboardStorageWhereInput;
};


export type QueryAccountStorageMovementsByTypeArgs = {
  where: DashboardStorageWhereInput;
};


export type QueryAddressCoordinatesArgs = {
  address: Scalars['String']['input'];
};


export type QueryAddressGeocodeArgs = {
  input: AddressGeocodeInput;
};


export type QueryAddressPostalCodeArgs = {
  postalCode: Scalars['String']['input'];
};


export type QueryApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiKeysArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ApiKeyOrderByInput>;
  where?: InputMaybe<ApiKeyWhereInput>;
};


export type QueryApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApprovalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ApprovalOrderByInput>;
  where?: InputMaybe<ApprovalWhereInput>;
};


export type QueryAuditLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuditLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AuditLogsOrderByInput>;
  where?: InputMaybe<AuditLogsWhereInput>;
};


export type QueryCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CompanyOrderByInput>;
  orderByDistance?: InputMaybe<CompanyOrderByDistanceInput>;
  where?: InputMaybe<CompanyWhereInput>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyByConfigArgs = {
  locationId: Scalars['ID']['input'];
  maintenanceTypeId?: InputMaybe<Scalars['ID']['input']>;
  segmentId: Scalars['ID']['input'];
};


export type QueryCompanyMaintenancesScheduleVolumeArgs = {
  companyId: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractIdentifierExistsArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryContractsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContractOrderByInput>;
  where?: InputMaybe<ContractWhereInput>;
};


export type QueryCoordinatesGeocodeArgs = {
  input: CoordinatesGeocodeInput;
};


export type QueryCourseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCourseSectionContentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoursesArgs = {
  orderBy?: InputMaybe<CourseOrderByEnum>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CourseWhereInput>;
};


export type QueryCoursesCategoriesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CoursesCategoryWhereInput>;
};


export type QueryCriteriaGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCriteriasDataByCriteriasGroupIdArgs = {
  id: Scalars['ID']['input'];
  where?: InputMaybe<CriteriasGroupsDataWhereInput>;
};


export type QueryCriteriasGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CriteriasGroupsOrderByInput>;
  where?: InputMaybe<CriteriasGroupsWhereInput>;
};


export type QueryCurrentMaintenanceInprogressByEmployeeArgs = {
  input: CurrentMaintenanceInprogressByEmployee;
};


export type QueryDeadlineContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeadlineContractByConfigArgs = {
  locationId: Scalars['ID']['input'];
  maintenanceTypeId?: InputMaybe<Scalars['ID']['input']>;
  segmentId: Scalars['ID']['input'];
};


export type QueryDeadlineContractsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DeadlineContractOrderByInput>;
  where?: InputMaybe<DeadlineContractWhereInput>;
};


export type QueryDeadlineViolationReasonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeadlineViolationReasonsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DeadlineViolationReasonOrderByInput>;
  where?: InputMaybe<DeadlineViolationReasonWhereInput>;
};


export type QueryEmployeesPositionsArgs = {
  where?: InputMaybe<EmployeesPositionWhereInput>;
};


export type QueryEquipmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEquipmentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEquipmentWithoutPermissionsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEquipmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EquipmentOrderByInput>;
  where?: InputMaybe<EquipmentWhereInput>;
};


export type QueryEquipmentsTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EquipmentTypeOrderByInput>;
  where?: InputMaybe<EquipmentTypeWhereInput>;
};


export type QueryEquipmentsWithoutPermissionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EquipmentWithOutOrderByInput>;
  where?: InputMaybe<EquipmentWithOutWhereInput>;
};


export type QueryExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpensesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExpenseOrderByInput>;
  where?: InputMaybe<ExpenseWhereInput>;
};


export type QueryExportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExportsOrderByInput>;
  where?: InputMaybe<ExportsWhereInput>;
};


export type QueryExternalStorageArgs = {
  where: ExternalStorageWhereInput;
};


export type QueryExternalStorageProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExternalStorageProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExternalStorageProductsOrderByInput>;
  where: ExternalStorageProductWhereInput;
};


export type QueryExternalStorageProductsV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExternalStorageProductsOrderByInput>;
  where: ExternalStorageProductV2WhereInput;
};


export type QueryExternalStoragesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ExternalStoragesOrderByInput>;
  where: ExternalStoragesWhereInput;
};


export type QueryFiltersArgs = {
  where?: InputMaybe<FiltersWhereInput>;
};


export type QueryFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFormAnswersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFormsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FormOrderByInput>;
  where?: InputMaybe<FormWhereInput>;
};


export type QueryGetCompletionProgressArgs = {
  type: CoursesTypesEnum;
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GroupOrderByInput>;
  where?: InputMaybe<GroupWhereInput>;
};


export type QueryGuestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGuestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderByInput>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ImportOrderByInput>;
  where?: InputMaybe<ImportWhereInput>;
};


export type QueryInvitesArgs = {
  where?: InputMaybe<InvitesWhereInput>;
};


export type QueryLabelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLabelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LabelOrderByInput>;
  where?: InputMaybe<LabelWhereInput>;
};


export type QueryLastMaintenanceCompletedByEmployeeArgs = {
  input: LastMaintenanceCompletedByEmployeeInput;
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationEnvironmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationEnvironmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LocationEnvironmentOrderByInput>;
  where?: InputMaybe<LocationEnvironmentWhereInput>;
};


export type QueryLocationGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationSectorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationSectorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LocationSectorOrderByInput>;
  where?: InputMaybe<LocationSectorWhereInput>;
};


export type QueryLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LocationOrderByObjectInput>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryLocationsByCursorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<LocationsByCursorOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationsByCursorWhereInput>;
};


export type QueryLocationsGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LocationGroupOrderByInput>;
  where?: InputMaybe<LocationGroupWhereInput>;
};


export type QueryLocationsNewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LocationOrderByObjectInput>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryLoginCustomizationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMaintenanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaintenanceTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaintenanceTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MaintenanceTypeOrderByInput>;
  where?: InputMaybe<MaintenanceTypeWhereInput>;
};


export type QueryMaintenancesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MaintenanceOrderByInput>;
  where?: InputMaybe<MaintenanceWhereInput>;
};


export type QueryNextMaintenanceScheduledByEmployeeArgs = {
  input: NextMaintenanceScheduledByEmployee;
};


export type QueryOccurrencesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OccurrenceOrderByInput>;
  where: OccurrenceWhereInput;
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaymentLogOrderByInput>;
  where?: InputMaybe<PaymentLogWhereInput>;
};


export type QueryPaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaymentOrderByInput>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryPendenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PendenciesOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PendenciesWhereInput>;
};


export type QueryPendencyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPendencyEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPendencyTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPendencyTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PendencyTypeOrderByInput>;
  where?: InputMaybe<PendencyTypeWhereInput>;
};


export type QueryPermissionsArgs = {
  orderBy?: InputMaybe<PermissionOrderByInput>;
};


export type QueryPermissionsCategoriesArgs = {
  orderBy?: InputMaybe<PermissionOrderByInput>;
};


export type QueryProblemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProblemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProblemOrderByInput>;
  where?: InputMaybe<ProblemWhereInput>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductTypeOrderByInput>;
  where?: InputMaybe<ProductTypeWhereInput>;
};


export type QueryProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductsOrderByInput>;
  where?: InputMaybe<ProductsWhereInput>;
};


export type QueryProductsServicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProductServiceOrderByInput>;
  where?: InputMaybe<ProductServiceWhereInput>;
};


export type QueryQuotationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuotationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<QuotationOrderByInput>;
  where?: InputMaybe<QuotationWhereInput>;
};


export type QueryRecurrenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecurrencesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RecurrenceOrderByInput>;
  where?: InputMaybe<RecurrenceWhereInput>;
};


export type QueryRequesterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRequestersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderByInput>;
  where?: InputMaybe<UserWhereInput>;
};


export type QuerySegmentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySegmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SegmentOrderByInput>;
  where?: InputMaybe<SegmentWhereInput>;
};


export type QueryServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ServiceOrderByInput>;
  where?: InputMaybe<ServiceWhereInput>;
};


export type QueryStorageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorageMovementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorageProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorageProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StoragesProductsOrderByInput>;
  where?: InputMaybe<StorageProductsWhereInput>;
};


export type QueryStoragesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StoragesOrderByInput>;
  where?: InputMaybe<StoragesWhereInput>;
};


export type QueryStoragesMovementsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StoragesMovementsOrderByInput>;
  where?: InputMaybe<StoragesMovementsWhereInput>;
};


export type QueryTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TicketOrderByInput>;
  where?: InputMaybe<TicketWhereInput>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserLookupArgs = {
  email: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderByInput>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryWarrantiesTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WarrantiesTemplatesOrderByInput>;
  where?: InputMaybe<WarrantiesTemplatesWhereInput>;
};


export type QueryWarrantyTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWebHookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWebHookDeliveriesArgs = {
  input: WebHookDeliveriesInput;
};


export type QueryWebHookDeliveryArgs = {
  sortKey: Scalars['String']['input'];
};


export type QueryWebHookHealthCheckArgs = {
  input: WebHookHealthCheckInput;
};


export type QueryWebHooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Question = {
  __typename?: 'Question';
  conditions: Array<QuestionCondition>;
  configuration?: Maybe<QuestionConfiguration>;
  id: Scalars['ID']['output'];
  isTagQuestion?: Maybe<Scalars['Boolean']['output']>;
  options: Array<Option>;
  position: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: QuestionTypeEnum;
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt: Scalars['Datetime']['output'];
  conditions?: Maybe<Array<Maybe<QuestionCondition>>>;
  configuration?: Maybe<QuestionConfiguration>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  options?: Maybe<Array<Maybe<Option>>>;
  position: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: QuestionTypeEnum;
};

export type QuestionAnswerOptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  value: Scalars['String']['input'];
};

export type QuestionAnswerStatistics = ClosedQuestionAnswerStatistics | MultipleQuestionAnswerStatistics | OpenQuestionAnswerStatistics;

export type QuestionCondition = {
  __typename?: 'QuestionCondition';
  operator: OperatorEnum;
  question: QuestionReference;
  value: Scalars['String']['output'];
};

export type QuestionConditionInput = {
  operator: OperatorEnum;
  question: QuestionReferenceInput;
  value: Scalars['String']['input'];
};

export type QuestionConfiguration = {
  __typename?: 'QuestionConfiguration';
  exampleValue?: Maybe<Scalars['String']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  maskRegexp?: Maybe<Scalars['String']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  transform?: Maybe<TextTransform>;
  validationMessage?: Maybe<Scalars['String']['output']>;
  validationRegexp?: Maybe<Scalars['String']['output']>;
};

export type QuestionConfigurationInput = {
  exampleValue: Scalars['String']['input'];
  mask?: InputMaybe<Scalars['String']['input']>;
  maskRegexp?: InputMaybe<Scalars['String']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  transform: TextTransform;
  validationMessage: Scalars['String']['input'];
  validationRegexp: Scalars['String']['input'];
};

export type QuestionInput = {
  conditions?: InputMaybe<Array<QuestionConditionInput>>;
  configuration?: InputMaybe<QuestionConfigurationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTagQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  options: Array<QuestionOptionInput>;
  required: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  type: QuestionTypeEnum;
};

export type QuestionOptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  value: Scalars['String']['input'];
};

export type QuestionReference = {
  __typename?: 'QuestionReference';
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type QuestionReferenceInput = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export enum QuestionTypeEnum {
  Attachment = 'attachment',
  Checkboxes = 'checkboxes',
  Currency = 'currency',
  Date = 'date',
  Document = 'document',
  Dropdown = 'dropdown',
  Email = 'email',
  Geolocation = 'geolocation',
  Hour = 'hour',
  MultipleChoice = 'multipleChoice',
  MultiplePicture = 'multiplePicture',
  Numeric = 'numeric',
  Paragraph = 'paragraph',
  Phone = 'phone',
  Picture = 'picture',
  ShortAnswer = 'shortAnswer',
  Signature = 'signature',
  UniqueCheckbox = 'uniqueCheckbox'
}

export type Quotation = {
  __typename?: 'Quotation';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['Datetime']['output']>;
  approvedBy?: Maybe<User>;
  approvedMessage?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  attachments: Array<QuotationAttachment>;
  company: Company;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  description: Scalars['String']['output'];
  discount: QuotationDiscount;
  expenses?: Maybe<Array<QuotationExpense>>;
  expensesTotalValue: Scalars['Float']['output'];
  expiredAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  items: Array<QuotationItem>;
  labels?: Maybe<Array<Label>>;
  location: Location;
  maintenance?: Maybe<Maintenance>;
  name: Scalars['String']['output'];
  payment?: Maybe<Payment>;
  productsServicesTotalValues: ProductsServicesTotalValues;
  refusedAt?: Maybe<Scalars['Datetime']['output']>;
  refusedBy?: Maybe<User>;
  status: QuotationStatus;
  subTotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedByClientApplicationName?: Maybe<QuotationUpdatedByClientApplicationName>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type QuotationAttachment = {
  __typename?: 'QuotationAttachment';
  account_id: Scalars['ID']['output'];
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  quotation_id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum QuotationAttachmentOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  PositionDesc = 'position_desc'
}

export type QuotationAttachmentResult = {
  __typename?: 'QuotationAttachmentResult';
  items: Array<QuotationAttachment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuotationAttachmentWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
};

export type QuotationDiscount = {
  __typename?: 'QuotationDiscount';
  total?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<QuotationDiscountType>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum QuotationDiscountType {
  Percentage = 'percentage',
  Value = 'value'
}

export type QuotationExpense = {
  __typename?: 'QuotationExpense';
  description?: Maybe<Scalars['String']['output']>;
  expense: Expense;
  id: Scalars['ID']['output'];
  path?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  quotation: Quotation;
  value: Scalars['Float']['output'];
};

export type QuotationItem = {
  __typename?: 'QuotationItem';
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  productService: ProductService;
  productServiceValue: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export enum QuotationOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  ExpiredAtAsc = 'expiredAt_asc',
  ExpiredAtDesc = 'expiredAt_desc',
  IdentifierAsc = 'identifier_asc',
  IdentifierDesc = 'identifier_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  TotalAsc = 'total_asc',
  TotalDesc = 'total_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type QuotationPagedResult = {
  __typename?: 'QuotationPagedResult';
  items: Array<Quotation>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum QuotationStatus {
  Approved = 'approved',
  Canceled = 'canceled',
  Expired = 'expired',
  Pending = 'pending',
  Refused = 'refused'
}

export enum QuotationUpdatedByClientApplicationName {
  Grond = 'grond',
  Mountdoom = 'mountdoom'
}

export type QuotationWhereInput = {
  agreementAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  agreementAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  approvedByOrRefusedById_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  hasMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  identifier_contains?: InputMaybe<Scalars['String']['input']>;
  labelId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationGroupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceStatus_in?: InputMaybe<Array<MaintenanceStatus>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  status_in?: InputMaybe<Array<QuotationStatus>>;
  total_gte?: InputMaybe<Scalars['Float']['input']>;
  total_lte?: InputMaybe<Scalars['Float']['input']>;
};

export type QuotationsAverageAndPercentageItem = {
  __typename?: 'QuotationsAverageAndPercentageItem';
  approvalPercentage?: Maybe<Scalars['Float']['output']>;
  averageAgeInDays?: Maybe<Scalars['Float']['output']>;
};

export type QuotationsAverageAndPercentageResult = {
  __typename?: 'QuotationsAverageAndPercentageResult';
  item?: Maybe<QuotationsAverageAndPercentageItem>;
  reportName: Scalars['String']['output'];
};

export type QuotationsPreferences = {
  __typename?: 'QuotationsPreferences';
  featureApproveQuotationByLink?: Maybe<Scalars['Boolean']['output']>;
  featureApproveQuotationByPanel?: Maybe<Scalars['Boolean']['output']>;
};

export type QuotationsPreferencesInput = {
  featureApproveQuotationByLink: Scalars['Boolean']['input'];
  featureApproveQuotationByPanel: Scalars['Boolean']['input'];
};

export type QuotationsTopCompanyByProductServiceResult = {
  __typename?: 'QuotationsTopCompanyByProductServiceResult';
  items?: Maybe<Array<QuotationsTopCompanyByProductServiceValue>>;
  reportName: Scalars['String']['output'];
};

export type QuotationsTopCompanyByProductServiceValue = {
  __typename?: 'QuotationsTopCompanyByProductServiceValue';
  companyId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  productServiceId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type QuotationsTotalAndQuantityByProductServiceResult = {
  __typename?: 'QuotationsTotalAndQuantityByProductServiceResult';
  items?: Maybe<Array<QuotationsTotalAndQuantityByProductServiceValue>>;
  reportName: Scalars['String']['output'];
};

export type QuotationsTotalAndQuantityByProductServiceValue = {
  __typename?: 'QuotationsTotalAndQuantityByProductServiceValue';
  productServiceId?: Maybe<Scalars['String']['output']>;
  productServiceName?: Maybe<Scalars['String']['output']>;
  productServiceType?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type QuotationsTotalByItemsTypeItem = {
  __typename?: 'QuotationsTotalByItemsTypeItem';
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type QuotationsTotalByItemsTypeResult = {
  __typename?: 'QuotationsTotalByItemsTypeResult';
  items?: Maybe<Array<Maybe<QuotationsTotalByItemsTypeItem>>>;
  reportName: Scalars['String']['output'];
};

export type Rating = {
  __typename?: 'Rating';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  stars: Scalars['Int']['output'];
};

export type ReallocateMaintenanceInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  newCompanyId: Scalars['ID']['input'];
  scheduleSuggestions?: InputMaybe<Array<MaintenanceScheduleSuggestionInput>>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailMessage?: InputMaybe<Scalars['String']['input']>;
};

export type Recurrence = {
  __typename?: 'Recurrence';
  archived: Scalars['Boolean']['output'];
  company?: Maybe<Company>;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  equipments: Array<Equipment>;
  id: Scalars['ID']['output'];
  iteration: Scalars['Int']['output'];
  location: Location;
  locationEnvironments: Array<LocationEnvironment>;
  locationSectors: Array<LocationSector>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  logs: Array<RecurrenceLog>;
  maintenanceType: MaintenanceType;
  message?: Maybe<Scalars['String']['output']>;
  occurrences?: Maybe<OccurrencePagedResult>;
  repeat?: Maybe<Repeat>;
  segment: Segment;
  source?: Maybe<RecurrenceSource>;
  type: MaintenanceTypeEnum;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};


export type RecurrenceOccurrencesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OccurrenceOrderByInput>;
};

export type RecurrenceCreateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  equipmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  equipments?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locationEnvironmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId: Scalars['ID']['input'];
  locationSectorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: Scalars['String']['input'];
  productsServices?: InputMaybe<Array<RecurrenceProductServiceInput>>;
  repeat: RepeatInput;
  segmentId: Scalars['ID']['input'];
  type?: InputMaybe<MaintenanceTypeEnum>;
  typeId: Scalars['ID']['input'];
};

export enum RecurrenceIntervalEnum {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export type RecurrenceLog = {
  __typename?: 'RecurrenceLog';
  clientApplicationName?: Maybe<Scalars['String']['output']>;
  clientIpAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  snapshot: RecurrenceSnapshot;
  updatedBy?: Maybe<User>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export enum RecurrenceOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  LocationAsc = 'location_asc',
  LocationDesc = 'location_desc',
  MaintenanceTypeAsc = 'maintenanceType_asc',
  MaintenanceTypeDesc = 'maintenanceType_desc',
  SegmentAsc = 'segment_asc',
  SegmentDesc = 'segment_desc'
}

export type RecurrencePagedResult = {
  __typename?: 'RecurrencePagedResult';
  items: Array<Recurrence>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecurrenceProductServiceInput = {
  productServiceId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
  type?: InputMaybe<ProductServiceType>;
};

export type RecurrenceSnapshot = {
  __typename?: 'RecurrenceSnapshot';
  archived: Scalars['Boolean']['output'];
  company?: Maybe<Company>;
  equipments?: Maybe<Array<Equipment>>;
  id: Scalars['ID']['output'];
  iteration: Scalars['Int']['output'];
  location: Location;
  locationEnvironments?: Maybe<Array<LocationEnvironment>>;
  locationSectors?: Maybe<Array<LocationSector>>;
  maintenanceType: MaintenanceType;
  message?: Maybe<Scalars['String']['output']>;
  repeat?: Maybe<Repeat>;
  segment: Segment;
};

export enum RecurrenceSource {
  Eyeofsauron = 'eyeofsauron',
  Sammathnaur = 'sammathnaur'
}

export type RecurrenceUpdateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  equipmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  equipments?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationEnvironmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationSectorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message?: InputMaybe<Scalars['String']['input']>;
  productsServices?: InputMaybe<Array<RecurrenceProductServiceInput>>;
  segmentId?: InputMaybe<Scalars['ID']['input']>;
};

export type RecurrenceWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  equipmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interval_in?: InputMaybe<Array<IntervalInput>>;
  locationEnvironmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  maintenanceTypeId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  message_contains?: InputMaybe<Scalars['String']['input']>;
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RecurrencesPreferences = {
  __typename?: 'RecurrencesPreferences';
  featureDeadlinesEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type RecurrencesPreferencesInput = {
  featureDeadlinesEnabled: Scalars['Boolean']['input'];
};

export type RejectQuotationInput = {
  approvedMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RemoveLocationFromGroupInput = {
  items: Array<RemoveLocationToGroupInputItem>;
};

export type RemoveLocationToGroupInputItem = {
  groupId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};

export type RemoveMaintenancesFromPaymentInput = {
  maintenanceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentId: Scalars['ID']['input'];
};

export type RemoveQuotationLabelInput = {
  labelId: Scalars['ID']['input'];
  quotationId: Scalars['ID']['input'];
};

export type RemoveQuotationsFromPaymentInput = {
  paymentId: Scalars['ID']['input'];
  quotationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RemoveSegmentFromGroupInput = {
  items: Array<RemoveSegmentFromGroupItemsInput>;
};

export type RemoveSegmentFromGroupItemsInput = {
  groupId: Scalars['ID']['input'];
  segmentId: Scalars['ID']['input'];
};

export type RemoveUserFromGroupInput = {
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveWarrantyInput = {
  warrantyId: Scalars['ID']['input'];
};

export type ReopenMaintenanceInput = {
  reopeningReason?: InputMaybe<Scalars['String']['input']>;
  scheduleSuggestions?: InputMaybe<Array<MaintenanceScheduleSuggestionInput>>;
};

export type Repeat = {
  __typename?: 'Repeat';
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  every: Scalars['Int']['output'];
  from: Scalars['Date']['output'];
  interval: IntervalInput;
  skipWeekend?: Maybe<Scalars['Boolean']['output']>;
  until?: Maybe<Scalars['Date']['output']>;
  weekday?: Maybe<WeekdayInput>;
};

export type RepeatInput = {
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  every?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  interval?: InputMaybe<IntervalInput>;
  skipWeekend?: InputMaybe<Scalars['Boolean']['input']>;
  until?: InputMaybe<Scalars['Date']['input']>;
  weekDay?: InputMaybe<WeekdayInput>;
};

export type ResultAverageItem = {
  __typename?: 'ResultAverageItem';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<AverageItem>;
};

export type ResultCompanyItem = {
  __typename?: 'ResultCompanyItem';
  maintenances: Array<MaintenanceItem>;
  name: Scalars['String']['output'];
  totalMaintenances?: Maybe<Scalars['Int']['output']>;
  totalMaintenancesBacklog?: Maybe<Scalars['Int']['output']>;
  totalMaintenancesCanceled?: Maybe<Scalars['Int']['output']>;
  totalMaintenancesDone?: Maybe<Scalars['Int']['output']>;
};

export type ResultHistoryItem = {
  __typename?: 'ResultHistoryItem';
  date: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<ResultHistoryValue>>>;
};

export type ResultHistoryValue = {
  __typename?: 'ResultHistoryValue';
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ResultItem = {
  __typename?: 'ResultItem';
  extra?: Maybe<Scalars['JSON']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ScalarStringWrapper = {
  __typename?: 'ScalarStringWrapper';
  value?: Maybe<Scalars['String']['output']>;
};

export type ScheduleDatetime = {
  __typename?: 'ScheduleDatetime';
  date?: Maybe<Scalars['Date']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type Segment = {
  __typename?: 'Segment';
  archived?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  groupsConnection: GroupPagedResult;
  id: Scalars['ID']['output'];
  maintenanceTypes: Array<MaintenanceType>;
  name: Scalars['String']['output'];
  segmentMaintenanceTypeForms: Array<Maybe<SegmentMaintenanceTypeForm>>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};


export type SegmentGroupsConnectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GroupOrderByInput>;
  where?: InputMaybe<GroupWhereInput>;
};

export type SegmentInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  segmentMaintenanceTypeForms?: InputMaybe<Array<SegmentMaintenanceTypeFormInput>>;
};

export type SegmentMaintenanceTypeForm = {
  __typename?: 'SegmentMaintenanceTypeForm';
  createdAt: Scalars['Datetime']['output'];
  form: Form;
  id: Scalars['ID']['output'];
  maintenanceType?: Maybe<MaintenanceType>;
  requiredComplete: Scalars['Boolean']['output'];
  requiredReport: Scalars['Boolean']['output'];
  requiredStart: Scalars['Boolean']['output'];
};

export type SegmentMaintenanceTypeFormInput = {
  formId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  maintenanceTypeId?: InputMaybe<Scalars['ID']['input']>;
  requiredComplete: Scalars['Boolean']['input'];
  requiredReport: Scalars['Boolean']['input'];
  requiredStart: Scalars['Boolean']['input'];
};

export enum SegmentOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc'
}

export type SegmentPagedResult = {
  __typename?: 'SegmentPagedResult';
  items: Array<Segment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SegmentWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  groupId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
};

export type Service = {
  __typename?: 'Service';
  archived: Scalars['Boolean']['output'];
  companies: Array<ProductServiceCompany>;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  measure?: Maybe<ProductServiceMeasure>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
  value: Scalars['Float']['output'];
};

export enum ServiceOrderByInput {
  CodeAsc = 'code_asc',
  CodeDesc = 'code_desc',
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type ServicePagedResult = {
  __typename?: 'ServicePagedResult';
  items: Array<Service>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ServiceProviderOrderByEnum {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  SegmentNameAsc = 'segmentName_asc',
  SegmentNameDesc = 'segmentName_desc'
}

export type ServiceProviderPagedResult = {
  __typename?: 'ServiceProviderPagedResult';
  items: Array<LocationServiceProvider>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ServiceProviderWhereInput = {
  segmentId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ServiceWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
};

export type SetUserPasswordInput = {
  password: Scalars['String']['input'];
  permanentPassword?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartImportInput = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['Datetime']['input'];
};

export type StartImportValidationInput = {
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['Datetime']['input'];
};

export type Storage = {
  __typename?: 'Storage';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  movements: StorageMovementCursorPagedResult;
  name: Scalars['String']['output'];
  products: StorageProductPagedResult;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};


export type StorageMovementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type StorageProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  where?: InputMaybe<StorageProductsWhereInput>;
};

export type StorageMovement = {
  __typename?: 'StorageMovement';
  company?: Maybe<Company>;
  createdAt: Scalars['Datetime']['output'];
  createdBy?: Maybe<User>;
  createdByAvatarUrl?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  externalStorage?: Maybe<ExternalStorage>;
  externalStorageMovement?: Maybe<ExternalStorageMovement>;
  id: Scalars['ID']['output'];
  maintenance?: Maybe<Maintenance>;
  product: Product;
  quantity: StorageMovementQuantity;
  relatedStorageMovement?: Maybe<StorageMovement>;
  storage?: Maybe<Storage>;
  sync?: Maybe<StorageMovementSync>;
  type: StorageMovementType;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy?: Maybe<User>;
};

export type StorageMovementCursorPagedResult = {
  __typename?: 'StorageMovementCursorPagedResult';
  items: Array<StorageMovement>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StorageMovementPagedResult = {
  __typename?: 'StorageMovementPagedResult';
  items: Array<StorageMovement>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StorageMovementQuantity = {
  __typename?: 'StorageMovementQuantity';
  changed: Scalars['Float']['output'];
  current: Scalars['Float']['output'];
  previous: Scalars['Float']['output'];
};

export type StorageMovementSync = {
  __typename?: 'StorageMovementSync';
  messageId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<StorageMovementSyncStatus>;
  syncedAt?: Maybe<Scalars['Datetime']['output']>;
};

export enum StorageMovementSyncStatus {
  Failed = 'failed',
  Pending = 'pending',
  Success = 'success'
}

export enum StorageMovementType {
  Entry = 'entry',
  ExternalEntry = 'external_entry',
  ExternalRemoval = 'external_removal',
  ExternalTransferEntry = 'external_transfer_entry',
  ExternalTransferRemoval = 'external_transfer_removal',
  InternalTransferEntry = 'internal_transfer_entry',
  InternalTransferRemoval = 'internal_transfer_removal',
  Removal = 'removal'
}

export type StoragePagedResult = {
  __typename?: 'StoragePagedResult';
  items: Array<Storage>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StorageProduct = {
  __typename?: 'StorageProduct';
  account: Account;
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  minimalQuantity?: Maybe<Scalars['Float']['output']>;
  minimalQuantityAtRisk?: Maybe<Scalars['Float']['output']>;
  product: Product;
  quantity: Scalars['Float']['output'];
  status?: Maybe<StorageProductStatus>;
  storage: Storage;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};

export type StorageProductPagedResult = {
  __typename?: 'StorageProductPagedResult';
  items: Array<StorageProduct>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum StorageProductStatus {
  AtRisk = 'at_risk',
  Available = 'available',
  Critical = 'critical',
  Unknown = 'unknown'
}

export type StorageProductsWhereInput = {
  company?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  productCodeContains?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  productMeasureIn?: InputMaybe<Array<ProductServiceMeasure>>;
  productNameContains?: InputMaybe<Scalars['String']['input']>;
  productNameOrCodeContains?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<StorageProductStatus>>;
  storageId?: InputMaybe<Scalars['ID']['input']>;
  storageNameContains?: InputMaybe<Scalars['String']['input']>;
};

export enum StoragesMovementsOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  DescriptionAsc = 'description_asc',
  DescriptionDesc = 'description_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type StoragesMovementsWhereInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  createdAtGte?: InputMaybe<Scalars['String']['input']>;
  createdAtLte?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  storageId?: InputMaybe<Scalars['ID']['input']>;
  storageIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  storageNameContains?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum StoragesOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type StoragesPreferences = {
  __typename?: 'StoragesPreferences';
  featureInternalStorages?: Maybe<Scalars['Boolean']['output']>;
  featureSharedStorages?: Maybe<Scalars['Boolean']['output']>;
};

export type StoragesPreferencesInput = {
  featureInternalStorages?: InputMaybe<Scalars['Boolean']['input']>;
  featureSharedStorages?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum StoragesProductsOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  StatusAsc = 'status_asc',
  StatusDesc = 'status_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type StoragesWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitJourneyFormInput = {
  answers: Array<JourneyAnswerInput>;
};

export type Task = {
  __typename?: 'Task';
  archived: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<TaskEmployee>;
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  logs: Array<TaskLog>;
  longitude: Scalars['Float']['output'];
  position: Scalars['Int']['output'];
  rating?: Maybe<TaskRating>;
  receivedAt?: Maybe<Scalars['Datetime']['output']>;
  reportedReason?: Maybe<Scalars['String']['output']>;
  scheduled?: Maybe<ScheduleDatetime>;
  startedAt?: Maybe<Scalars['Datetime']['output']>;
  startedRouteAt?: Maybe<Scalars['Datetime']['output']>;
  status: Scalars['String']['output'];
  statusDescription?: Maybe<Scalars['String']['output']>;
  /**  @deprecated Use taskLogsConnection instead  */
  taskLogsConnection: TaskLogsConnectionResult;
  timezone?: Maybe<Scalars['String']['output']>;
  viewedAt?: Maybe<Scalars['Datetime']['output']>;
};


export type TaskLogsArgs = {
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
};


export type TaskTaskLogsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskConnectionResult = {
  __typename?: 'TaskConnectionResult';
  items: Array<Task>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskEmployee = {
  __typename?: 'TaskEmployee';
  avatar?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TaskLog = {
  __typename?: 'TaskLog';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  snapshot?: Maybe<TaskSnapshot>;
  updatedBy?: Maybe<TaskUpdatedBy>;
};

export enum TaskLogUpdatedBySource {
  Api = 'api',
  Browser = 'browser',
  Mobile = 'mobile',
  System = 'system',
  Vrp = 'vrp'
}

export enum TaskLogUpdatedByType {
  Api = 'api',
  Customers = 'customers',
  Employees = 'employees',
  Integrations = 'integrations',
  System = 'system',
  Users = 'users'
}

export type TaskLogsConnectionResult = {
  __typename?: 'TaskLogsConnectionResult';
  items: Array<TaskLog>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskRating = {
  __typename?: 'TaskRating';
  comments?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  stars?: Maybe<Scalars['Int']['output']>;
};

export type TaskSnapshot = {
  __typename?: 'TaskSnapshot';
  archived: Scalars['Boolean']['output'];
  company?: Maybe<Company>;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  employee?: Maybe<TaskEmployee>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<TaskRating>;
  receivedAt?: Maybe<Scalars['Datetime']['output']>;
  scheduled?: Maybe<ScheduleDatetime>;
  startedAt?: Maybe<Scalars['Datetime']['output']>;
  status: TaskStatus;
  statusDescription?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  viewedAt?: Maybe<Scalars['Datetime']['output']>;
};

export enum TaskStatus {
  Canceled = 'canceled',
  Done = 'done',
  InProgress = 'inProgress',
  OnRoute = 'onRoute',
  Pending = 'pending',
  Reported = 'reported',
  Scheduled = 'scheduled'
}

export type TaskUpdatedBy = {
  __typename?: 'TaskUpdatedBy';
  id?: Maybe<Scalars['ID']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offline: Scalars['Boolean']['output'];
  offlineClock?: Maybe<Scalars['Datetime']['output']>;
  source?: Maybe<TaskLogUpdatedBySource>;
  type?: Maybe<TaskLogUpdatedByType>;
};

export enum TextTransform {
  Lowercase = 'lowercase',
  None = 'none',
  Uppercase = 'uppercase'
}

export type Ticket = {
  __typename?: 'Ticket';
  address?: Maybe<TicketAddress>;
  addressHash?: Maybe<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  attachments: Array<TicketAttachment>;
  cancelationReason?: Maybe<Scalars['String']['output']>;
  clientApplicationName?: Maybe<Scalars['String']['output']>;
  comments: Array<Comment>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  equipments: Array<Equipment>;
  formAnswers: Array<FormAnswer>;
  id: Scalars['ID']['output'];
  locationEnvironments: Array<LocationEnvironment>;
  locationSectors: Array<LocationSector>;
  maintenance?: Maybe<Maintenance>;
  maintenanceType: MaintenanceType;
  message?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  requester?: Maybe<User>;
  segment: Segment;
  status: TicketStatus;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
};


export type TicketCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  where?: InputMaybe<MaintenanceCommentWhereInput>;
};

export type TicketAddress = {
  __typename?: 'TicketAddress';
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  coords: AddressCoords;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  neighborhood: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type TicketAddressInput = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  coords: AddressCoordsInput;
  neighborhood: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type TicketAttachment = {
  __typename?: 'TicketAttachment';
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type TicketAttachmentCreateInput = {
  path: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  ticketId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type TicketAttachmentInput = {
  path: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TicketCreateInput = {
  address?: InputMaybe<TicketAddressInput>;
  attachments: Array<TicketAttachmentInput>;
  equipmentIds: Array<Scalars['ID']['input']>;
  forms: Array<CreateFormAnswerInput>;
  maintenanceTypeId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  segmentId: Scalars['ID']['input'];
};

export enum TicketOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  NumberAsc = 'number_asc',
  NumberDesc = 'number_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc'
}

export type TicketPagedResult = {
  __typename?: 'TicketPagedResult';
  items: Array<Ticket>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TicketRejectInput = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export enum TicketStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Pending = 'pending'
}

export type TicketWhereInput = {
  addressNumberContains?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  cityContains?: InputMaybe<Scalars['String']['input']>;
  complementContains?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  equipmentNumberContains?: InputMaybe<Scalars['String']['input']>;
  maintenanceTypeIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  neighborhoodContains?: InputMaybe<Scalars['String']['input']>;
  numberContains?: InputMaybe<Scalars['String']['input']>;
  openedAt?: InputMaybe<DateRangeInput>;
  requesterIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  stateContains?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<TicketStatus>>;
  streetContains?: InputMaybe<Scalars['String']['input']>;
  warrantyStatusIn?: InputMaybe<Array<WarrantyStatus>>;
  zipCodeContains?: InputMaybe<Scalars['String']['input']>;
};

export enum TimelineIntervalEnum {
  LastNinetyDays = 'lastNinetyDays',
  LastSevenDays = 'lastSevenDays',
  LastSixMonths = 'lastSixMonths',
  LastThirtyDays = 'lastThirtyDays',
  LastTwelveMonths = 'lastTwelveMonths'
}

export type UnarchiveLocationEnvironmentInput = {
  id: Scalars['ID']['input'];
  unarchiveEquipments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UnarchiveLocationSectorInput = {
  id: Scalars['ID']['input'];
  unarchiveEquipments: Scalars['Boolean']['input'];
};

export type UpdateContractInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCourseInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  coverPath?: InputMaybe<Scalars['String']['input']>;
  coverSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCourseSectionContentInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previousSectionContentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCourseSectionInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCoursesCategoryInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeadlineViolationReasonInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  deadlineContractIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEquipmentInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  customFields?: InputMaybe<Array<EquipmentCustomFieldInput>>;
  equipmentTypeId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  installedAt?: InputMaybe<Scalars['Date']['input']>;
  locationEnvironmentId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationSectorId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  purchasedAt?: InputMaybe<Scalars['Date']['input']>;
  qrCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExpenseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  receiptRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateExternalStorageProductInput = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  minimalQuantity?: InputMaybe<Scalars['Int']['input']>;
  minimalQuantityAtRisk?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateImportFileInput = {
  bucketName: Scalars['String']['input'];
  fileKey: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  updatedAt: Scalars['Datetime']['input'];
};

export type UpdateLocationEnvironmentInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocationSectorInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMaintenanceTypeInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  availableOnApp?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  mobileStartCompleteTaskValidationRadiusMeters?: InputMaybe<Scalars['Int']['input']>;
  mobileStartCompleteTaskValidationRadiusOn?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratingFormId?: InputMaybe<Scalars['ID']['input']>;
  sendEmailEmployeeRouteTrackingLinkWhenOnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailOrderReportLinkWhenCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailTaskRatingLinkWhenCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  signatureRequired?: InputMaybe<Scalars['Boolean']['input']>;
  ticketFormId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePaymentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdatePendencyAssigneeInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  readerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdatePendencyEventNoteInput = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type UpdatePendencyInput = {
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  maintenanceId?: InputMaybe<Scalars['ID']['input']>;
  pendencyTypeId?: InputMaybe<Scalars['ID']['input']>;
  readerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  treatmentType?: InputMaybe<PendencyTreatmentType>;
};

export type UpdatePendencyTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateProductCompanyInput = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  preferences?: InputMaybe<ProductServiceCompanyPreferencesInput>;
  value: Scalars['Float']['input'];
  valueType: ProductServiceValueType;
};

export type UpdateProductInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<ProductServiceCompanyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  measure?: InputMaybe<ProductServiceMeasure>;
  name?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['ID']['input']>;
  qrCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductTypeInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceInput = {
  companies?: InputMaybe<Array<ProductServiceCompanyInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStorageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStorageMovementInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateStorageProductInput = {
  id: Scalars['ID']['input'];
  minimalQuantity?: InputMaybe<Scalars['Int']['input']>;
  minimalQuantityAtRisk?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWarrantyInput = {
  attachments?: InputMaybe<Array<WarrantyAttachmentInput>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  coverageDurationDays: Scalars['Int']['input'];
  coverageStartedAt?: InputMaybe<Scalars['Date']['input']>;
  description: Scalars['String']['input'];
  extendedCoverageDurationDays: Scalars['Int']['input'];
  extendedValue: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  maintenanceTypesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type UpdateWarrantyTemplateInput = {
  attachments?: InputMaybe<Array<WarrantyAttachmentInput>>;
  coverageDurationDays?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extendedCoverageDurationDays?: InputMaybe<Scalars['Int']['input']>;
  extendedValue?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  maintenanceTypesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UploadCredential = {
  __typename?: 'UploadCredential';
  baseUrl: Scalars['String']['output'];
  bucketName: Scalars['String']['output'];
  fields: Scalars['JSON']['output'];
  fileKey: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export enum UploadCredentialEntityEnum {
  Contracts = 'contracts',
  CoursesContentExtraFile = 'coursesContentExtraFile',
  CoursesContentMainFile = 'coursesContentMainFile',
  CoursesImage = 'coursesImage',
  Equipments = 'equipments',
  Imports = 'imports',
  Maintenances = 'maintenances',
  Payments = 'payments',
  Pendencies = 'pendencies',
  Products = 'products',
  Services = 'services',
  Warranties = 'warranties'
}

export type UploadCredentialInput = {
  entity: UploadCredentialEntityEnum;
  extension: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  archived: Scalars['Boolean']['output'];
  authenticationInfo?: Maybe<AuthenticationInfo>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  email: Scalars['String']['output'];
  groups: Array<Group>;
  groupsConnection: GroupPagedResult;
  guest?: Maybe<Guest>;
  id: Scalars['ID']['output'];
  lastLoginAt?: Maybe<Scalars['Datetime']['output']>;
  loginIntegrationEnabled: Scalars['Boolean']['output'];
  loginProvider?: Maybe<Scalars['String']['output']>;
  mfaEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  preferences?: Maybe<UserPreferences>;
  role: UserRole;
  type: UserType;
};


export type UserGroupsConnectionArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<GroupOrderByInput>;
  where?: InputMaybe<GroupWhereInput>;
};

export enum UserAuthenticationStatus {
  Archived = 'ARCHIVED',
  Compromised = 'COMPROMISED',
  Confirmed = 'CONFIRMED',
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  ResetRequired = 'RESET_REQUIRED',
  Unconfirmed = 'UNCONFIRMED',
  Unknown = 'UNKNOWN'
}

export type UserGroup = {
  __typename?: 'UserGroup';
  group: Group;
  user: User;
};

export type UserInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  loginIntegrationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  loginProvider?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<UserPreferencesInput>;
  role?: InputMaybe<UserRole>;
  type?: InputMaybe<UserType>;
};

export type UserLookupResult = {
  __typename?: 'UserLookupResult';
  clientId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  loginIntegrationEnabled?: Maybe<Scalars['Boolean']['output']>;
  loginProvider?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  openIdConfigurationEndpoint?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export enum UserOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  LastLoginAtAsc = 'lastLoginAt_asc',
  LastLoginAtDesc = 'lastLoginAt_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  RoleAsc = 'role_asc',
  RoleDesc = 'role_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc'
}

export type UserPagedResult = {
  __typename?: 'UserPagedResult';
  items: Array<User>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  featureOpenedMaintenanceSendEmailNotification?: Maybe<Scalars['Boolean']['output']>;
};

export type UserPreferencesInput = {
  featureOpenedMaintenanceSendEmailNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UserPwa {
  Guests = 'guests',
  Users = 'users'
}

export enum UserRole {
  Admin = 'admin',
  Default = 'default',
  Owner = 'owner'
}

export type UserSnapshot = {
  __typename?: 'UserSnapshot';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum UserType {
  Admin = 'admin',
  All = 'all',
  Requester = 'requester'
}

export type UserWhereInput = {
  address_guests_contains?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  document_number_contains?: InputMaybe<Scalars['String']['input']>;
  email_contains?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  location_id?: InputMaybe<Scalars['String']['input']>;
  mfa_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_or_email_contains?: InputMaybe<Scalars['String']['input']>;
  role_in?: InputMaybe<Array<UserRole>>;
  type?: InputMaybe<UserWhereType>;
  type_in?: InputMaybe<Array<UserType>>;
};

export enum UserWhereType {
  Guests = 'guests',
  Users = 'users'
}

export enum WarrantiesOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  DescriptionAsc = 'description_asc',
  DescriptionDesc = 'description_desc',
  ExtendedCoverageDurationDaysAsc = 'extendedCoverageDurationDays_asc',
  ExtendedCoverageDurationDaysDesc = 'extendedCoverageDurationDays_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc'
}

export enum WarrantiesTemplatesOrderByInput {
  CreatedAtAsc = 'createdAt_asc',
  CreatedAtDesc = 'createdAt_desc',
  DescriptionAsc = 'description_asc',
  DescriptionDesc = 'description_desc',
  ExtendedCoverageDurationDaysAsc = 'extendedCoverageDurationDays_asc',
  ExtendedCoverageDurationDaysDesc = 'extendedCoverageDurationDays_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  TypeAsc = 'type_asc',
  TypeDesc = 'type_desc',
  UpdatedAtAsc = 'updatedAt_asc',
  UpdatedAtDesc = 'updatedAt_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc'
}

export type WarrantiesTemplatesPagedResult = {
  __typename?: 'WarrantiesTemplatesPagedResult';
  items: Array<WarrantyTemplate>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WarrantiesTemplatesWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  coverageDurationDaysEq?: InputMaybe<Scalars['Int']['input']>;
  coverageDurationDaysGte?: InputMaybe<Scalars['Int']['input']>;
  coverageDurationDaysLte?: InputMaybe<Scalars['Int']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  doesNotHaveExtendedCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  hasExtendedCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceTypeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type WarrantiesWhereInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  coverageDurationDaysEq?: InputMaybe<Scalars['Int']['input']>;
  coverageDurationDaysGte?: InputMaybe<Scalars['Int']['input']>;
  coverageDurationDaysLte?: InputMaybe<Scalars['Int']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  doesNotHaveExtendedCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  hasExtendedCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameEq?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Warranty = {
  __typename?: 'Warranty';
  archived: Scalars['Boolean']['output'];
  attachments: Array<WarrantyAttachment>;
  companies: Array<Company>;
  company?: Maybe<Company>;
  coverageDurationDays: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Datetime']['output']>;
  equipment?: Maybe<Equipment>;
  extendedCoverageDurationDays: Scalars['Int']['output'];
  extendedEndDate?: Maybe<Scalars['Datetime']['output']>;
  extendedValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  maintenance?: Maybe<Maintenance>;
  maintenancesTypes: Array<MaintenanceType>;
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Datetime']['output']>;
  status?: Maybe<WarrantyStatus>;
  template: WarrantyTemplate;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: User;
  value: Scalars['Float']['output'];
};

export type WarrantyAttachment = {
  __typename?: 'WarrantyAttachment';
  bucketName: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  download?: Maybe<Download>;
  fileKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type WarrantyAttachmentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  path: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum WarrantyMaintenanceStatus {
  Active = 'active',
  Extended = 'extended'
}

export enum WarrantyStatus {
  Active = 'active',
  Expired = 'expired',
  Extended = 'extended',
  Future = 'future'
}

export type WarrantySummary = {
  __typename?: 'WarrantySummary';
  count?: Maybe<WarrantySummaryCount>;
  createdAt: Scalars['Datetime']['output'];
  endDate?: Maybe<Scalars['Datetime']['output']>;
  extendedEndDate?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['Datetime']['output']>;
  status: WarrantyStatus;
  updatedAt: Scalars['Datetime']['output'];
};

export type WarrantySummaryCount = {
  __typename?: 'WarrantySummaryCount';
  equipment: Scalars['Int']['output'];
  maintenance: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WarrantyTemplate = {
  __typename?: 'WarrantyTemplate';
  account: Account;
  archived: Scalars['Boolean']['output'];
  attachments?: Maybe<Array<WarrantyAttachment>>;
  companies?: Maybe<Array<Company>>;
  coverageDurationDays: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  extendedCoverageDurationDays: Scalars['Int']['output'];
  extendedValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  maintenancesTypes?: Maybe<Array<MaintenanceType>>;
  name: Scalars['String']['output'];
  type: WarrantyType;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
  value: Scalars['Float']['output'];
  warranties?: Maybe<Array<Warranty>>;
};

export enum WarrantyType {
  Equipments = 'equipments',
  Maintenances = 'maintenances'
}

export type WebHook = {
  __typename?: 'WebHook';
  authentication: WebHookAuthentication;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  messageTypes?: Maybe<Array<WebHookMessageType>>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<User>;
  url: Scalars['String']['output'];
};

export type WebHookAuthentication = {
  __typename?: 'WebHookAuthentication';
  password?: Maybe<Scalars['String']['output']>;
  type: WebHookAuthenticationType;
  username?: Maybe<Scalars['String']['output']>;
};

export type WebHookAuthenticationInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  type: WebHookAuthenticationType;
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum WebHookAuthenticationType {
  Basic = 'BASIC',
  None = 'NONE'
}

export type WebHookDeliveriesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  direction: WebHookDeliveriesOrderDirection;
  limit: Scalars['Int']['input'];
  where?: InputMaybe<WebHookDeliveriesWhereInput>;
};

export enum WebHookDeliveriesOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type WebHookDeliveriesWhereInput = {
  deliveredAt_gte?: InputMaybe<Scalars['Datetime']['input']>;
  deliveredAt_lte?: InputMaybe<Scalars['Datetime']['input']>;
  messageType_in?: InputMaybe<Array<WebHookMessageType>>;
};

export type WebHookDelivery = {
  __typename?: 'WebHookDelivery';
  deliveredAt: Scalars['Datetime']['output'];
  messageId: Scalars['ID']['output'];
  messageType: WebHookMessageType;
  request: WebHookDeliveryResult;
  response: WebHookDeliveryResult;
  sortKey: Scalars['String']['output'];
};

export type WebHookDeliveryPagedResult = {
  __typename?: 'WebHookDeliveryPagedResult';
  items: Array<WebHookDelivery>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  pageInfo: PageInfo;
};

export type WebHookDeliveryResult = {
  __typename?: 'WebHookDeliveryResult';
  body?: Maybe<Scalars['JSON']['output']>;
  headers?: Maybe<Scalars['JSON']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type WebHookHealthCheck = {
  __typename?: 'WebHookHealthCheck';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type WebHookHealthCheckInput = {
  url: Scalars['String']['input'];
};

export enum WebHookMessageType {
  FormUpdated = 'FORM_UPDATED',
  MaintenanceCanceled = 'MAINTENANCE_CANCELED',
  MaintenanceCompleted = 'MAINTENANCE_COMPLETED',
  MaintenanceInProgress = 'MAINTENANCE_IN_PROGRESS',
  MaintenanceOnNegotiation = 'MAINTENANCE_ON_NEGOTIATION',
  MaintenancePending = 'MAINTENANCE_PENDING',
  MaintenanceReported = 'MAINTENANCE_REPORTED',
  MaintenanceRequested = 'MAINTENANCE_REQUESTED',
  MaintenanceScheduled = 'MAINTENANCE_SCHEDULED'
}

export type WebHookPagedResult = {
  __typename?: 'WebHookPagedResult';
  items: Array<WebHook>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  pageInfo: PageInfo;
};

export type WeekDayValuesInput = {
  friday?: InputMaybe<Scalars['Float']['input']>;
  monday?: InputMaybe<Scalars['Float']['input']>;
  saturday?: InputMaybe<Scalars['Float']['input']>;
  sunday?: InputMaybe<Scalars['Float']['input']>;
  thursday?: InputMaybe<Scalars['Float']['input']>;
  tuesday?: InputMaybe<Scalars['Float']['input']>;
  wednesday?: InputMaybe<Scalars['Float']['input']>;
};

export type WeekDayValuesType = {
  __typename?: 'WeekDayValuesType';
  friday?: Maybe<Scalars['Float']['output']>;
  monday?: Maybe<Scalars['Float']['output']>;
  saturday?: Maybe<Scalars['Float']['output']>;
  sunday?: Maybe<Scalars['Float']['output']>;
  thursday?: Maybe<Scalars['Float']['output']>;
  tuesday?: Maybe<Scalars['Float']['output']>;
  wednesday?: Maybe<Scalars['Float']['output']>;
};

export enum WeekdayInput {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

export type CompaniesPaginatedQueryVariables = Exact<{
  where?: InputMaybe<CompanyWhereInput>;
  orderBy?: InputMaybe<CompanyOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompaniesPaginatedQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Company', id: string, name: string, avatarUrl?: string | null, createdAt?: any | null, archived: boolean, fieldAccountId?: number | null, documentNumber?: string | null, address?: { __typename?: 'CompanyAddress', formattedAddress?: string | null } | null, fieldAccount?: { __typename?: 'CompanyFieldAccount', phone?: string | null, timezone?: string | null, accountType?: string | null, manager?: { __typename?: 'CompanyFieldAccountManager', email?: string | null, name?: string | null } | null } | null }> } };

export type EquipmentsPaginatedQueryVariables = Exact<{
  where?: InputMaybe<EquipmentWhereInput>;
  orderBy?: InputMaybe<EquipmentOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EquipmentsPaginatedQuery = { __typename?: 'Query', equipments: { __typename?: 'EquipmentPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Equipment', id: string, name?: string | null, number: string, notes?: string | null, archived: boolean, imageUrl?: string | null, type: { __typename?: 'EquipmentType', id: string, name: string }, location: { __typename?: 'Location', id: string, address?: { __typename?: 'Address', formattedAddress?: string | null } | null }, locationSector?: { __typename?: 'LocationSector', id: string } | null, locationEnvironment?: { __typename?: 'LocationEnvironment', id: string } | null, warranties: Array<{ __typename?: 'Warranty', name: string, startDate?: any | null, endDate?: any | null, extendedEndDate?: any | null, coverageDurationDays: number }>, warrantySummary?: { __typename?: 'WarrantySummary', id: string, status: WarrantyStatus, startDate?: any | null, endDate?: any | null, extendedEndDate?: any | null } | null }> } };

export type EquipmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EquipmentQuery = { __typename?: 'Query', equipment?: { __typename?: 'Equipment', id: string, name?: string | null, notes?: string | null, number: string, qrCode?: string | null, installedAt?: any | null, purchasedAt?: any | null, archived: boolean, type: { __typename?: 'EquipmentType', id: string, name: string }, location: { __typename?: 'Location', address?: { __typename?: 'Address', formattedAddress?: string | null } | null }, locationSector?: { __typename?: 'LocationSector', id: string, name: string } | null, locationEnvironment?: { __typename?: 'LocationEnvironment', id: string, name: string } | null, warrantySummary?: { __typename?: 'WarrantySummary', id: string, status: WarrantyStatus, startDate?: any | null, endDate?: any | null, extendedEndDate?: any | null, createdAt: any, updatedAt: any } | null, warranties: Array<{ __typename?: 'Warranty', name: string, startDate?: any | null, endDate?: any | null, extendedEndDate?: any | null, coverageDurationDays: number }> } | null };

export type EquipmentWithWarrantiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EquipmentWithWarrantiesQuery = { __typename?: 'Query', equipment?: { __typename?: 'Equipment', id: string, name?: string | null, warranties: Array<{ __typename?: 'Warranty', id: string, name: string, status?: WarrantyStatus | null, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number, endDate?: any | null, startDate?: any | null, extendedEndDate?: any | null, value: number, description: string, archived: boolean, createdAt: any, updatedAt: any, equipment?: { __typename?: 'Equipment', id: string, name?: string | null } | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string } | null, company?: { __typename?: 'Company', id: string, name: string } | null, template: { __typename?: 'WarrantyTemplate', id: string, name: string }, createdBy: { __typename?: 'User', id: string, name: string }, updatedBy: { __typename?: 'User', id: string, name: string }, companies: Array<{ __typename?: 'Company', id: string }>, maintenancesTypes: Array<{ __typename?: 'MaintenanceType', id: string, name: string }> }>, warrantySummary?: { __typename?: 'WarrantySummary', id: string, status: WarrantyStatus, startDate?: any | null, endDate?: any | null, extendedEndDate?: any | null, createdAt: any, updatedAt: any } | null } | null };

export type LocationEnvironmentsPaginatedQueryVariables = Exact<{
  where?: InputMaybe<LocationEnvironmentWhereInput>;
  orderBy?: InputMaybe<LocationEnvironmentOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationEnvironmentsPaginatedQuery = { __typename?: 'Query', locationEnvironments: { __typename?: 'LocationEnvironmentsPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'LocationEnvironment', id: string, name: string, archived: boolean, description?: string | null, locationSector: { __typename?: 'LocationSector', id: string, name: string, location: { __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null } } }> } };

export type LocationEnvironmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LocationEnvironmentQuery = { __typename?: 'Query', locationEnvironment: { __typename?: 'LocationEnvironment', id: string, name: string, qrCode?: string | null, archived: boolean, description?: string | null, locationSector: { __typename?: 'LocationSector', id: string, name: string, location: { __typename?: 'Location', address?: { __typename?: 'Address', formattedAddress?: string | null } | null } } } };

export type GetPaginatedLocationsGroupsQueryVariables = Exact<{
  where?: InputMaybe<LocationGroupWhereInput>;
  orderBy?: InputMaybe<LocationGroupOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaginatedLocationsGroupsQuery = { __typename?: 'Query', locationsGroups: { __typename?: 'LocationGroupPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'LocationGroup', id: string, name?: string | null }> } };

export type LocationSectorsPaginatedQueryVariables = Exact<{
  where?: InputMaybe<LocationSectorWhereInput>;
  orderBy?: InputMaybe<LocationSectorOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationSectorsPaginatedQuery = { __typename?: 'Query', locationSectors: { __typename?: 'LocationSectorsPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'LocationSector', id: string, name: string, archived: boolean, createdAt: any, description?: string | null, location: { __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null }, locationEnvironments: Array<{ __typename?: 'LocationEnvironment', id: string, name: string, qrCode?: string | null, description?: string | null, archived: boolean, createdAt: any }> }> } };

export type LocationSectorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LocationSectorQuery = { __typename?: 'Query', locationSector: { __typename?: 'LocationSector', id: string, name: string, archived: boolean, description?: string | null, location: { __typename?: 'Location', address?: { __typename?: 'Address', formattedAddress?: string | null } | null } } };

export type LocationsByCursorQueryVariables = Exact<{
  where?: InputMaybe<LocationsByCursorWhereInput>;
  orderBy?: InputMaybe<LocationsByCursorOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type LocationsByCursorQuery = { __typename?: 'Query', locationsByCursor: { __typename?: 'LocationCursorPagedResult', totalCount: number, pageInfo: { __typename?: 'CursorPageInfo', startCursor?: string | null, endCursor?: string | null }, items: Array<{ __typename?: 'Location', id: string, name?: string | null, archived?: boolean | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null, maintenances: Array<{ __typename?: 'Maintenance', id: string, status: MaintenanceStatus, locationSectors: Array<{ __typename?: 'LocationSector', id: string }>, locationEnvironments: Array<{ __typename?: 'LocationEnvironment', id: string }>, equipments: Array<{ __typename?: 'Equipment', id: string, warrantySummary?: { __typename?: 'WarrantySummary', status: WarrantyStatus } | null }> }> }> } };

export type LocationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, name?: string | null, notes?: string | null, archived?: boolean | null, documentNumber?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null, group?: { __typename?: 'LocationGroup', id: string, name?: string | null } | null, segments?: Array<{ __typename?: 'Segment', id: string, name: string } | null> | null } | null };

export type GetMaintenanceWithWarrantiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMaintenanceWithWarrantiesQuery = { __typename?: 'Query', maintenance?: { __typename?: 'Maintenance', id: string, warranties: Array<{ __typename?: 'Warranty', id: string, name: string, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number, endDate?: any | null, startDate?: any | null, extendedEndDate?: any | null, value: number, description: string, status?: WarrantyStatus | null, equipment?: { __typename?: 'Equipment', id: string, name?: string | null } | null, createdBy: { __typename?: 'User', id: string, name: string }, maintenancesTypes: Array<{ __typename?: 'MaintenanceType', id: string, name: string }>, template: { __typename?: 'WarrantyTemplate', id: string } }>, warrantySummary?: { __typename?: 'WarrantySummary', status: WarrantyStatus, startDate?: any | null, endDate?: any | null } | null, equipments: Array<{ __typename?: 'Equipment', id: string, name?: string | null, number: string, warranties: Array<{ __typename?: 'Warranty', id: string, name: string, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number, endDate?: any | null, startDate?: any | null, extendedEndDate?: any | null, value: number, description: string, status?: WarrantyStatus | null, company?: { __typename?: 'Company', id: string } | null, equipment?: { __typename?: 'Equipment', id: string, name?: string | null } | null, createdBy: { __typename?: 'User', id: string, name: string }, maintenancesTypes: Array<{ __typename?: 'MaintenanceType', id: string, name: string }>, template: { __typename?: 'WarrantyTemplate', id: string } }>, warrantySummary?: { __typename?: 'WarrantySummary', status: WarrantyStatus, startDate?: any | null, endDate?: any | null } | null }> } | null };

export type PendencyTypesPageQueryVariables = Exact<{
  where?: InputMaybe<PendencyTypeWhereInput>;
  orderBy?: InputMaybe<PendencyTypeOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PendencyTypesPageQuery = { __typename?: 'Query', pendencyTypes: { __typename?: 'PendencyTypePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'PendencyType', id: string, name: string, description?: string | null, createdAt: any, archived: boolean }> } };

export type PendencyTypeByNameQueryVariables = Exact<{
  nameEq: Scalars['String']['input'];
}>;


export type PendencyTypeByNameQuery = { __typename?: 'Query', pendencyTypes: { __typename?: 'PendencyTypePagedResult', items: Array<{ __typename?: 'PendencyType', id: string }> } };

export type PendencyTypeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PendencyTypeByIdQuery = { __typename?: 'Query', pendencyType: { __typename?: 'PendencyType', id: string, name: string, description?: string | null, archived: boolean } };

export type CreatePendencyTypeMutationVariables = Exact<{
  input: CreatePendencyTypeInput;
}>;


export type CreatePendencyTypeMutation = { __typename?: 'Mutation', createPendencyType: { __typename?: 'PendencyType', id: string } };

export type UpdatePendencyTypeMutationVariables = Exact<{
  input: UpdatePendencyTypeInput;
}>;


export type UpdatePendencyTypeMutation = { __typename?: 'Mutation', updatePendencyType: { __typename?: 'PendencyType', id: string } };

export type ArchivePendencyTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchivePendencyTypeMutation = { __typename?: 'Mutation', archivePendencyType: { __typename?: 'PendencyType', id: string } };

export type UnarchivePendencyTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchivePendencyTypeMutation = { __typename?: 'Mutation', unarchivePendencyType: { __typename?: 'PendencyType', id: string } };

export type ProductsServicesForTabQueryVariables = Exact<{
  where?: InputMaybe<ProductServiceWhereInput>;
  orderBy?: InputMaybe<ProductServiceOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductsServicesForTabQuery = { __typename?: 'Query', productsServices: { __typename?: 'ProductServicePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'ProductService', id: string, name: string, type: ProductServiceType }> } };

export type MaintenanceWithLinkedProductsServicesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  where?: InputMaybe<MaintenanceProductServiceWhereInput>;
}>;


export type MaintenanceWithLinkedProductsServicesQuery = { __typename?: 'Query', maintenance?: { __typename?: 'Maintenance', id: string, productsServices: { __typename?: 'MaintenanceProductServicePagedResult', items: Array<{ __typename?: 'MaintenanceProductService', quantity: number, value: number, item: { __typename?: 'ProductService', id: string, name: string } }> } } | null };

export type GetAuthenticatedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticatedUserQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', id?: string | null, name?: string | null, email?: string | null, avatarUrl?: string | null, type?: UserType | null, emailHash?: string | null, fieldNewsEmailHash?: string | null, role?: UserRole | null, loginIntegrationEnabled: boolean, account?: { __typename?: 'Account', id: string, name: string, slug?: string | null, featureFlags?: Array<{ __typename?: 'AccountFeatureFlag', name: string, active: boolean }> | null, preferences?: { __typename?: 'AccountPreferences', openMaintenance?: { __typename?: 'OpenMaintenancePreferences', featureDisableOpenMaintenanceOnPanel?: boolean | null, featureProblemRequired?: boolean | null, maintenanceNumberGenerator?: MaintenanceNumberGeneratorEnum | null } | null, forms?: { __typename?: 'FormsPreferences', questionsLimit?: number | null, featureFormsWithScoredOptions?: boolean | null } | null, quotations?: { __typename?: 'QuotationsPreferences', featureApproveQuotationByPanel?: boolean | null, featureApproveQuotationByLink?: boolean | null } | null, other?: { __typename?: 'OtherPreferences', featureLocationsPermissionsEnabled?: boolean | null } | null, storages?: { __typename?: 'StoragesPreferences', featureSharedStorages?: boolean | null, featureInternalStorages?: boolean | null } | null } | null } | null, preferences?: { __typename?: 'UserPreferences', featureOpenedMaintenanceSendEmailNotification?: boolean | null } | null, authenticationInfo?: { __typename?: 'AuthenticationInfo', enabled?: boolean | null, status?: UserAuthenticationStatus | null } | null, groups: Array<{ __typename?: 'Group', id: string, name?: string | null, permissions: Array<{ __typename?: 'Permission', name: string, category: string }> }> } | null };

export type QueryPagedUsersQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  orderBy?: InputMaybe<UserOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryPagedUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'User', id: string, name: string, email: string, archived: boolean, avatarUrl?: string | null }> } };

export type GetWarrantiesTemplatesBasicQueryVariables = Exact<{
  where?: InputMaybe<WarrantiesTemplatesWhereInput>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WarrantiesTemplatesOrderByInput>;
}>;


export type GetWarrantiesTemplatesBasicQuery = { __typename?: 'Query', warrantiesTemplates: { __typename?: 'WarrantiesTemplatesPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'WarrantyTemplate', id: string, name: string, description?: string | null, value: number, type: WarrantyType, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number, maintenancesTypes?: Array<{ __typename?: 'MaintenanceType', name: string }> | null }> } };

export type CreateWarrantyMutationVariables = Exact<{
  input: CreateWarrantyInput;
}>;


export type CreateWarrantyMutation = { __typename?: 'Mutation', createWarranty: { __typename?: 'Warranty', id: string, name: string, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number, endDate?: any | null, startDate?: any | null, extendedEndDate?: any | null, value: number, description: string, archived: boolean, equipment?: { __typename?: 'Equipment', id: string, name?: string | null } | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string } | null, template: { __typename?: 'WarrantyTemplate', id: string, name: string }, createdBy: { __typename?: 'User', id: string, name: string }, updatedBy: { __typename?: 'User', id: string, name: string }, companies: Array<{ __typename?: 'Company', id: string }>, maintenancesTypes: Array<{ __typename?: 'MaintenanceType', id: string }> } };

export type UpdateWarrantyMutationVariables = Exact<{
  input: UpdateWarrantyInput;
}>;


export type UpdateWarrantyMutation = { __typename?: 'Mutation', updateWarranty: { __typename?: 'Warranty', id: string, name: string, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number, endDate?: any | null, startDate?: any | null, extendedEndDate?: any | null, value: number, description: string, archived: boolean, equipment?: { __typename?: 'Equipment', id: string, name?: string | null } | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string } | null, template: { __typename?: 'WarrantyTemplate', id: string, name: string }, createdBy: { __typename?: 'User', id: string, name: string }, updatedBy: { __typename?: 'User', id: string, name: string }, companies: Array<{ __typename?: 'Company', id: string }>, maintenancesTypes: Array<{ __typename?: 'MaintenanceType', id: string }> } };

export type RemoveWarrantyMutationVariables = Exact<{
  input: RemoveWarrantyInput;
}>;


export type RemoveWarrantyMutation = { __typename?: 'Mutation', removeWarranty: { __typename?: 'Warranty', id: string } };

export type ManageFeatureFlagsMutationVariables = Exact<{
  input: ManageFeatureFlagsInput;
}>;


export type ManageFeatureFlagsMutation = { __typename?: 'Mutation', manageFeatureFlags?: { __typename?: 'Account', id: string, name: string, featureFlags?: Array<{ __typename?: 'AccountFeatureFlag', name: string, active: boolean }> | null } | null };

export type GetCompanyByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCompanyByIdQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null, archived: boolean, fieldAccountId?: number | null, address?: { __typename?: 'CompanyAddress', formattedAddress?: string | null } | null } | null };

export type GetCompanyWithStatsByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCompanyWithStatsByIdQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name: string, documentNumber?: string | null, avatarUrl?: string | null, address?: { __typename?: 'CompanyAddress', formattedAddress?: string | null } | null, stats?: { __typename?: 'CompanyStats', totalMaintenances?: number | null, averageRating?: number | null, lastMaintenance?: { __typename?: 'Maintenance', id: string, number: string } | null, lastRating?: { __typename?: 'TaskRating', stars?: number | null } | null } | null } | null };

export type GetCompanyByIdToDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCompanyByIdToDetailsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name: string, documentNumber?: string | null, archived: boolean, fieldAccountId?: number | null, updatedAt?: any | null, preferences?: { __typename?: 'CompanyPreferences', featureDisableEditTaskStatus?: boolean | null, featureHideCancelTicketButton?: boolean | null, featureDisableCreateEquipment?: boolean | null, featureDisableCreateEquipmentByApp?: boolean | null, featureQuotationServiceOrderRequired?: boolean | null, featureAssignedEmployeeRequired?: boolean | null, featurePendenciesEnabled?: boolean | null, featureAllowCompanyCreateRecurrence?: boolean | null, featureRecurrenceAssignedEmployeeRequired?: boolean | null, featureStorageControlEnabledByCMMS?: boolean | null, allowOpenMaintenanceForMaintenanceTypeIds?: Array<string> | null } | null, address?: { __typename?: 'CompanyAddress', countryCode?: string | null, zipCode?: string | null, city?: string | null, street?: string | null, number?: string | null, formattedAddress?: string | null, coords?: { __typename?: 'AddressCoords', latitude?: number | null, longitude?: number | null } | null } | null, fieldAccount?: { __typename?: 'CompanyFieldAccount', phone?: string | null, phoneCountryCode?: string | null, timezone?: string | null, accountType?: string | null, manager?: { __typename?: 'CompanyFieldAccountManager', email?: string | null, name?: string | null } | null } | null } | null };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null, archived: boolean, updatedAt?: any | null } };

export type ArchiveCompanyAndUnlinkServiceProviderMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type ArchiveCompanyAndUnlinkServiceProviderMutation = { __typename?: 'Mutation', archiveCompanyAndUnlinkServiceProvider: { __typename?: 'Company', id: string } };

export type CreateContractAttachmentMutationVariables = Exact<{
  input: ContractAttachmentCreateInput;
}>;


export type CreateContractAttachmentMutation = { __typename?: 'Mutation', createContractAttachment: { __typename?: 'ContractAttachment', id: string, path: string, title?: string | null, type: string, fileKey: string, createdAt: any } };

export type UpdateContractAttachmentTitleMutationVariables = Exact<{
  input: ContractAttachmentUpdateInput;
}>;


export type UpdateContractAttachmentTitleMutation = { __typename?: 'Mutation', updateContractAttachmentTitle: { __typename?: 'ContractAttachment', id: string } };

export type RemoveContractAttachmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveContractAttachmentMutation = { __typename?: 'Mutation', deleteContractAttachment: { __typename?: 'ContractAttachment', id: string } };

export type GetContractsPaginatedQueryVariables = Exact<{
  where?: InputMaybe<ContractWhereInput>;
  orderBy?: InputMaybe<ContractOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetContractsPaginatedQuery = { __typename?: 'Query', contracts: { __typename?: 'ContractPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Contract', id: string, identifier: string, name: string, status: ContractStatusEnum, startAt: any, description?: string | null, endAt: any, archived: boolean, company: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null }, dashboard?: { __typename?: 'ContractDashboard', progress: number } | null } | null> } };

export type GetContractByIdWithRecurrencesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContractByIdWithRecurrencesQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id: string, identifier: string, name: string, description?: string | null, startAt: any, endAt: any, archived: boolean, status: ContractStatusEnum, createdAt: string, updatedAt: string, attachments?: Array<{ __typename?: 'ContractAttachment', id: string, path: string, fileKey: string, bucketName: string, title?: string | null, type: string, size: number, createdAt: any }> | null, configuration?: { __typename?: 'ContractConfiguration', uniqueByEntity: boolean } | null, company: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null }, contractItems: Array<{ __typename?: 'ContractItem', repeatInterval?: RecurrenceIntervalEnum | null, repeatEvery?: number | null, startAt?: any | null, endAt?: any | null, configuration?: { __typename?: 'ContractItemConfiguration', isNonRecurring: boolean } | null, segment?: { __typename?: 'Segment', id: string, name: string } | null, maintenanceType?: { __typename?: 'MaintenanceType', id: string, name: string } | null, productsServices?: Array<{ __typename?: 'ProductService', id: string, name: string, productServiceCompanies: Array<{ __typename?: 'ProductServiceCompany', id: string, value: number, valueType: ProductServiceValueType, company: { __typename?: 'Company', id: string }, preferences?: { __typename?: 'ProductServiceCompanyPreferences', allowEditValue?: boolean | null, weekDayValues?: { __typename?: 'WeekDayValuesType', monday?: number | null, tuesday?: number | null, wednesday?: number | null, thursday?: number | null, friday?: number | null, saturday?: number | null, sunday?: number | null } | null } | null }> }> | null, deadlineContract?: { __typename?: 'DeadlineContract', id: string, name: string, solutionDeadline: { __typename?: 'DeadlineContractResponseSolution', unity: DeadlineContractResponseSolutionUnityEnum, valueInMinutes: number } } | null, itemLocations: Array<{ __typename?: 'ContractItemLocation', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, location: { __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null }, locationSectors?: Array<{ __typename?: 'ContractItemLocationSector', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, sector: { __typename?: 'LocationSector', id: string, name: string, description?: string | null }, locationSectorEnvironments?: Array<{ __typename?: 'ContractItemLocationEnvironment', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, environment: { __typename?: 'LocationEnvironment', id: string, name: string, description?: string | null }, locationSectorEnvironmentEquipments?: Array<{ __typename?: 'ContractItemLocationEquipment', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, equipment: { __typename?: 'Equipment', id: string, name?: string | null, number: string } }> | null }> | null, locationSectorEquipments?: Array<{ __typename?: 'ContractItemLocationEquipment', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, equipment: { __typename?: 'Equipment', id: string, name?: string | null, number: string } }> | null }> | null, locationEquipments?: Array<{ __typename?: 'ContractItemLocationEquipment', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, equipment: { __typename?: 'Equipment', id: string, name?: string | null, number: string } }> | null }> }>, dashboard?: { __typename?: 'ContractDashboard', progress: number, updatedAt: string, activities: { __typename?: 'ContractDashboardActivities', totalMaintenances: number, completedMaintenances: number, totalOccurrences: number, completedOccurrences: number }, deadlines: { __typename?: 'ContractDashboardDeadlines', pending: number, onTime: number, atRisk: number, violated: number, completedOnTime: number, completedWithViolation: number, avgResolutionTimeMinutes: number, maintenancesResolvedOnTimePercent: number, topViolationReasons: Array<{ __typename?: 'ContractDashboardViolationReason', label: string, count: number }> }, maintenanceTypesSummary: Array<{ __typename?: 'ContractDashboardMaintenanceTypeSummary', maintenanceTypeId: string, maintenanceTypeName: string, completed: number, planned: number }> } | null } | null };

export type GetContractOccurrencesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContractOccurrencesQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id: string, contractItems: Array<{ __typename?: 'ContractItem', itemLocations: Array<{ __typename?: 'ContractItemLocation', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, locationSectors?: Array<{ __typename?: 'ContractItemLocationSector', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, locationSectorEnvironments?: Array<{ __typename?: 'ContractItemLocationEnvironment', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, locationSectorEnvironmentEquipments?: Array<{ __typename?: 'ContractItemLocationEquipment', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null }> | null }> | null, locationSectorEquipments?: Array<{ __typename?: 'ContractItemLocationEquipment', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null }> | null }> | null, locationEquipments?: Array<{ __typename?: 'ContractItemLocationEquipment', recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null }> | null }> }> } | null };

export type ContractIdentifierExistsQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;


export type ContractIdentifierExistsQuery = { __typename?: 'Query', contractIdentifierExists: boolean };

export type CreateContractMutationVariables = Exact<{
  input: CreateContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'Contract', id: string, contractItems: Array<{ __typename?: 'ContractItem', configuration?: { __typename?: 'ContractItemConfiguration', isNonRecurring: boolean } | null, segment?: { __typename?: 'Segment', id: string, name: string } | null, maintenanceType?: { __typename?: 'MaintenanceType', id: string, name: string } | null, itemLocations: Array<{ __typename?: 'ContractItemLocation', location: { __typename?: 'Location', id: string, name?: string | null }, recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, locationSectors?: Array<{ __typename?: 'ContractItemLocationSector', sector: { __typename?: 'LocationSector', id: string, name: string }, recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, locationSectorEnvironments?: Array<{ __typename?: 'ContractItemLocationEnvironment', environment: { __typename?: 'LocationEnvironment', id: string, name: string }, recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null, locationSectorEnvironmentEquipments?: Array<{ __typename?: 'ContractItemLocationEquipment', equipment: { __typename?: 'Equipment', id: string, name?: string | null }, recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null }> | null }> | null, locationSectorEquipments?: Array<{ __typename?: 'ContractItemLocationEquipment', equipment: { __typename?: 'Equipment', id: string, name?: string | null }, recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null }> | null }> | null, locationEquipments?: Array<{ __typename?: 'ContractItemLocationEquipment', equipment: { __typename?: 'Equipment', id: string, name?: string | null }, recurrence?: { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null } | null }> | null }> }> } };

export type ActivateContractMutationVariables = Exact<{
  input: ActiveContractInput;
}>;


export type ActivateContractMutation = { __typename?: 'Mutation', activeContract: { __typename?: 'Contract', id: string } };

export type CancelContractMutationVariables = Exact<{
  input: CancelContractInput;
}>;


export type CancelContractMutation = { __typename?: 'Mutation', cancelContract: { __typename?: 'Contract', id: string } };

export type ArchiveContractMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveContractMutation = { __typename?: 'Mutation', archiveContract: { __typename?: 'Contract', id: string } };

export type UnarchiveContractMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveContractMutation = { __typename?: 'Mutation', unarchiveContract: { __typename?: 'Contract', id: string } };

export type UpdateContractMutationVariables = Exact<{
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: { __typename?: 'Contract', id: string } };

export type GenerateContractIdentifierMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateContractIdentifierMutation = { __typename?: 'Mutation', generateContractIdentifier: { __typename?: 'ContractIdentifierResult', identifier: string } };

export type RecurrenceFieldsFragment = { __typename?: 'Recurrence', id: string, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, occurrences?: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', name: string } | null } | null }> } | null, repeat?: { __typename?: 'Repeat', from: any, until?: any | null, interval: IntervalInput, every: number } | null };

export type DeadlineContractsQueryVariables = Exact<{
  where?: InputMaybe<DeadlineContractWhereInput>;
  orderBy?: InputMaybe<DeadlineContractOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DeadlineContractsQuery = { __typename?: 'Query', deadlineContracts: { __typename?: 'DeadlineContractPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'DeadlineContract', id: string, name: string, solutionDeadline: { __typename?: 'DeadlineContractResponseSolution', valueInMinutes: number, unity: DeadlineContractResponseSolutionUnityEnum } }> } };

export type ExternalStorageProductsPaginatedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where: ExternalStorageProductWhereInput;
  orderBy?: InputMaybe<ExternalStorageProductsOrderByInput>;
}>;


export type ExternalStorageProductsPaginatedQuery = { __typename?: 'Query', externalStorageProducts: { __typename?: 'ExternalStorageProductPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'ExternalStorageProduct', id: string, quantity: number, storage: { __typename?: 'ExternalStorage', id: string }, product: { __typename?: 'ExternalProduct', id: string, name: string } }> } };

export type FormsQueryVariables = Exact<{
  where?: InputMaybe<FormWhereInput>;
  orderBy?: InputMaybe<FormOrderByInput>;
}>;


export type FormsQuery = { __typename?: 'Query', forms: { __typename?: 'FormPagedResult', items: Array<{ __typename?: 'Form', id: string, name: string, archived: boolean, questions: Array<{ __typename?: 'Question', id: string, title: string, type: QuestionTypeEnum, position: number, required: boolean, options: Array<{ __typename?: 'Option', id: string, value?: string | null, position: number }>, conditions: Array<{ __typename?: 'QuestionCondition', operator: OperatorEnum, value: string, question: { __typename?: 'QuestionReference', id?: string | null } }> }> } | null> } };

export type FormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormQuery = { __typename?: 'Query', form?: { __typename?: 'Form', id: string, name: string, archived: boolean, questions: Array<{ __typename?: 'Question', id: string, title: string, type: QuestionTypeEnum, position: number, required: boolean, options: Array<{ __typename?: 'Option', id: string, value?: string | null, position: number }>, conditions: Array<{ __typename?: 'QuestionCondition', operator: OperatorEnum, value: string, question: { __typename?: 'QuestionReference', id?: string | null } }> }> } | null };

export type InvitesQueryVariables = Exact<{
  where?: InputMaybe<InvitesWhereInput>;
}>;


export type InvitesQuery = { __typename?: 'Query', invites: Array<{ __typename?: 'Invite', id: string, email: string, status: InviteStatus, sentAt?: any | null, expiredAt?: any | null, acceptedAt?: any | null, refusedAt?: any | null }> };

export type CreateInviteMutationVariables = Exact<{
  input: CreateInviteInput;
}>;


export type CreateInviteMutation = { __typename?: 'Mutation', createInvite: { __typename?: 'CreateInviteResult', alreadyPending: Array<string>, alreadyAccepted: Array<string>, created: Array<{ __typename?: 'Invite', id: string, email: string, status: InviteStatus, sentAt?: any | null, expiredAt?: any | null, acceptedAt?: any | null, refusedAt?: any | null }> } };

export type ResendInviteMutationVariables = Exact<{
  inviteId: Scalars['ID']['input'];
}>;


export type ResendInviteMutation = { __typename?: 'Mutation', resendInvite: { __typename?: 'Invite', id: string, status: InviteStatus, sentAt?: any | null, expiredAt?: any | null } };

export type IsJourneyFormSubmittedQueryVariables = Exact<{ [key: string]: never; }>;


export type IsJourneyFormSubmittedQuery = { __typename?: 'Query', journey?: { __typename?: 'Journey', status: JourneyStatusEnum } | null };

export type GetJourneyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJourneyQuery = { __typename?: 'Query', journey?: { __typename?: 'Journey', overallProgress?: number | null, status: JourneyStatusEnum, steps?: { __typename?: 'JourneySteps', essential: { __typename?: 'JourneyStepEssential', maintenanceType?: boolean | null, locations?: boolean | null, segments?: boolean | null, companies?: boolean | null }, operation: { __typename?: 'JourneyStepOperation', operationsStructure?: { __typename?: 'JourneyOperationsStructure', equipment?: boolean | null, equipmentTypes?: boolean | null } | null, costResource?: { __typename?: 'JourneyCostResource', services?: boolean | null, expenses?: boolean | null } | null, stockControl?: { __typename?: 'JourneyStockControl', products?: boolean | null, storageMovements?: boolean | null, storageProducts?: boolean | null } | null, standardization?: { __typename?: 'JourneyStandardization', form?: boolean | null } | null, rules?: { __typename?: 'JourneyRules', contracts?: boolean | null, deadlines?: boolean | null, warranties?: boolean | null } | null }, configuration: { __typename?: 'JourneyStepConfiguration', accountRules?: { __typename?: 'JourneyAccountRules', users?: boolean | null, permissionGroups?: boolean | null } | null } } | null } | null };

export type JourneyFormQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type JourneyFormQuestionsQuery = { __typename?: 'Query', journeyFormQuestions: Array<{ __typename?: 'JourneyFormQuestion', key: JourneyQuestionKeyEnum, position: number, metadata: any, translations: Array<{ __typename?: 'JourneyQuestionTranslation', locale: LocaleEnum, title: string, description: string }>, options: Array<{ __typename?: 'JourneyFormQuestionOption', key: string, is_recommended: boolean, translations: Array<{ __typename?: 'JourneyQuestionOptionTranslation', locale: LocaleEnum, label: string, description?: string | null }> }> }> };

export type SubmitJourneyFormMutationVariables = Exact<{
  input: SubmitJourneyFormInput;
}>;


export type SubmitJourneyFormMutation = { __typename?: 'Mutation', submitJourneyForm: { __typename?: 'Journey', id: string, status: JourneyStatusEnum } };

export type CompleteJourneyMutationVariables = Exact<{ [key: string]: never; }>;


export type CompleteJourneyMutation = { __typename?: 'Mutation', completeJourney: { __typename?: 'Journey', overallProgress?: number | null, status: JourneyStatusEnum } };

export type PaginatedLocationsQueryVariables = Exact<{
  where?: InputMaybe<LocationWhereInput>;
  orderBy?: InputMaybe<LocationOrderByObjectInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedLocationsQuery = { __typename?: 'Query', locationsNew: { __typename?: 'LocationPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null }> } };

export type GetLocationsAddressesQueryVariables = Exact<{
  where?: InputMaybe<LocationWhereInput>;
  orderBy?: InputMaybe<LocationOrderByObjectInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLocationsAddressesQuery = { __typename?: 'Query', locationsNew: { __typename?: 'LocationPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null }> } };

export type GetLocationsWithChildrensQueryVariables = Exact<{
  where?: InputMaybe<LocationWhereInput>;
  orderBy?: InputMaybe<LocationOrderByObjectInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLocationsWithChildrensQuery = { __typename?: 'Query', locationsNew: { __typename?: 'LocationPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Location', id: string, name?: string | null, segments?: Array<{ __typename?: 'Segment', id: string } | null> | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null, equipments: Array<{ __typename?: 'Equipment', id: string, number: string, name?: string | null, type: { __typename?: 'EquipmentType', segment: { __typename?: 'Segment', id: string } } }>, sectors: Array<{ __typename?: 'LocationSector', id: string, name: string, description?: string | null, equipmentsWithoutEnvironment?: Array<{ __typename?: 'Equipment', id: string, number: string, name?: string | null, type: { __typename?: 'EquipmentType', segment: { __typename?: 'Segment', id: string } } }> | null, locationEnvironments: Array<{ __typename?: 'LocationEnvironment', id: string, name: string, description?: string | null, equipments?: Array<{ __typename?: 'Equipment', id: string, number: string, name?: string | null, type: { __typename?: 'EquipmentType', segment: { __typename?: 'Segment', id: string } } }> | null }> }> }> } };

export type PaginatedMaintenanceTypesQueryVariables = Exact<{
  where?: InputMaybe<MaintenanceTypeWhereInput>;
  orderBy?: InputMaybe<MaintenanceTypeOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedMaintenanceTypesQuery = { __typename?: 'Query', maintenanceTypes: { __typename?: 'MaintenanceTypePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'MaintenanceType', id: string, name: string }> } };

export type GetPaginatedMaintenancesQueryVariables = Exact<{
  where?: InputMaybe<MaintenanceWhereInput>;
  orderBy?: InputMaybe<MaintenanceOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaginatedMaintenancesQuery = { __typename?: 'Query', maintenances: { __typename?: 'MaintenancePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, message?: string | null, openedAt?: any | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, segment: { __typename?: 'Segment', id: string, name: string }, maintenanceType?: { __typename?: 'MaintenanceType', id: string, name: string } | null, warrantySummary?: { __typename?: 'WarrantySummary', status: WarrantyStatus, startDate?: any | null, extendedEndDate?: any | null } | null }> } };

export type StoragesMovementsPaginatedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoragesMovementsWhereInput>;
  orderBy?: InputMaybe<StoragesMovementsOrderByInput>;
}>;


export type StoragesMovementsPaginatedQuery = { __typename?: 'Query', storagesMovements: { __typename?: 'StorageMovementPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'StorageMovement', id: string, type: StorageMovementType, createdAt: any, createdByAvatarUrl?: string | null, createdByName?: string | null, quantity: { __typename?: 'StorageMovementQuantity', changed: number }, storage?: { __typename?: 'Storage', id: string, name: string } | null, externalStorage?: { __typename?: 'ExternalStorage', id: string, name: string } | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string } | null, product: { __typename?: 'Product', id: string, name: string, imageUrl?: string | null, measure?: ProductServiceMeasure | null, productType?: { __typename?: 'ProductType', id: string, name: string } | null }, company?: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } | null, createdBy?: { __typename?: 'User', name: string, avatarUrl?: string | null } | null }> } };

export type StorageMovementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StorageMovementQuery = { __typename?: 'Query', storageMovement?: { __typename?: 'StorageMovement', id: string, description: string, createdByName?: string | null, createdByAvatarUrl?: string | null, type: StorageMovementType, createdAt: any, updatedAt: any, company?: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } | null, maintenance?: { __typename?: 'Maintenance', id: string, number: string } | null, storage?: { __typename?: 'Storage', id: string, name: string } | null, externalStorage?: { __typename?: 'ExternalStorage', name: string, employee?: { __typename?: 'ExternalStorageEmployee', name: string, avatarUrl?: string | null } | null } | null, externalStorageMovement?: { __typename?: 'ExternalStorageMovement', quantity: number, oldQuantity: number } | null, relatedStorageMovement?: { __typename?: 'StorageMovement', quantity: { __typename?: 'StorageMovementQuantity', previous: number, changed: number, current: number }, storage?: { __typename?: 'Storage', id: string, name: string } | null, externalStorage?: { __typename?: 'ExternalStorage', id: string, name: string } | null } | null, quantity: { __typename?: 'StorageMovementQuantity', previous: number, changed: number, current: number }, product: { __typename?: 'Product', id: string, name: string, code?: string | null, imageUrl?: string | null, measure?: ProductServiceMeasure | null, productType?: { __typename?: 'ProductType', id: string, name: string } | null }, createdBy?: { __typename?: 'User', name: string, avatarUrl?: string | null } | null, updatedBy?: { __typename?: 'User', name: string, avatarUrl?: string | null } | null, sync?: { __typename?: 'StorageMovementSync', status?: StorageMovementSyncStatus | null } | null } | null };

export type CreateStorageMovementMutationVariables = Exact<{
  input: CreateStorageMovementInput;
}>;


export type CreateStorageMovementMutation = { __typename?: 'Mutation', createStorageMovement: Array<{ __typename?: 'StorageMovement', id: string }> };

export type UpdateStorageMovementMutationVariables = Exact<{
  input: UpdateStorageMovementInput;
}>;


export type UpdateStorageMovementMutation = { __typename?: 'Mutation', updateStorageMovement: { __typename?: 'StorageMovement', id: string, updatedAt: any } };

export type GetPaginatedOccurrencesQueryVariables = Exact<{
  where: OccurrenceWhereInput;
  orderBy?: InputMaybe<OccurrenceOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaginatedOccurrencesQuery = { __typename?: 'Query', occurrences: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null }> } };

export type GetOccurrencesWithMaintenanceQueryVariables = Exact<{
  where: OccurrenceWhereInput;
  orderBy?: InputMaybe<OccurrenceOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOccurrencesWithMaintenanceQuery = { __typename?: 'Query', occurrences: { __typename?: 'OccurrencePagedResult', totalCount: number, items: Array<{ __typename?: 'Occurrence', id: string, iteration: number, scheduledAt?: any | null, scheduledDate: any, scheduledType?: IntervalInput | null, maintenance?: { __typename?: 'Maintenance', id: string, status: MaintenanceStatus, assignee?: { __typename?: 'User', id: string, name: string } | null } | null }> } };

export type GetPaymentLogsQueryVariables = Exact<{
  where?: InputMaybe<PaymentLogWhereInput>;
  orderBy?: InputMaybe<PaymentLogOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaymentLogsQuery = { __typename?: 'Query', paymentLogs: { __typename?: 'PaymentLogsPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'PaymentLog', type: PaymentLogTypeEnum, createdAt: any, clientApplicationName: PaymentLogClientApplicationNameEnum, data?: { __typename?: 'PaymentLogData', cancellationReason?: string | null } | null, autor: { __typename?: 'PaymentUser', name: string, avatarUrl?: string | null } }> } };

export type PaginatedPaymentsQueryVariables = Exact<{
  where?: InputMaybe<PaymentWhereInput>;
  orderBy?: InputMaybe<PaymentOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedPaymentsQuery = { __typename?: 'Query', payments: { __typename?: 'PaymentPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Payment', id: string, number: string, description?: string | null, status: PaymentStatusEnum, totalValue: number, archived: boolean, createdAt: any, createdBy: { __typename?: 'PaymentUser', id: string, name: string, avatarUrl?: string | null }, company: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } }> } };

export type GetPaymentByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPaymentByIdQuery = { __typename?: 'Query', payment?: { __typename?: 'Payment', id: string, number: string, description?: string | null, status: PaymentStatusEnum, totalValue: number, archived: boolean, createdAt: any, attachments: Array<{ __typename?: 'PaymentAttachment', id: string, title?: string | null, path: string, createdAt: any }>, maintenancesConnection?: { __typename?: 'MaintenancePagedResult', totalCount: number, items: Array<{ __typename?: 'Maintenance', id: string }> } | null, createdBy: { __typename?: 'PaymentUser', id: string, name: string, avatarUrl?: string | null }, company: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null }, quotationsConnection?: { __typename?: 'QuotationPagedResult', items: Array<{ __typename?: 'Quotation', id: string }> } | null } | null };

export type NextPaymentNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type NextPaymentNumberQuery = { __typename?: 'Query', nextPaymentNumber: { __typename?: 'NextPaymentNumberResult', number: string } };

export type ListPaymentMaintenancesQueryVariables = Exact<{
  where?: InputMaybe<MaintenanceWhereInput>;
  orderBy?: InputMaybe<MaintenanceOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListPaymentMaintenancesQuery = { __typename?: 'Query', maintenances: { __typename?: 'MaintenancePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Maintenance', id: string, number: string, status: MaintenanceStatus, openedAt?: any | null, closedAt?: any | null, productsTotalValue?: number | null, servicesTotalValue?: number | null, totalValue?: number | null, orderId?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, maintenanceType?: { __typename?: 'MaintenanceType', id: string, name: string } | null, segment: { __typename?: 'Segment', id: string, name: string } }> } };

export type CreatePaymentMutationVariables = Exact<{
  input: CreatePaymentInput;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment: { __typename?: 'Payment', id: string, number: string, updatedAt: any } };

export type UpdatePaymentMutationVariables = Exact<{
  input: UpdatePaymentInput;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'Payment', id: string, number: string, updatedAt: any } };

export type ArchivePaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchivePaymentMutation = { __typename?: 'Mutation', archivePayment: { __typename?: 'Payment', id: string } };

export type UnarchivePaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchivePaymentMutation = { __typename?: 'Mutation', unarchivePayment: { __typename?: 'Payment', id: string } };

export type MarkPaymentAsPaidMutationVariables = Exact<{
  input: MarkPaymentAsPaidInput;
}>;


export type MarkPaymentAsPaidMutation = { __typename?: 'Mutation', markPaymentAsPaid: { __typename?: 'Payment', id: string, status: PaymentStatusEnum, updatedAt: any } };

export type ListPaymentQuotationsQueryVariables = Exact<{
  where?: InputMaybe<QuotationWhereInput>;
  orderBy?: InputMaybe<QuotationOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListPaymentQuotationsQuery = { __typename?: 'Query', quotations: { __typename?: 'QuotationPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Quotation', id: string, identifier: string, name: string, status: QuotationStatus, createdAt?: any | null, approvedAt?: any | null, expensesTotalValue: number, total: number, productsServicesTotalValues: { __typename?: 'ProductsServicesTotalValues', productsTotalValue: number, servicesTotalValue: number }, maintenance?: { __typename?: 'Maintenance', id: string, status: MaintenanceStatus, maintenanceType?: { __typename?: 'MaintenanceType', id: string, name: string } | null, segment: { __typename?: 'Segment', id: string, name: string } } | null, location: { __typename?: 'Location', id: string, name?: string | null } }> } };

export type RemoveMaintenancesFromPaymentMutationVariables = Exact<{
  input: RemoveMaintenancesFromPaymentInput;
}>;


export type RemoveMaintenancesFromPaymentMutation = { __typename?: 'Mutation', removeMaintenancesFromPayment: { __typename?: 'Payment', id: string, updatedAt: any } };

export type AddMaintenancesToPaymentMutationVariables = Exact<{
  input: AddMaintenancesToPaymentInput;
}>;


export type AddMaintenancesToPaymentMutation = { __typename?: 'Mutation', addMaintenancesToPayment: { __typename?: 'Payment', id: string, updatedAt: any } };

export type AddQuotationsToPaymentMutationVariables = Exact<{
  input: AddQuotationsToPaymentInput;
}>;


export type AddQuotationsToPaymentMutation = { __typename?: 'Mutation', addQuotationsToPayment: { __typename?: 'Payment', id: string, updatedAt: any } };

export type RemoveQuotationsFromPaymentMutationVariables = Exact<{
  input: RemoveQuotationsFromPaymentInput;
}>;


export type RemoveQuotationsFromPaymentMutation = { __typename?: 'Mutation', removeQuotationsFromPayment: { __typename?: 'Payment', id: string, updatedAt: any } };

export type ProductsServicesPaginatedQueryVariables = Exact<{
  where?: InputMaybe<ProductServiceWhereInput>;
  orderBy?: InputMaybe<ProductServiceOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductsServicesPaginatedQuery = { __typename?: 'Query', productsServices: { __typename?: 'ProductServicePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'ProductService', id: string }> } };

export type PaginatedProductTypesQueryVariables = Exact<{
  where?: InputMaybe<ProductTypeWhereInput>;
  orderBy?: InputMaybe<ProductTypeOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedProductTypesQuery = { __typename?: 'Query', productTypes: { __typename?: 'ProductTypePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'ProductType', id: string, name: string, description?: string | null }> } };

export type ProductsPaginatedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductsWhereInput>;
  orderBy?: InputMaybe<ProductsOrderByInput>;
  companyId: Scalars['ID']['input'];
  includeCompanyProduct?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductsPaginatedQuery = { __typename?: 'Query', products: { __typename?: 'ProductPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Product', id: string, name: string, code?: string | null, imageUrl?: string | null, measure?: ProductServiceMeasure | null, productCompany?: { __typename?: 'ProductCompany', fieldProductServiceId?: string | null } | null }> } };

export type GetPaginatedSegmentsQueryVariables = Exact<{
  where?: InputMaybe<SegmentWhereInput>;
  orderBy?: InputMaybe<SegmentOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaginatedSegmentsQuery = { __typename?: 'Query', segments: { __typename?: 'SegmentPagedResult', totalCount: number, items: Array<{ __typename?: 'Segment', id: string, name: string }> } };

export type ServicesPaginatedQueryVariables = Exact<{
  where?: InputMaybe<ServiceWhereInput>;
  orderBy?: InputMaybe<ServiceOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ServicesPaginatedQuery = { __typename?: 'Query', services: { __typename?: 'ServicePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Service', id: string, name: string, measure?: ProductServiceMeasure | null, value: number }> } };

export type ServicesCompaniesPaginatedQueryVariables = Exact<{
  where?: InputMaybe<ServiceWhereInput>;
  orderBy?: InputMaybe<ServiceOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ServicesCompaniesPaginatedQuery = { __typename?: 'Query', services: { __typename?: 'ServicePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Service', id: string, name: string, companies: Array<{ __typename?: 'ProductServiceCompany', id: string, value: number, valueType: ProductServiceValueType, company: { __typename?: 'Company', id: string }, preferences?: { __typename?: 'ProductServiceCompanyPreferences', allowEditValue?: boolean | null, weekDayValues?: { __typename?: 'WeekDayValuesType', monday?: number | null, tuesday?: number | null, wednesday?: number | null, thursday?: number | null, friday?: number | null, saturday?: number | null, sunday?: number | null } | null } | null }> }> } };

export type InternalStoragesPaginatedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoragesWhereInput>;
  orderBy?: InputMaybe<StoragesOrderByInput>;
}>;


export type InternalStoragesPaginatedQuery = { __typename?: 'Query', storages: { __typename?: 'StoragePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Storage', id: string, name: string }> } };

export type InternalStoragePaginatedQueryVariables = Exact<{
  ID: Scalars['ID']['input'];
}>;


export type InternalStoragePaginatedQuery = { __typename?: 'Query', storage?: { __typename?: 'Storage', id: string, name: string, archived: boolean, description?: string | null, createdAt: any, updatedAt?: any | null, createdBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null, type: UserType }, updatedBy?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null, type: UserType } | null, products: { __typename?: 'StorageProductPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'StorageProduct', id: string, quantity: number, minimalQuantity?: number | null, minimalQuantityAtRisk?: number | null, createdAt: any, updatedAt?: any | null, product: { __typename?: 'Product', id: string, name: string, code?: string | null, imageUrl?: string | null, measure?: ProductServiceMeasure | null }, createdBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null, type: UserType }, updatedBy?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null, type: UserType } | null }> } } | null };

export type ExternalStoragesPaginatedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where: ExternalStoragesWhereInput;
  orderBy?: InputMaybe<ExternalStoragesOrderByInput>;
}>;


export type ExternalStoragesPaginatedQuery = { __typename?: 'Query', externalStorages: { __typename?: 'ExternalStoragePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'ExternalStorage', id: string, name: string, description?: string | null, archived: boolean, employee?: { __typename?: 'ExternalStorageEmployee', id: string, name: string, avatarUrl?: string | null } | null, storageProduct?: { __typename?: 'StorageProduct', quantity: number, product: { __typename?: 'Product', name: string } } | null }> } };

export type TicketQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TicketQuery = { __typename?: 'Query', ticket?: { __typename?: 'Ticket', id: string, number: string, message?: string | null, clientApplicationName?: string | null, addressHash?: string | null, cancelationReason?: string | null, archived: boolean, status: TicketStatus, updatedAt?: any | null, createdAt?: any | null, formAnswers: Array<{ __typename?: 'FormAnswer', id: string, name: string, archived: boolean, status?: FormAnswerStatusEnum | null, createdAt: any, updatedAt?: any | null, type: string, questionAnswers?: Array<{ __typename?: 'QuestionAnswer', id: string, title: string, answer?: string | null, type: QuestionTypeEnum, position: number, required: boolean, createdAt: any, answeredAt: any, options?: Array<{ __typename?: 'Option', id: string, value?: string | null, position: number, score?: number | null } | null> | null, conditions?: Array<{ __typename?: 'QuestionCondition', operator: OperatorEnum, value: string, question: { __typename?: 'QuestionReference', id?: string | null } } | null> | null }> | null, equipment?: { __typename?: 'Equipment', id: string, name?: string | null } | null }>, address?: { __typename?: 'TicketAddress', zipCode: string, street: string, city: string, number?: string | null, complement?: string | null, neighborhood: string, state: string, formattedAddress?: string | null, coords: { __typename?: 'AddressCoords', latitude?: number | null, longitude?: number | null } } | null, segment: { __typename?: 'Segment', id: string, name: string }, attachments: Array<{ __typename?: 'TicketAttachment', id: string, path: string, title?: string | null, type: string, size: number, createdAt: any }>, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, requester?: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null, guest?: { __typename?: 'Guest', documentNumber?: string | null, phoneNumber?: string | null, locations: Array<{ __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null }> } | null } | null, updatedBy?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null, equipments: Array<{ __typename?: 'Equipment', id: string, number: string, name?: string | null, type: { __typename?: 'EquipmentType', id: string, name: string }, warranties: Array<{ __typename?: 'Warranty', id: string, name: string, status?: WarrantyStatus | null, startDate?: any | null, endDate?: any | null, extendedEndDate?: any | null, coverageDurationDays: number, extendedCoverageDurationDays: number, value: number, extendedValue: number, description: string, equipment?: { __typename?: 'Equipment', id: string, name?: string | null } | null }>, warrantySummary?: { __typename?: 'WarrantySummary', id: string, status: WarrantyStatus, startDate?: any | null, endDate?: any | null, extendedEndDate?: any | null, createdAt: any, updatedAt: any } | null, locationSector?: { __typename?: 'LocationSector', id: string, name: string } | null, locationEnvironment?: { __typename?: 'LocationEnvironment', id: string, name: string } | null, location: { __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null } }>, locationSectors: Array<{ __typename?: 'LocationSector', id: string, name: string, description?: string | null, location: { __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null } }>, locationEnvironments: Array<{ __typename?: 'LocationEnvironment', id: string, name: string, description?: string | null, locationSector: { __typename?: 'LocationSector', id: string, name: string, location: { __typename?: 'Location', name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null } } }> } | null };

export type TicketCommentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TicketCommentsQuery = { __typename?: 'Query', ticket?: { __typename?: 'Ticket', comments: Array<{ __typename?: 'Comment', id: string, message?: string | null, type?: CommentTypeEnum | null, createdAt?: any | null, archived?: boolean | null, postedBy?: { __typename?: 'Author', id?: string | null, name?: string | null, avatarUrl?: string | null, type?: CommentPostedByTypeEnum | null } | null, company?: { __typename?: 'Company', id: string, name: string } | null }> } | null };

export type CreateMaintenanceCommentMutationVariables = Exact<{
  input: CommentInput;
}>;


export type CreateMaintenanceCommentMutation = { __typename?: 'Mutation', createMaintenanceComment: { __typename?: 'Comment', id: string, message?: string | null, type?: CommentTypeEnum | null, createdAt?: any | null, archived?: boolean | null, postedBy?: { __typename?: 'Author', id?: string | null, name?: string | null, avatarUrl?: string | null, type?: CommentPostedByTypeEnum | null } | null, company?: { __typename?: 'Company', id: string, name: string } | null } };

export type RemoveMaintenanceCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveMaintenanceCommentMutation = { __typename?: 'Mutation', removeMaintenanceComment: { __typename?: 'Comment', id: string } };

export type TicketsQueryVariables = Exact<{
  where?: InputMaybe<TicketWhereInput>;
  orderBy?: InputMaybe<TicketOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TicketsQuery = { __typename?: 'Query', tickets?: { __typename?: 'TicketPagedResult', totalCount: number, items: Array<{ __typename?: 'Ticket', id: string, number: string, message?: string | null, status: TicketStatus, archived: boolean, updatedAt?: any | null, createdAt?: any | null, equipments: Array<{ __typename?: 'Equipment', id: string, warrantySummary?: { __typename?: 'WarrantySummary', status: WarrantyStatus } | null }>, maintenanceType: { __typename?: 'MaintenanceType', id: string, name: string }, segment: { __typename?: 'Segment', id: string, name: string }, requester?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null, updatedBy?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null, address?: { __typename?: 'TicketAddress', formattedAddress?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ArchiveTicketMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveTicketMutation = { __typename?: 'Mutation', archiveTicket: { __typename?: 'Ticket', id: string } };

export type UnarchiveTicketMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveTicketMutation = { __typename?: 'Mutation', unarchiveTicket: { __typename?: 'Ticket', id: string } };

export type AcceptTicketMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcceptTicketMutation = { __typename?: 'Mutation', acceptTicket: { __typename?: 'Ticket', id: string, maintenance?: { __typename?: 'Maintenance', id: string } | null } };

export type RejectTicketMutationVariables = Exact<{
  input: TicketRejectInput;
}>;


export type RejectTicketMutation = { __typename?: 'Mutation', rejectTicket: { __typename?: 'Ticket', id: string, status: TicketStatus } };

export type UnarchiveTicketsMutationVariables = Exact<{
  input: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnarchiveTicketsMutation = { __typename?: 'Mutation', unarchiveTickets: Array<{ __typename?: 'Ticket', message?: string | null, clientApplicationName?: string | null, number: string, archived: boolean }> };

export type ArchiveTicketsMutationVariables = Exact<{
  input: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveTicketsMutation = { __typename?: 'Mutation', archiveTickets: Array<{ __typename?: 'Ticket', message?: string | null, clientApplicationName?: string | null, number: string, archived: boolean }> };

export type MainGetAuthenticatedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type MainGetAuthenticatedUserQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', id?: string | null, name?: string | null, email?: string | null, avatarUrl?: string | null, type?: UserType | null, emailHash?: string | null, fieldNewsEmailHash?: string | null, role?: UserRole | null, loginIntegrationEnabled: boolean, account?: { __typename?: 'Account', id: string, name: string, createdAt: any, slug?: string | null, featureFlags?: Array<{ __typename?: 'AccountFeatureFlag', name: string, active: boolean }> | null, preferences?: { __typename?: 'AccountPreferences', openMaintenance?: { __typename?: 'OpenMaintenancePreferences', featureDisableOpenMaintenanceOnPanel?: boolean | null, featureProblemRequired?: boolean | null, maintenanceNumberGenerator?: MaintenanceNumberGeneratorEnum | null } | null, forms?: { __typename?: 'FormsPreferences', questionsLimit?: number | null, featureFormsWithScoredOptions?: boolean | null } | null, quotations?: { __typename?: 'QuotationsPreferences', featureApproveQuotationByPanel?: boolean | null, featureApproveQuotationByLink?: boolean | null } | null, other?: { __typename?: 'OtherPreferences', featureLocationsPermissionsEnabled?: boolean | null } | null, storages?: { __typename?: 'StoragesPreferences', featureSharedStorages?: boolean | null, featureInternalStorages?: boolean | null } | null } | null } | null, preferences?: { __typename?: 'UserPreferences', featureOpenedMaintenanceSendEmailNotification?: boolean | null } | null, authenticationInfo?: { __typename?: 'AuthenticationInfo', enabled?: boolean | null, status?: UserAuthenticationStatus | null } | null, groups: Array<{ __typename?: 'Group', id: string, name?: string | null, permissions: Array<{ __typename?: 'Permission', name: string, category: string }> }> } | null };

export type GetWarrantiesTemplatesTotalCountQueryVariables = Exact<{
  where?: InputMaybe<WarrantiesTemplatesWhereInput>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WarrantiesTemplatesOrderByInput>;
}>;


export type GetWarrantiesTemplatesTotalCountQuery = { __typename?: 'Query', warrantiesTemplates: { __typename?: 'WarrantiesTemplatesPagedResult', totalCount: number, items: Array<{ __typename?: 'WarrantyTemplate', id: string }> } };

export type ListLocationsOverlayQueryVariables = Exact<{
  where?: InputMaybe<LocationWhereInput>;
  orderBy: LocationOrderByObjectInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListLocationsOverlayQuery = { __typename?: 'Query', locations: { __typename?: 'LocationPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Location', id: string, name?: string | null, archived?: boolean | null }> } };

export type ListMaintenanceTypeOverlayQueryVariables = Exact<{
  where?: InputMaybe<MaintenanceTypeWhereInput>;
  orderBy: MaintenanceTypeOrderByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListMaintenanceTypeOverlayQuery = { __typename?: 'Query', maintenanceTypes: { __typename?: 'MaintenanceTypePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'MaintenanceType', id: string, name: string, archived: boolean }> } };

export type ListSegmentOverlayQueryVariables = Exact<{
  where?: InputMaybe<SegmentWhereInput>;
  orderBy: SegmentOrderByInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListSegmentOverlayQuery = { __typename?: 'Query', segments: { __typename?: 'SegmentPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Segment', id: string, name: string, archived?: boolean | null }> } };

export type CompanyFilterQueryVariables = Exact<{
  where?: InputMaybe<CompanyWhereInput>;
  orderBy?: InputMaybe<CompanyOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompanyFilterQuery = { __typename?: 'Query', companies: { __typename?: 'CompanyPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Company', id: string, name: string, avatarUrl?: string | null, archived: boolean }> } };

export type CreateExportMutationVariables = Exact<{
  input: CreateExportInput;
}>;


export type CreateExportMutation = { __typename?: 'Mutation', createExport: { __typename?: 'Export', id: string } };

export type GenerateUploadCredentialMutationVariables = Exact<{
  input: UploadCredentialInput;
}>;


export type GenerateUploadCredentialMutation = { __typename?: 'Mutation', generateUploadCredential: { __typename?: 'UploadCredential', baseUrl: string, fields: any, link: string, bucketName: string, fileKey: string } };

export type AuditLogsQueryVariables = Exact<{
  where?: InputMaybe<AuditLogsWhereInput>;
  orderBy?: InputMaybe<AuditLogsOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AuditLogsQuery = { __typename?: 'Query', auditLogs: { __typename?: 'AuditLogPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'AuditLog', id: string, type: AuditLogType, action: AuditLogAction, browser?: string | null, userAgent?: string | null, applicationName: AuditLogApplicationName, operatingSystem?: string | null, clientIpAddress?: string | null, createdAt: any, metadata?: { __typename?: 'AuditLogMetadata', value?: string | null, change?: AuditLogMetadataChange | null, preference?: string | null, responseFromSesType?: string | null, emailStatus?: AuditLogMetadataEmailStatus | null, permission?: { __typename?: 'Permission', name: string } | null, group?: { __typename?: 'Group', id: string, name?: string | null } | null, user?: { __typename?: 'User', id: string, name: string, type: UserType, role: UserRole } | null, company?: { __typename?: 'Company', id: string, name: string } | null } | null, createdBy: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null } }> } };

export type ExportsQueryVariables = Exact<{
  where?: InputMaybe<ExportsWhereInput>;
  orderBy?: InputMaybe<ExportsOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExportsQuery = { __typename?: 'Query', exports: { __typename?: 'ExportPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Export', id: string, type: ExportTypeEnum, status: ExportStatusEnum, expiredAt?: any | null, createdAt: any, updatedAt: any, completedAt?: any | null, download?: { __typename?: 'Download', signedUrl: string, expiresAt: any } | null, createdBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } }> } };

export type DeadlineViolationReasonsQueryVariables = Exact<{
  where?: InputMaybe<DeadlineViolationReasonWhereInput>;
  orderBy?: InputMaybe<DeadlineViolationReasonOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DeadlineViolationReasonsQuery = { __typename?: 'Query', deadlineViolationReasons: { __typename?: 'DeadlineViolationReasonPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'DeadlineViolationReason', id: string, name: string, color: string, description?: string | null, createdAt: any, archived: boolean }> } };

export type DeadlineViolationReasonByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeadlineViolationReasonByIdQuery = { __typename?: 'Query', deadlineViolationReason: { __typename?: 'DeadlineViolationReason', id: string, name: string, color: string, archived: boolean, description?: string | null, deadlineContracts?: Array<{ __typename?: 'DeadlineContract', id: string, name: string }> | null } };

export type CreateDeadlineViolationReasonMutationVariables = Exact<{
  input: CreateDeadlineViolationReasonInput;
}>;


export type CreateDeadlineViolationReasonMutation = { __typename?: 'Mutation', createDeadlineViolationReason: { __typename?: 'DeadlineViolationReason', id: string } };

export type UpdateDeadlineViolationReasonMutationVariables = Exact<{
  input: UpdateDeadlineViolationReasonInput;
}>;


export type UpdateDeadlineViolationReasonMutation = { __typename?: 'Mutation', updateDeadlineViolationReason: { __typename?: 'DeadlineViolationReason', id: string } };

export type ArchiveDeadlineViolationReasonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveDeadlineViolationReasonMutation = { __typename?: 'Mutation', archiveDeadlineViolationReason: { __typename?: 'DeadlineViolationReason', id: string } };

export type UnarchiveDeadlineViolationReasonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveDeadlineViolationReasonMutation = { __typename?: 'Mutation', unarchiveDeadlineViolationReason: { __typename?: 'DeadlineViolationReason', id: string } };

export type ProductTypesPageQueryVariables = Exact<{
  where?: InputMaybe<ProductTypeWhereInput>;
  orderBy?: InputMaybe<ProductTypeOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductTypesPageQuery = { __typename?: 'Query', productTypes: { __typename?: 'ProductTypePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'ProductType', id: string, name: string, archived: boolean, description?: string | null, createdAt: any, updatedAt: any }> } };

export type ProductTypeByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductTypeByIdQuery = { __typename?: 'Query', productType: { __typename?: 'ProductType', id: string, name: string, archived: boolean, description?: string | null, createdAt: any, updatedAt: any } };

export type CreateProductTypeMutationVariables = Exact<{
  input: CreateProductTypeInput;
}>;


export type CreateProductTypeMutation = { __typename?: 'Mutation', createProductType: { __typename?: 'ProductType', id: string, name: string, createdAt: any, updatedAt: any } };

export type UpdateProductTypeMutationVariables = Exact<{
  input: UpdateProductTypeInput;
}>;


export type UpdateProductTypeMutation = { __typename?: 'Mutation', updateProductType: { __typename?: 'ProductType', id: string, name: string, updatedAt: any } };

export type ArchiveProductTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveProductTypeMutation = { __typename?: 'Mutation', archiveProductType: { __typename?: 'ProductType', id: string } };

export type UnarchiveProductTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveProductTypeMutation = { __typename?: 'Mutation', unarchiveProductType: { __typename?: 'ProductType', id: string } };

export type ExpensesQueryVariables = Exact<{
  where?: InputMaybe<ExpenseWhereInput>;
  orderBy?: InputMaybe<ExpenseOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExpensesQuery = { __typename?: 'Query', expenses: { __typename?: 'ExpensePagedResult', totalCount: number, items: Array<{ __typename?: 'Expense', id: string, name: string, description?: string | null, maxValue?: number | null, receiptRequired?: boolean | null, createdAt: any, updatedAt?: any | null, archived: boolean, createdBy?: { __typename?: 'User', id: string, name: string } | null, updatedBy?: { __typename?: 'User', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExpenseQuery = { __typename?: 'Query', expense?: { __typename?: 'Expense', id: string, name: string, description?: string | null, maxValue?: number | null, receiptRequired?: boolean | null, createdAt: any, updatedAt?: any | null, archived: boolean, createdBy?: { __typename?: 'User', id: string, name: string } | null, updatedBy?: { __typename?: 'User', id: string, name: string } | null } | null };

export type CreateExpenseMutationVariables = Exact<{
  input: CreateExpenseInput;
}>;


export type CreateExpenseMutation = { __typename?: 'Mutation', createExpense: { __typename?: 'Expense', id: string, name: string, description?: string | null, maxValue?: number | null, receiptRequired?: boolean | null, archived: boolean, createdAt: any, updatedAt?: any | null, createdBy?: { __typename?: 'User', id: string, name: string } | null, updatedBy?: { __typename?: 'User', id: string, name: string } | null } };

export type UpdateExpenseMutationVariables = Exact<{
  input: UpdateExpenseInput;
}>;


export type UpdateExpenseMutation = { __typename?: 'Mutation', updateExpense: { __typename?: 'Expense', id: string, name: string, description?: string | null, maxValue?: number | null, receiptRequired?: boolean | null, archived: boolean, createdAt: any, updatedAt?: any | null, createdBy?: { __typename?: 'User', id: string, name: string } | null, updatedBy?: { __typename?: 'User', id: string, name: string } | null } };

export type ArchiveExpenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveExpenseMutation = { __typename?: 'Mutation', archiveExpense: { __typename?: 'Expense', id: string } };

export type UnarchiveExpenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveExpenseMutation = { __typename?: 'Mutation', unarchiveExpense: { __typename?: 'Expense', id: string } };

export type GetGuestsQueryVariables = Exact<{
  where?: InputMaybe<UserWhereInput>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderByInput>;
}>;


export type GetGuestsQuery = { __typename?: 'Query', guests: { __typename?: 'UserPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null, guest?: { __typename?: 'Guest', documentNumber?: string | null, phoneNumber?: string | null, location?: { __typename?: 'GuestLocation', id: string, address?: { __typename?: 'Address', formattedAddress?: string | null } | null } | null } | null }> } };

export type GuestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GuestQuery = { __typename?: 'Query', guest?: { __typename?: 'User', id: string, name: string, email: string, avatarUrl?: string | null, guest?: { __typename?: 'Guest', documentNumber?: string | null, phoneNumber?: string | null, location?: { __typename?: 'GuestLocation', address?: { __typename?: 'Address', formattedAddress?: string | null } | null } | null, locations: Array<{ __typename?: 'Location', id: string, name?: string | null, archived?: boolean | null, default?: boolean | null, locked?: boolean | null, notes?: string | null, updatedBy?: { __typename?: 'User', name: string } | null, createdBy?: { __typename?: 'User', name: string } | null, address?: { __typename?: 'Address', streetName?: string | null, number?: string | null, neighborhood?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, formattedAddress?: string | null } | null }> } | null } | null };

export type StorageProductQueryVariables = Exact<{
  storageId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}>;


export type StorageProductQuery = { __typename?: 'Query', storageProducts: { __typename?: 'StorageProductPagedResult', items: Array<{ __typename?: 'StorageProduct', id: string, quantity: number, minimalQuantity?: number | null, minimalQuantityAtRisk?: number | null, status?: StorageProductStatus | null, storage: { __typename?: 'Storage', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string } }> } };

export type ExternalStorageProductQueryVariables = Exact<{
  storageId: Scalars['ID']['input'];
  sammathnaurProductId: Scalars['ID']['input'];
}>;


export type ExternalStorageProductQuery = { __typename?: 'Query', externalStorageProductsV2: { __typename?: 'ExternalStorageProductPagedResult', items: Array<{ __typename?: 'ExternalStorageProduct', id: string, quantity: number, minimalQuantity?: number | null, minimalQuantityAtRisk?: number | null, status?: StorageProductStatus | null, storage: { __typename?: 'ExternalStorage', id: string, name: string }, product: { __typename?: 'ExternalProduct', id: string, name: string } }> } };

export type CreateProductCompanyMutationVariables = Exact<{
  input: CreateProductCompanyInput;
}>;


export type CreateProductCompanyMutation = { __typename?: 'Mutation', createProductCompany: { __typename?: 'ProductCompany', id: string, value: number, archived: boolean, preferences?: { __typename?: 'ProductServiceCompanyPreferences', allowEditValue?: boolean | null } | null, company: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } } };

export type UpdateProductCompanyMutationVariables = Exact<{
  input: UpdateProductCompanyInput;
}>;


export type UpdateProductCompanyMutation = { __typename?: 'Mutation', updateProductCompany: { __typename?: 'ProductCompany', id: string } };

export type ArchiveProductCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveProductCompanyMutation = { __typename?: 'Mutation', archiveProductCompany: { __typename?: 'ProductCompany', id: string } };

export type UnarchiveProductCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveProductCompanyMutation = { __typename?: 'Mutation', unarchiveProductCompany: { __typename?: 'ProductCompany', id: string } };

export type PaginatedProductsQueryVariables = Exact<{
  where?: InputMaybe<ProductsWhereInput>;
  orderBy?: InputMaybe<ProductsOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Product', id: string, name: string, code?: string | null, measure?: ProductServiceMeasure | null, imageUrl?: string | null, archived: boolean, productType?: { __typename?: 'ProductType', id: string, name: string } | null, createdBy?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null }> } };

export type GetProductByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductByIdQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name: string, code?: string | null, qrCode?: string | null, measure?: ProductServiceMeasure | null, imageUrl?: string | null, updatedAt?: any | null, createdAt?: any | null, archived: boolean, description?: string | null, companies?: Array<{ __typename?: 'ProductCompany', id: string, value: number, archived: boolean, preferences?: { __typename?: 'ProductServiceCompanyPreferences', allowEditValue?: boolean | null } | null, company: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } }> | null, productType?: { __typename?: 'ProductType', id: string, name: string } | null } | null };

export type GetProductStoragesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductStoragesQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name: string, storages: { __typename?: 'StorageProductPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'StorageProduct', id: string, quantity: number, storage: { __typename?: 'Storage', id: string, name: string } }> } } | null };

export type NextProductCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type NextProductCodeQuery = { __typename?: 'Query', nextProductCode: { __typename?: 'NextProductCodeResult', code: string } };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string, name: string, imageUrl?: string | null, updatedAt?: any | null } };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, name: string, imageUrl?: string | null, updatedAt?: any | null } };

export type ArchiveProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveProductMutation = { __typename?: 'Mutation', archiveProduct: { __typename?: 'Product', id: string } };

export type UnarchiveProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveProductMutation = { __typename?: 'Mutation', unarchiveProduct: { __typename?: 'Product', id: string } };

export type PaginatedServicesQueryVariables = Exact<{
  where?: InputMaybe<ServiceWhereInput>;
  orderBy?: InputMaybe<ServiceOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedServicesQuery = { __typename?: 'Query', services: { __typename?: 'ServicePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Service', id: string, name: string, description?: string | null, imageUrl?: string | null, archived: boolean, createdBy?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null }> } };

export type GetServiceByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetServiceByIdQuery = { __typename?: 'Query', service?: { __typename?: 'Service', id: string, name: string, imageUrl?: string | null, updatedAt?: any | null, createdAt: any, archived: boolean, description?: string | null, companies: Array<{ __typename?: 'ProductServiceCompany', id: string, value: number, valueType: ProductServiceValueType, archived: boolean, preferences?: { __typename?: 'ProductServiceCompanyPreferences', allowEditValue?: boolean | null, weekDayValues?: { __typename?: 'WeekDayValuesType', monday?: number | null, tuesday?: number | null, wednesday?: number | null, thursday?: number | null, friday?: number | null, saturday?: number | null, sunday?: number | null } | null } | null, company: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } }> } | null };

export type CreateServiceMutationVariables = Exact<{
  input: CreateServiceInput;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'Service', id: string, name: string, imageUrl?: string | null, updatedAt?: any | null } };

export type UpdateServiceMutationVariables = Exact<{
  input: UpdateServiceInput;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'Service', id: string, name: string, imageUrl?: string | null, updatedAt?: any | null } };

export type ArchiveServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveServiceMutation = { __typename?: 'Mutation', archiveService: { __typename?: 'Service', id: string } };

export type UnarchiveServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveServiceMutation = { __typename?: 'Mutation', unarchiveService: { __typename?: 'Service', id: string } };

export type PaginatedExternalStorageProductsQueryVariables = Exact<{
  where: ExternalStorageProductV2WhereInput;
  orderBy?: InputMaybe<ExternalStorageProductsOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedExternalStorageProductsQuery = { __typename?: 'Query', externalStorageProductsV2: { __typename?: 'ExternalStorageProductPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'ExternalStorageProduct', id: string, quantity: number, status?: StorageProductStatus | null, company?: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } | null, storage: { __typename?: 'ExternalStorage', id: string, name: string }, product: { __typename?: 'ExternalProduct', id: string, name: string, code?: string | null, measure?: ProductServiceMeasure | null, imageUrl?: string | null, productType?: { __typename?: 'ExternalProductType', id: string, name: string } | null } }> } };

export type GetExternalStorageProductByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExternalStorageProductByIdQuery = { __typename?: 'Query', externalStorageProduct: { __typename?: 'ExternalStorageProduct', id: string, quantity: number, createdAt: any, minimalQuantity?: number | null, minimalQuantityAtRisk?: number | null, product: { __typename?: 'ExternalProduct', id: string, code?: string | null, name: string, qrCode?: string | null, measure?: ProductServiceMeasure | null, imageUrl?: string | null, description?: string | null, productType?: { __typename?: 'ExternalProductType', id: string, name: string } | null }, company?: { __typename?: 'Company', id: string, name: string } | null, storage: { __typename?: 'ExternalStorage', id: string, name: string } } };

export type UpdateExternalStorageProductMutationVariables = Exact<{
  input: UpdateExternalStorageProductInput;
}>;


export type UpdateExternalStorageProductMutation = { __typename?: 'Mutation', updateExternalStorageProduct: { __typename?: 'ExternalStorageProduct', id: string, quantity: number, minimalQuantity?: number | null, minimalQuantityAtRisk?: number | null, product: { __typename?: 'ExternalProduct', id: string, code?: string | null, name: string, qrCode?: string | null, measure?: ProductServiceMeasure | null, imageUrl?: string | null, description?: string | null, productType?: { __typename?: 'ExternalProductType', id: string, name: string } | null }, storage: { __typename?: 'ExternalStorage', id: string, name: string } } };

export type PaginatedStorageProductsQueryVariables = Exact<{
  where?: InputMaybe<StorageProductsWhereInput>;
  orderBy?: InputMaybe<StoragesProductsOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedStorageProductsQuery = { __typename?: 'Query', storageProducts: { __typename?: 'StorageProductPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'StorageProduct', id: string, quantity: number, status?: StorageProductStatus | null, account: { __typename?: 'Account', id: string, name: string, loginCustomization?: { __typename?: 'LoginCustomization', logoUrl?: string | null } | null }, storage: { __typename?: 'Storage', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, code?: string | null, measure?: ProductServiceMeasure | null, imageUrl?: string | null, productType?: { __typename?: 'ProductType', id: string, name: string } | null } }> } };

export type GetStorageProductByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStorageProductByIdQuery = { __typename?: 'Query', storageProduct?: { __typename?: 'StorageProduct', id: string, quantity: number, createdAt: any, updatedAt?: any | null, minimalQuantity?: number | null, minimalQuantityAtRisk?: number | null, product: { __typename?: 'Product', id: string, code?: string | null, name: string, qrCode?: string | null, measure?: ProductServiceMeasure | null, imageUrl?: string | null, description?: string | null, productType?: { __typename?: 'ProductType', id: string, name: string } | null }, storage: { __typename?: 'Storage', id: string, name: string } } | null };

export type UpdateStorageProductMutationVariables = Exact<{
  input: UpdateStorageProductInput;
}>;


export type UpdateStorageProductMutation = { __typename?: 'Mutation', updateStorageProduct: { __typename?: 'StorageProduct', id: string, updatedAt?: any | null } };

export type PaginatedStoragesQueryVariables = Exact<{
  where?: InputMaybe<StoragesWhereInput>;
  orderBy?: InputMaybe<StoragesOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedStoragesQuery = { __typename?: 'Query', storages: { __typename?: 'StoragePagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'Storage', id: string, name: string, description?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null } | null }> } };

export type GetStorageByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStorageByIdQuery = { __typename?: 'Query', storage?: { __typename?: 'Storage', id: string, name: string, description?: string | null, archived: boolean, createdAt: any, updatedAt?: any | null, location?: { __typename?: 'Location', id: string, name?: string | null, address?: { __typename?: 'Address', formattedAddress?: string | null } | null } | null } | null };

export type GetStorageProductsByStorageIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  where?: InputMaybe<StorageProductsWhereInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStorageProductsByStorageIdQuery = { __typename?: 'Query', storage?: { __typename?: 'Storage', products: { __typename?: 'StorageProductPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'StorageProduct', id: string, quantity: number, createdBy: { __typename?: 'User', id: string, name: string }, product: { __typename?: 'Product', id: string, name: string, code?: string | null, measure?: ProductServiceMeasure | null, imageUrl?: string | null, productType?: { __typename?: 'ProductType', id: string, name: string } | null } }> } } | null };

export type GetStorageMovementsByStorageIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  orderBy?: InputMaybe<CreatedAtOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStorageMovementsByStorageIdQuery = { __typename?: 'Query', storage?: { __typename?: 'Storage', movements: { __typename?: 'StorageMovementCursorPagedResult', totalCount: number, pageInfo: { __typename?: 'CursorPageInfo', startCursor?: string | null, endCursor?: string | null }, items: Array<{ __typename?: 'StorageMovement', id: string, description: string, type: StorageMovementType, createdAt: any, updatedAt: any, company?: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } | null, storage?: { __typename?: 'Storage', id: string, name: string, products: { __typename?: 'StorageProductPagedResult', totalCount: number, items: Array<{ __typename?: 'StorageProduct', id: string, quantity: number, product: { __typename?: 'Product', id: string, name: string, code?: string | null, imageUrl?: string | null } }> } } | null, externalStorage?: { __typename?: 'ExternalStorage', name: string, employee?: { __typename?: 'ExternalStorageEmployee', name: string, avatarUrl?: string | null } | null } | null, relatedStorageMovement?: { __typename?: 'StorageMovement', quantity: { __typename?: 'StorageMovementQuantity', previous: number, changed: number, current: number }, storage?: { __typename?: 'Storage', name: string, products: { __typename?: 'StorageProductPagedResult', totalCount: number, items: Array<{ __typename?: 'StorageProduct', id: string, quantity: number, product: { __typename?: 'Product', id: string, name: string, code?: string | null, imageUrl?: string | null } }> } } | null } | null, quantity: { __typename?: 'StorageMovementQuantity', previous: number, changed: number, current: number }, product: { __typename?: 'Product', id: string, name: string, code?: string | null, imageUrl?: string | null, measure?: ProductServiceMeasure | null, productType?: { __typename?: 'ProductType', id: string, name: string } | null }, createdBy?: { __typename?: 'User', name: string, avatarUrl?: string | null } | null, updatedBy?: { __typename?: 'User', name: string, avatarUrl?: string | null } | null, sync?: { __typename?: 'StorageMovementSync', status?: StorageMovementSyncStatus | null } | null }> } } | null };

export type CreateStorageMutationVariables = Exact<{
  input: CreateStorageInput;
}>;


export type CreateStorageMutation = { __typename?: 'Mutation', createStorage: { __typename?: 'Storage', id: string, name: string, updatedAt?: any | null } };

export type UpdateStorageMutationVariables = Exact<{
  input: UpdateStorageInput;
}>;


export type UpdateStorageMutation = { __typename?: 'Mutation', updateStorage: { __typename?: 'Storage', id: string, name: string, updatedAt?: any | null } };

export type ArchiveStorageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveStorageMutation = { __typename?: 'Mutation', archiveStorage: { __typename?: 'Storage', id: string } };

export type UnarchiveStorageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveStorageMutation = { __typename?: 'Mutation', unarchiveStorage: { __typename?: 'Storage', id: string } };

export type CreatePendencyMutationVariables = Exact<{
  input: CreatePendencyInput;
}>;


export type CreatePendencyMutation = { __typename?: 'Mutation', createPendency: { __typename?: 'Pendency', id: string, title: string, identifier: string, createdAt: any, updatedAt: any, treatmentType: PendencyTreatmentType, treatmentStatus: PendencyTreatmentStatus, status: PendencyStatus, archived: boolean, company?: { __typename?: 'Company', name: string, avatarUrl?: string | null } | null, pendencyType: { __typename?: 'PendencyType', name: string }, assignees: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }>, readers: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }> } };

export type UpdatePendencyMutationVariables = Exact<{
  input: UpdatePendencyInput;
}>;


export type UpdatePendencyMutation = { __typename?: 'Mutation', updatePendency: { __typename?: 'Pendency', id: string, title: string, status: PendencyStatus, archived: boolean, createdAt: any, updatedAt: any, identifier: string, description?: string | null, treatmentStatus: PendencyTreatmentStatus, treatmentType: PendencyTreatmentType, createdBy: { __typename?: 'PendencyChangedBy', id: string, name: string }, updatedBy?: { __typename?: 'PendencyChangedBy', id: string, name: string } | null, assignees: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }>, readers: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }>, maintenance?: { __typename?: 'Maintenance', id: string, number: string, location?: { __typename?: 'Location', name?: string | null } | null, segment: { __typename?: 'Segment', name: string }, maintenanceType?: { __typename?: 'MaintenanceType', name: string } | null } | null, company?: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } | null, pendencyType: { __typename?: 'PendencyType', id: string, name: string } } };

export type ArchivePendencyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchivePendencyMutation = { __typename?: 'Mutation', archivePendency: { __typename?: 'Pendency', id: string } };

export type ConcludePendencyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConcludePendencyMutation = { __typename?: 'Mutation', concludePendency: { __typename?: 'Pendency', id: string } };

export type UnarchivePendencyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchivePendencyMutation = { __typename?: 'Mutation', unarchivePendency: { __typename?: 'Pendency', id: string } };

export type UpdatePendencyAssigneeMutationVariables = Exact<{
  input: UpdatePendencyAssigneeInput;
}>;


export type UpdatePendencyAssigneeMutation = { __typename?: 'Mutation', updatePendencyAssignee: { __typename?: 'Pendency', id: string, updatedAt: any, assignee?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null, assignees: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }>, readers: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }>, maintenance?: { __typename?: 'Maintenance', id: string, number: string, location?: { __typename?: 'Location', name?: string | null } | null, segment: { __typename?: 'Segment', name: string }, maintenanceType?: { __typename?: 'MaintenanceType', name: string } | null } | null } };

export type TransferPendencyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TransferPendencyMutation = { __typename?: 'Mutation', transferPendency: { __typename?: 'Pendency', id: string } };

export type GetPendencyByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPendencyByIdQuery = { __typename?: 'Query', pendency: { __typename?: 'Pendency', id: string, title: string, status: PendencyStatus, archived: boolean, createdAt: any, updatedAt: any, identifier: string, description?: string | null, treatmentStatus: PendencyTreatmentStatus, treatmentType: PendencyTreatmentType, createdBy: { __typename?: 'PendencyChangedBy', id: string, name: string }, updatedBy?: { __typename?: 'PendencyChangedBy', id: string, name: string } | null, assignees: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }>, readers: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }>, maintenance?: { __typename?: 'Maintenance', id: string, number: string, location?: { __typename?: 'Location', name?: string | null } | null, segment: { __typename?: 'Segment', name: string }, maintenanceType?: { __typename?: 'MaintenanceType', name: string } | null } | null, company?: { __typename?: 'Company', id: string, name: string, avatarUrl?: string | null } | null, pendencyType: { __typename?: 'PendencyType', id: string, name: string } } };

export type PendencyEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PendencyEventQuery = { __typename?: 'Query', pendencyEvent: { __typename?: 'PendencyEvent', id: string, createdAt: any, updatedAt?: any | null, type: PendencyEventType, createdBy: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null }, updatedBy?: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null } | null, content?: { __typename?: 'PendencyEventLog', type: PendencyEventLogType, changes?: Array<{ __typename?: 'PendencyEventLogChanges', column: PendencyEventLogChangesColumn, oldValue?: { __typename?: 'Company', id: string, name: string } | { __typename?: 'Maintenance', id: string, number: string } | { __typename?: 'PendencyType', id: string, name: string } | { __typename?: 'ScalarStringWrapper', value?: string | null } | { __typename?: 'User', id: string, name: string } | null, newValue?: { __typename?: 'Company', id: string, name: string } | { __typename?: 'Maintenance', id: string, number: string } | { __typename?: 'PendencyType', id: string, name: string } | { __typename?: 'ScalarStringWrapper', value?: string | null } | { __typename?: 'User', id: string, name: string } | null }> | null } | { __typename?: 'PendencyEventNote' } | { __typename?: 'PendencyEventReply', message: string, attachments?: Array<{ __typename?: 'PendencyEventReplyAttachment', size: number, path: string, type: string, title?: string | null, createdAt: any }> | null } | null } };

export type GetPendencyEventsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  where?: InputMaybe<PendencyEventWhereInput>;
  take: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPendencyEventsQuery = { __typename?: 'Query', pendency: { __typename?: 'Pendency', id: string, title: string, identifier: string, events: { __typename?: 'PendenciesEventsPagedResult', totalCount: number, pageInfo: { __typename?: 'CursorPageInfo', startCursor?: string | null, endCursor?: string | null }, items: Array<{ __typename?: 'PendencyEvent', id: string, type: PendencyEventType, createdAt: any, updatedAt?: any | null, createdBy: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null }, content?: { __typename?: 'PendencyEventLog', type: PendencyEventLogType, changes?: Array<{ __typename?: 'PendencyEventLogChanges', column: PendencyEventLogChangesColumn, oldValue?: { __typename?: 'Company', id: string, name: string } | { __typename?: 'Maintenance', id: string, number: string } | { __typename?: 'PendencyType', id: string, name: string } | { __typename?: 'ScalarStringWrapper', value?: string | null } | { __typename?: 'User', id: string, name: string } | null, newValue?: { __typename?: 'Company', id: string, name: string } | { __typename?: 'Maintenance', id: string, number: string } | { __typename?: 'PendencyType', id: string, name: string } | { __typename?: 'ScalarStringWrapper', value?: string | null } | { __typename?: 'User', id: string, name: string } | null }> | null } | { __typename?: 'PendencyEventNote', message: string } | { __typename?: 'PendencyEventReply', message: string, attachments?: Array<{ __typename?: 'PendencyEventReplyAttachment', size: number, path: string, type: string, title?: string | null, createdAt: any, download?: { __typename?: 'Download', signedUrl: string, expiresAt: any } | null }> | null } | null }> } } };

export type PaginatedPendenciesQueryVariables = Exact<{
  where?: InputMaybe<PendenciesWhereInput>;
  orderBy?: InputMaybe<PendenciesOrderByInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedPendenciesQuery = { __typename?: 'Query', pendencies: { __typename?: 'PendenciesPagedResult', totalCount: number, pageInfo: { __typename?: 'CursorPageInfo', startCursor?: string | null, endCursor?: string | null }, items: Array<{ __typename?: 'Pendency', id: string, title: string, archived: boolean, identifier: string, createdAt: any, updatedAt: any, treatmentType: PendencyTreatmentType, treatmentStatus: PendencyTreatmentStatus, status: PendencyStatus, company?: { __typename?: 'Company', name: string, avatarUrl?: string | null } | null, pendencyType: { __typename?: 'PendencyType', name: string }, assignees: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }>, readers: Array<{ __typename?: 'User', id: string, name: string, avatarUrl?: string | null }>, maintenance?: { __typename?: 'Maintenance', id: string, number: string, segment: { __typename?: 'Segment', id: string, name: string } } | null }> } };

export type CreatePendencyEventReplyMutationVariables = Exact<{
  input: CreatePendencyEventReplyInput;
}>;


export type CreatePendencyEventReplyMutation = { __typename?: 'Mutation', createPendencyEventReply: { __typename?: 'PendencyEvent', id: string, type: PendencyEventType, createdAt: any, createdBy: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null }, content?: { __typename?: 'PendencyEventLog' } | { __typename?: 'PendencyEventNote' } | { __typename?: 'PendencyEventReply', message: string, attachments?: Array<{ __typename?: 'PendencyEventReplyAttachment', size: number, path: string, type: string, title?: string | null, createdAt: any, download?: { __typename?: 'Download', signedUrl: string, expiresAt: any } | null }> | null } | null } };

export type CreatePendencyEventNoteMutationVariables = Exact<{
  input: CreatePendencyEventNoteInput;
}>;


export type CreatePendencyEventNoteMutation = { __typename?: 'Mutation', createPendencyEventNote: { __typename?: 'PendencyEvent', id: string, type: PendencyEventType, createdAt: any, updatedAt?: any | null, pendency: { __typename?: 'Pendency', id: string, title: string, identifier: string }, createdBy: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null }, updatedBy?: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null } | null, content?: { __typename?: 'PendencyEventLog' } | { __typename?: 'PendencyEventNote', message: string } | { __typename?: 'PendencyEventReply' } | null } };

export type UpdatePendencyEventNoteMutationVariables = Exact<{
  input: UpdatePendencyEventNoteInput;
}>;


export type UpdatePendencyEventNoteMutation = { __typename?: 'Mutation', updatePendencyEventNote: { __typename?: 'PendencyEvent', type: PendencyEventType, createdAt: any, updatedAt?: any | null, pendency: { __typename?: 'Pendency', id: string, title: string, identifier: string }, createdBy: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null }, updatedBy?: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null } | null, content?: { __typename?: 'PendencyEventLog' } | { __typename?: 'PendencyEventNote', message: string } | { __typename?: 'PendencyEventReply' } | null } };

export type DeletePendencyEventNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePendencyEventNoteMutation = { __typename?: 'Mutation', deletePendencyEventNote: { __typename?: 'PendencyEvent', id: string, type: PendencyEventType, createdAt: any, updatedAt?: any | null, pendency: { __typename?: 'Pendency', id: string, title: string, identifier: string }, createdBy: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null }, updatedBy?: { __typename?: 'PendencyEventUser', id?: string | null, type: PendencyEventUserType, name: string, avatarUrl?: string | null, company?: { __typename?: 'Company', id: string, name: string } | null } | null, content?: { __typename?: 'PendencyEventLog' } | { __typename?: 'PendencyEventNote', message: string } | { __typename?: 'PendencyEventReply' } | null } };

export type GetWarrantiesTemplatesQueryVariables = Exact<{
  where?: InputMaybe<WarrantiesTemplatesWhereInput>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WarrantiesTemplatesOrderByInput>;
}>;


export type GetWarrantiesTemplatesQuery = { __typename?: 'Query', warrantiesTemplates: { __typename?: 'WarrantiesTemplatesPagedResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items: Array<{ __typename?: 'WarrantyTemplate', id: string, name: string, description?: string | null, value: number, type: WarrantyType, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number, createdAt: any, createdBy: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null }, updatedBy?: { __typename?: 'User', id: string, name: string, avatarUrl?: string | null } | null }> } };

export type GetWarrantyTemplateByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWarrantyTemplateByIdQuery = { __typename?: 'Query', warrantyTemplate?: { __typename?: 'WarrantyTemplate', id: string, name: string, description?: string | null, value: number, type: WarrantyType, archived: boolean, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number, createdAt: any, updatedAt?: any | null, warranties?: Array<{ __typename?: 'Warranty', id: string }> | null, companies?: Array<{ __typename?: 'Company', id: string, name: string, address?: { __typename?: 'CompanyAddress', formattedAddress?: string | null } | null }> | null, maintenancesTypes?: Array<{ __typename?: 'MaintenanceType', id: string, name: string }> | null, attachments?: Array<{ __typename?: 'WarrantyAttachment', id: string, bucketName: string, fileKey: string, createdAt: any, title?: string | null, size?: number | null, download?: { __typename?: 'Download', signedUrl: string, expiresAt: any } | null }> | null, createdBy: { __typename?: 'User', id: string, name: string }, updatedBy?: { __typename?: 'User', id: string, name: string } | null } | null };

export type CreateWarrantyTemplateMutationVariables = Exact<{
  input: CreateWarrantyTemplateInput;
}>;


export type CreateWarrantyTemplateMutation = { __typename?: 'Mutation', createWarrantyTemplate: { __typename?: 'WarrantyTemplate', name: string, type: WarrantyType, description?: string | null, archived: boolean, value: number, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number } };

export type UpdateWarrantyTemplateMutationVariables = Exact<{
  input: UpdateWarrantyTemplateInput;
}>;


export type UpdateWarrantyTemplateMutation = { __typename?: 'Mutation', updateWarrantyTemplate: { __typename?: 'WarrantyTemplate', name: string, type: WarrantyType, description?: string | null, archived: boolean, value: number, coverageDurationDays: number, extendedCoverageDurationDays: number, extendedValue: number, attachments?: Array<{ __typename?: 'WarrantyAttachment', id: string, bucketName: string, fileKey: string, createdAt: any, title?: string | null, size?: number | null, download?: { __typename?: 'Download', signedUrl: string, expiresAt: any } | null }> | null } };

export type ArchiveWarrantyTemplateMutationVariables = Exact<{
  input: ArchivedWarrantyTemplateInput;
}>;


export type ArchiveWarrantyTemplateMutation = { __typename?: 'Mutation', archiveWarrantyTemplate: { __typename?: 'WarrantyTemplate', id: string, archived: boolean } };

export type UnarchiveWarrantyTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveWarrantyTemplateMutation = { __typename?: 'Mutation', unarchiveWarrantyTemplate: { __typename?: 'WarrantyTemplate', id: string, archived: boolean } };

export const RecurrenceFieldsFragmentDoc = gql`
    fragment RecurrenceFields on Recurrence {
  id
  segment {
    id
    name
  }
  maintenanceType {
    id
    name
  }
  occurrences(limit: 10, offset: 0) {
    totalCount
    items {
      id
      iteration
      scheduledAt
      scheduledDate
      scheduledType
      maintenance {
        id
        number
        status
        assignee {
          name
        }
      }
    }
  }
  repeat {
    from
    until
    interval
    every
  }
}
    `;
export const CompaniesPaginatedDocument = gql`
    query companiesPaginated($where: CompanyWhereInput, $orderBy: CompanyOrderByInput, $limit: Int, $offset: Int) {
  companies(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      avatarUrl
      createdAt
      archived
      fieldAccountId
      address {
        formattedAddress
      }
      documentNumber
      fieldAccount {
        phone
        timezone
        accountType
        manager {
          email
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompaniesPaginatedGQL extends Apollo.Query<CompaniesPaginatedQuery, CompaniesPaginatedQueryVariables> {
    override document = CompaniesPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EquipmentsPaginatedDocument = gql`
    query EquipmentsPaginated($where: EquipmentWhereInput, $orderBy: EquipmentOrderByInput, $limit: Int, $offset: Int) {
  equipments(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      name
      number
      notes
      archived
      imageUrl
      type {
        id
        name
      }
      location {
        id
        address {
          formattedAddress
        }
      }
      locationSector {
        id
      }
      locationEnvironment {
        id
      }
      warranties {
        name
        startDate
        endDate
        extendedEndDate
        coverageDurationDays
      }
      warrantySummary {
        id
        status
        startDate
        endDate
        extendedEndDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EquipmentsPaginatedGQL extends Apollo.Query<EquipmentsPaginatedQuery, EquipmentsPaginatedQueryVariables> {
    override document = EquipmentsPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EquipmentDocument = gql`
    query equipment($id: ID!) {
  equipment(id: $id) {
    id
    name
    notes
    number
    qrCode
    installedAt
    purchasedAt
    archived
    type {
      id
      name
    }
    location {
      address {
        formattedAddress
      }
    }
    locationSector {
      id
      name
    }
    locationEnvironment {
      id
      name
    }
    warrantySummary {
      id
      status
      startDate
      endDate
      extendedEndDate
      createdAt
      updatedAt
    }
    warranties {
      name
      startDate
      endDate
      extendedEndDate
      coverageDurationDays
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EquipmentGQL extends Apollo.Query<EquipmentQuery, EquipmentQueryVariables> {
    override document = EquipmentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EquipmentWithWarrantiesDocument = gql`
    query equipmentWithWarranties($id: ID!) {
  equipment(id: $id) {
    id
    name
    warranties {
      id
      name
      status
      coverageDurationDays
      extendedCoverageDurationDays
      extendedValue
      endDate
      startDate
      extendedEndDate
      value
      description
      archived
      createdAt
      updatedAt
      equipment {
        id
        name
      }
      maintenance {
        id
        number
      }
      company {
        id
        name
      }
      template {
        id
        name
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      companies {
        id
      }
      maintenancesTypes {
        id
        name
      }
    }
    warrantySummary {
      id
      status
      startDate
      endDate
      extendedEndDate
      createdAt
      updatedAt
    }
    warranties {
      name
      startDate
      endDate
      extendedEndDate
      coverageDurationDays
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EquipmentWithWarrantiesGQL extends Apollo.Query<EquipmentWithWarrantiesQuery, EquipmentWithWarrantiesQueryVariables> {
    override document = EquipmentWithWarrantiesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LocationEnvironmentsPaginatedDocument = gql`
    query LocationEnvironmentsPaginated($where: LocationEnvironmentWhereInput, $orderBy: LocationEnvironmentOrderByInput, $limit: Int, $offset: Int) {
  locationEnvironments(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      archived
      description
      locationSector {
        id
        name
        location {
          id
          name
          address {
            formattedAddress
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LocationEnvironmentsPaginatedGQL extends Apollo.Query<LocationEnvironmentsPaginatedQuery, LocationEnvironmentsPaginatedQueryVariables> {
    override document = LocationEnvironmentsPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LocationEnvironmentDocument = gql`
    query locationEnvironment($id: ID!) {
  locationEnvironment(id: $id) {
    id
    name
    qrCode
    archived
    description
    locationSector {
      id
      name
      location {
        address {
          formattedAddress
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LocationEnvironmentGQL extends Apollo.Query<LocationEnvironmentQuery, LocationEnvironmentQueryVariables> {
    override document = LocationEnvironmentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaginatedLocationsGroupsDocument = gql`
    query getPaginatedLocationsGroups($where: LocationGroupWhereInput, $orderBy: LocationGroupOrderByInput, $limit: Int, $offset: Int) {
  locationsGroups(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaginatedLocationsGroupsGQL extends Apollo.Query<GetPaginatedLocationsGroupsQuery, GetPaginatedLocationsGroupsQueryVariables> {
    override document = GetPaginatedLocationsGroupsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LocationSectorsPaginatedDocument = gql`
    query LocationSectorsPaginated($where: LocationSectorWhereInput, $orderBy: LocationSectorOrderByInput, $limit: Int, $offset: Int) {
  locationSectors(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      archived
      createdAt
      description
      location {
        id
        name
        address {
          formattedAddress
        }
      }
      locationEnvironments {
        id
        name
        qrCode
        description
        archived
        createdAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LocationSectorsPaginatedGQL extends Apollo.Query<LocationSectorsPaginatedQuery, LocationSectorsPaginatedQueryVariables> {
    override document = LocationSectorsPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LocationSectorDocument = gql`
    query locationSector($id: ID!) {
  locationSector(id: $id) {
    id
    name
    archived
    description
    location {
      address {
        formattedAddress
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LocationSectorGQL extends Apollo.Query<LocationSectorQuery, LocationSectorQueryVariables> {
    override document = LocationSectorDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LocationsByCursorDocument = gql`
    query locationsByCursor($where: LocationsByCursorWhereInput, $orderBy: LocationsByCursorOrderByInput, $take: Int, $after: String) {
  locationsByCursor(where: $where, orderBy: $orderBy, take: $take, after: $after) {
    pageInfo {
      startCursor
      endCursor
    }
    totalCount
    items {
      id
      name
      archived
      address {
        formattedAddress
      }
      maintenances {
        id
        status
        locationSectors {
          id
        }
        locationEnvironments {
          id
        }
        equipments {
          id
          warrantySummary {
            status
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LocationsByCursorGQL extends Apollo.Query<LocationsByCursorQuery, LocationsByCursorQueryVariables> {
    override document = LocationsByCursorDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LocationDocument = gql`
    query location($id: ID!) {
  location(id: $id) {
    id
    name
    notes
    archived
    documentNumber
    address {
      formattedAddress
    }
    group {
      id
      name
    }
    segments {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LocationGQL extends Apollo.Query<LocationQuery, LocationQueryVariables> {
    override document = LocationDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaintenanceWithWarrantiesDocument = gql`
    query getMaintenanceWithWarranties($id: ID!) {
  maintenance(id: $id) {
    id
    warranties {
      id
      name
      coverageDurationDays
      extendedCoverageDurationDays
      extendedValue
      endDate
      startDate
      extendedEndDate
      value
      description
      status
      equipment {
        id
        name
      }
      createdBy {
        id
        name
      }
      maintenancesTypes {
        id
        name
      }
      template {
        id
      }
    }
    warrantySummary {
      status
      startDate
      endDate
    }
    equipments {
      id
      name
      number
      warranties {
        id
        name
        coverageDurationDays
        extendedCoverageDurationDays
        extendedValue
        endDate
        startDate
        extendedEndDate
        value
        description
        status
        company {
          id
        }
        equipment {
          id
          name
        }
        createdBy {
          id
          name
        }
        maintenancesTypes {
          id
          name
        }
        template {
          id
        }
      }
      warrantySummary {
        status
        startDate
        endDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaintenanceWithWarrantiesGQL extends Apollo.Query<GetMaintenanceWithWarrantiesQuery, GetMaintenanceWithWarrantiesQueryVariables> {
    override document = GetMaintenanceWithWarrantiesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PendencyTypesPageDocument = gql`
    query PendencyTypesPage($where: PendencyTypeWhereInput, $orderBy: PendencyTypeOrderByInput, $limit: Int, $offset: Int) {
  pendencyTypes(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      description
      createdAt
      archived
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PendencyTypesPageGQL extends Apollo.Query<PendencyTypesPageQuery, PendencyTypesPageQueryVariables> {
    override document = PendencyTypesPageDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PendencyTypeByNameDocument = gql`
    query PendencyTypeByName($nameEq: String!) {
  pendencyTypes(where: {nameEq: $nameEq}, orderBy: name_asc, limit: 1, offset: 0) {
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PendencyTypeByNameGQL extends Apollo.Query<PendencyTypeByNameQuery, PendencyTypeByNameQueryVariables> {
    override document = PendencyTypeByNameDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PendencyTypeByIdDocument = gql`
    query PendencyTypeById($id: ID!) {
  pendencyType(id: $id) {
    id
    name
    description
    archived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PendencyTypeByIdGQL extends Apollo.Query<PendencyTypeByIdQuery, PendencyTypeByIdQueryVariables> {
    override document = PendencyTypeByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePendencyTypeDocument = gql`
    mutation CreatePendencyType($input: CreatePendencyTypeInput!) {
  createPendencyType(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePendencyTypeGQL extends Apollo.Mutation<CreatePendencyTypeMutation, CreatePendencyTypeMutationVariables> {
    override document = CreatePendencyTypeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePendencyTypeDocument = gql`
    mutation UpdatePendencyType($input: UpdatePendencyTypeInput!) {
  updatePendencyType(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePendencyTypeGQL extends Apollo.Mutation<UpdatePendencyTypeMutation, UpdatePendencyTypeMutationVariables> {
    override document = UpdatePendencyTypeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePendencyTypeDocument = gql`
    mutation ArchivePendencyType($id: ID!) {
  archivePendencyType(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePendencyTypeGQL extends Apollo.Mutation<ArchivePendencyTypeMutation, ArchivePendencyTypeMutationVariables> {
    override document = ArchivePendencyTypeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchivePendencyTypeDocument = gql`
    mutation UnarchivePendencyType($id: ID!) {
  unarchivePendencyType(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchivePendencyTypeGQL extends Apollo.Mutation<UnarchivePendencyTypeMutation, UnarchivePendencyTypeMutationVariables> {
    override document = UnarchivePendencyTypeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductsServicesForTabDocument = gql`
    query ProductsServicesForTab($where: ProductServiceWhereInput, $orderBy: ProductServiceOrderByInput, $limit: Int, $offset: Int) {
  productsServices(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductsServicesForTabGQL extends Apollo.Query<ProductsServicesForTabQuery, ProductsServicesForTabQueryVariables> {
    override document = ProductsServicesForTabDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaintenanceWithLinkedProductsServicesDocument = gql`
    query MaintenanceWithLinkedProductsServices($id: ID!, $where: MaintenanceProductServiceWhereInput) {
  maintenance(id: $id) {
    id
    productsServices(where: $where) {
      items {
        item {
          id
          name
        }
        quantity
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaintenanceWithLinkedProductsServicesGQL extends Apollo.Query<MaintenanceWithLinkedProductsServicesQuery, MaintenanceWithLinkedProductsServicesQueryVariables> {
    override document = MaintenanceWithLinkedProductsServicesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuthenticatedUserDocument = gql`
    query getAuthenticatedUser {
  me {
    id
    name
    email
    avatarUrl
    type
    emailHash
    fieldNewsEmailHash
    role
    loginIntegrationEnabled
    account {
      id
      name
      slug
      featureFlags {
        name
        active
      }
      preferences {
        openMaintenance {
          featureDisableOpenMaintenanceOnPanel
          featureProblemRequired
          maintenanceNumberGenerator
        }
        forms {
          questionsLimit
          featureFormsWithScoredOptions
        }
        quotations {
          featureApproveQuotationByPanel
          featureApproveQuotationByLink
        }
        other {
          featureLocationsPermissionsEnabled
        }
        storages {
          featureSharedStorages
          featureInternalStorages
        }
      }
    }
    preferences {
      featureOpenedMaintenanceSendEmailNotification
    }
    authenticationInfo {
      enabled
      status
    }
    groups {
      id
      name
      permissions {
        name
        category
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuthenticatedUserGQL extends Apollo.Query<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables> {
    override document = GetAuthenticatedUserDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QueryPagedUsersDocument = gql`
    query queryPagedUsers($where: UserWhereInput, $orderBy: UserOrderByInput, $limit: Int, $offset: Int) {
  users(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      email
      archived
      avatarUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QueryPagedUsersGQL extends Apollo.Query<QueryPagedUsersQuery, QueryPagedUsersQueryVariables> {
    override document = QueryPagedUsersDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWarrantiesTemplatesBasicDocument = gql`
    query getWarrantiesTemplatesBasic($where: WarrantiesTemplatesWhereInput, $limit: Int!, $offset: Int, $orderBy: WarrantiesTemplatesOrderByInput) {
  warrantiesTemplates(
    where: $where
    limit: $limit
    offset: $offset
    orderBy: $orderBy
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      description
      value
      type
      coverageDurationDays
      extendedCoverageDurationDays
      extendedValue
      maintenancesTypes {
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWarrantiesTemplatesBasicGQL extends Apollo.Query<GetWarrantiesTemplatesBasicQuery, GetWarrantiesTemplatesBasicQueryVariables> {
    override document = GetWarrantiesTemplatesBasicDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateWarrantyDocument = gql`
    mutation createWarranty($input: CreateWarrantyInput!) {
  createWarranty(input: $input) {
    id
    name
    coverageDurationDays
    extendedCoverageDurationDays
    extendedValue
    endDate
    startDate
    extendedEndDate
    value
    description
    archived
    equipment {
      id
      name
    }
    maintenance {
      id
      number
    }
    template {
      id
      name
    }
    createdBy {
      id
      name
    }
    updatedBy {
      id
      name
    }
    companies {
      id
    }
    maintenancesTypes {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateWarrantyGQL extends Apollo.Mutation<CreateWarrantyMutation, CreateWarrantyMutationVariables> {
    override document = CreateWarrantyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateWarrantyDocument = gql`
    mutation updateWarranty($input: UpdateWarrantyInput!) {
  updateWarranty(input: $input) {
    id
    name
    coverageDurationDays
    extendedCoverageDurationDays
    extendedValue
    endDate
    startDate
    extendedEndDate
    value
    description
    archived
    equipment {
      id
      name
    }
    maintenance {
      id
      number
    }
    template {
      id
      name
    }
    createdBy {
      id
      name
    }
    updatedBy {
      id
      name
    }
    companies {
      id
    }
    maintenancesTypes {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateWarrantyGQL extends Apollo.Mutation<UpdateWarrantyMutation, UpdateWarrantyMutationVariables> {
    override document = UpdateWarrantyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveWarrantyDocument = gql`
    mutation removeWarranty($input: RemoveWarrantyInput!) {
  removeWarranty(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveWarrantyGQL extends Apollo.Mutation<RemoveWarrantyMutation, RemoveWarrantyMutationVariables> {
    override document = RemoveWarrantyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ManageFeatureFlagsDocument = gql`
    mutation ManageFeatureFlags($input: ManageFeatureFlagsInput!) {
  manageFeatureFlags(input: $input) {
    id
    name
    featureFlags {
      name
      active
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ManageFeatureFlagsGQL extends Apollo.Mutation<ManageFeatureFlagsMutation, ManageFeatureFlagsMutationVariables> {
    override document = ManageFeatureFlagsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyByIdDocument = gql`
    query getCompanyById($id: ID!) {
  company(id: $id) {
    id
    name
    avatarUrl
    archived
    fieldAccountId
    address {
      formattedAddress
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyByIdGQL extends Apollo.Query<GetCompanyByIdQuery, GetCompanyByIdQueryVariables> {
    override document = GetCompanyByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyWithStatsByIdDocument = gql`
    query getCompanyWithStatsById($id: ID!) {
  company(id: $id) {
    id
    name
    documentNumber
    avatarUrl
    address {
      formattedAddress
    }
    stats {
      totalMaintenances
      lastMaintenance {
        id
        number
      }
      lastRating {
        stars
      }
      averageRating
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyWithStatsByIdGQL extends Apollo.Query<GetCompanyWithStatsByIdQuery, GetCompanyWithStatsByIdQueryVariables> {
    override document = GetCompanyWithStatsByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyByIdToDetailsDocument = gql`
    query getCompanyByIdToDetails($id: ID!) {
  company(id: $id) {
    id
    name
    documentNumber
    archived
    fieldAccountId
    updatedAt
    preferences {
      featureDisableEditTaskStatus
      featureHideCancelTicketButton
      featureDisableCreateEquipment
      featureDisableCreateEquipmentByApp
      featureQuotationServiceOrderRequired
      featureAssignedEmployeeRequired
      featurePendenciesEnabled
      featureAllowCompanyCreateRecurrence
      featureRecurrenceAssignedEmployeeRequired
      featureStorageControlEnabledByCMMS
      allowOpenMaintenanceForMaintenanceTypeIds
    }
    address {
      countryCode
      zipCode
      city
      street
      number
      formattedAddress
      coords {
        latitude
        longitude
      }
    }
    fieldAccount {
      phone
      phoneCountryCode
      timezone
      accountType
      manager {
        email
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyByIdToDetailsGQL extends Apollo.Query<GetCompanyByIdToDetailsQuery, GetCompanyByIdToDetailsQueryVariables> {
    override document = GetCompanyByIdToDetailsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyDocument = gql`
    mutation updateCompany($id: ID!, $input: CompanyInput!) {
  updateCompany(id: $id, input: $input) {
    id
    name
    avatarUrl
    archived
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyGQL extends Apollo.Mutation<UpdateCompanyMutation, UpdateCompanyMutationVariables> {
    override document = UpdateCompanyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveCompanyAndUnlinkServiceProviderDocument = gql`
    mutation archiveCompanyAndUnlinkServiceProvider($companyId: ID!) {
  archiveCompanyAndUnlinkServiceProvider(companyId: $companyId) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveCompanyAndUnlinkServiceProviderGQL extends Apollo.Mutation<ArchiveCompanyAndUnlinkServiceProviderMutation, ArchiveCompanyAndUnlinkServiceProviderMutationVariables> {
    override document = ArchiveCompanyAndUnlinkServiceProviderDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateContractAttachmentDocument = gql`
    mutation CreateContractAttachment($input: ContractAttachmentCreateInput!) {
  createContractAttachment(input: $input) {
    id
    path
    title
    type
    fileKey
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateContractAttachmentGQL extends Apollo.Mutation<CreateContractAttachmentMutation, CreateContractAttachmentMutationVariables> {
    override document = CreateContractAttachmentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContractAttachmentTitleDocument = gql`
    mutation UpdateContractAttachmentTitle($input: ContractAttachmentUpdateInput!) {
  updateContractAttachmentTitle(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContractAttachmentTitleGQL extends Apollo.Mutation<UpdateContractAttachmentTitleMutation, UpdateContractAttachmentTitleMutationVariables> {
    override document = UpdateContractAttachmentTitleDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveContractAttachmentDocument = gql`
    mutation RemoveContractAttachment($id: ID!) {
  deleteContractAttachment(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveContractAttachmentGQL extends Apollo.Mutation<RemoveContractAttachmentMutation, RemoveContractAttachmentMutationVariables> {
    override document = RemoveContractAttachmentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContractsPaginatedDocument = gql`
    query GetContractsPaginated($where: ContractWhereInput, $orderBy: ContractOrderByInput, $limit: Int, $offset: Int) {
  contracts(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      identifier
      name
      status
      startAt
      description
      endAt
      archived
      company {
        id
        name
        avatarUrl
      }
      dashboard {
        progress
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContractsPaginatedGQL extends Apollo.Query<GetContractsPaginatedQuery, GetContractsPaginatedQueryVariables> {
    override document = GetContractsPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContractByIdWithRecurrencesDocument = gql`
    query GetContractByIdWithRecurrences($id: ID!) {
  contract(id: $id) {
    id
    identifier
    name
    description
    startAt
    endAt
    archived
    attachments {
      id
      path
      fileKey
      bucketName
      title
      type
      size
      createdAt
    }
    status
    createdAt
    updatedAt
    configuration {
      uniqueByEntity
    }
    company {
      id
      name
      avatarUrl
    }
    contractItems {
      configuration {
        isNonRecurring
      }
      segment {
        id
        name
      }
      maintenanceType {
        id
        name
      }
      productsServices {
        id
        name
        productServiceCompanies {
          id
          value
          valueType
          company {
            id
          }
          preferences {
            allowEditValue
            weekDayValues {
              monday
              tuesday
              wednesday
              thursday
              friday
              saturday
              sunday
            }
          }
        }
      }
      repeatInterval
      repeatEvery
      startAt
      endAt
      deadlineContract {
        id
        name
        solutionDeadline {
          unity
          valueInMinutes
        }
      }
      itemLocations {
        recurrence {
          ...RecurrenceFields
        }
        location {
          id
          name
          address {
            formattedAddress
          }
        }
        locationSectors {
          recurrence {
            ...RecurrenceFields
          }
          sector {
            id
            name
            description
          }
          locationSectorEnvironments {
            recurrence {
              ...RecurrenceFields
            }
            environment {
              id
              name
              description
            }
            locationSectorEnvironmentEquipments {
              recurrence {
                ...RecurrenceFields
              }
              equipment {
                id
                name
                number
              }
            }
          }
          locationSectorEquipments {
            recurrence {
              ...RecurrenceFields
            }
            equipment {
              id
              name
              number
            }
          }
        }
        locationEquipments {
          recurrence {
            ...RecurrenceFields
          }
          equipment {
            id
            name
            number
          }
        }
      }
    }
    dashboard {
      progress
      updatedAt
      activities {
        totalMaintenances
        completedMaintenances
        totalOccurrences
        completedOccurrences
      }
      deadlines {
        pending
        onTime
        atRisk
        violated
        completedOnTime
        completedWithViolation
        topViolationReasons {
          label
          count
        }
        avgResolutionTimeMinutes
        maintenancesResolvedOnTimePercent
      }
      maintenanceTypesSummary {
        maintenanceTypeId
        maintenanceTypeName
        completed
        planned
      }
    }
  }
}
    ${RecurrenceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContractByIdWithRecurrencesGQL extends Apollo.Query<GetContractByIdWithRecurrencesQuery, GetContractByIdWithRecurrencesQueryVariables> {
    override document = GetContractByIdWithRecurrencesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetContractOccurrencesDocument = gql`
    query GetContractOccurrences($id: ID!) {
  contract(id: $id) {
    id
    contractItems {
      itemLocations {
        recurrence {
          ...RecurrenceFields
        }
        locationSectors {
          recurrence {
            ...RecurrenceFields
          }
          locationSectorEnvironments {
            recurrence {
              ...RecurrenceFields
            }
            locationSectorEnvironmentEquipments {
              recurrence {
                ...RecurrenceFields
              }
            }
          }
          locationSectorEquipments {
            recurrence {
              ...RecurrenceFields
            }
          }
        }
        locationEquipments {
          recurrence {
            ...RecurrenceFields
          }
        }
      }
    }
  }
}
    ${RecurrenceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetContractOccurrencesGQL extends Apollo.Query<GetContractOccurrencesQuery, GetContractOccurrencesQueryVariables> {
    override document = GetContractOccurrencesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContractIdentifierExistsDocument = gql`
    query ContractIdentifierExists($identifier: String!) {
  contractIdentifierExists(identifier: $identifier)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContractIdentifierExistsGQL extends Apollo.Query<ContractIdentifierExistsQuery, ContractIdentifierExistsQueryVariables> {
    override document = ContractIdentifierExistsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateContractDocument = gql`
    mutation CreateContract($input: CreateContractInput!) {
  createContract(input: $input) {
    id
    contractItems {
      configuration {
        isNonRecurring
      }
      segment {
        id
        name
      }
      maintenanceType {
        id
        name
      }
      itemLocations {
        location {
          id
          name
        }
        recurrence {
          ...RecurrenceFields
        }
        locationSectors {
          sector {
            id
            name
          }
          recurrence {
            ...RecurrenceFields
          }
          locationSectorEnvironments {
            environment {
              id
              name
            }
            recurrence {
              ...RecurrenceFields
            }
            locationSectorEnvironmentEquipments {
              equipment {
                id
                name
              }
              recurrence {
                ...RecurrenceFields
              }
            }
          }
          locationSectorEquipments {
            equipment {
              id
              name
            }
            recurrence {
              ...RecurrenceFields
            }
          }
        }
        locationEquipments {
          equipment {
            id
            name
          }
          recurrence {
            ...RecurrenceFields
          }
        }
      }
    }
  }
}
    ${RecurrenceFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateContractGQL extends Apollo.Mutation<CreateContractMutation, CreateContractMutationVariables> {
    override document = CreateContractDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateContractDocument = gql`
    mutation ActivateContract($input: ActiveContractInput!) {
  activeContract(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateContractGQL extends Apollo.Mutation<ActivateContractMutation, ActivateContractMutationVariables> {
    override document = ActivateContractDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelContractDocument = gql`
    mutation CancelContract($input: CancelContractInput!) {
  cancelContract(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelContractGQL extends Apollo.Mutation<CancelContractMutation, CancelContractMutationVariables> {
    override document = CancelContractDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveContractDocument = gql`
    mutation ArchiveContract($id: ID!) {
  archiveContract(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveContractGQL extends Apollo.Mutation<ArchiveContractMutation, ArchiveContractMutationVariables> {
    override document = ArchiveContractDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveContractDocument = gql`
    mutation UnarchiveContract($id: ID!) {
  unarchiveContract(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveContractGQL extends Apollo.Mutation<UnarchiveContractMutation, UnarchiveContractMutationVariables> {
    override document = UnarchiveContractDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContractDocument = gql`
    mutation UpdateContract($input: UpdateContractInput!) {
  updateContract(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContractGQL extends Apollo.Mutation<UpdateContractMutation, UpdateContractMutationVariables> {
    override document = UpdateContractDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateContractIdentifierDocument = gql`
    mutation GenerateContractIdentifier {
  generateContractIdentifier {
    identifier
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateContractIdentifierGQL extends Apollo.Mutation<GenerateContractIdentifierMutation, GenerateContractIdentifierMutationVariables> {
    override document = GenerateContractIdentifierDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeadlineContractsDocument = gql`
    query deadlineContracts($where: DeadlineContractWhereInput, $orderBy: DeadlineContractOrderByInput, $limit: Int, $offset: Int) {
  deadlineContracts(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      name
      solutionDeadline {
        valueInMinutes
        unity
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeadlineContractsGQL extends Apollo.Query<DeadlineContractsQuery, DeadlineContractsQueryVariables> {
    override document = DeadlineContractsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExternalStorageProductsPaginatedDocument = gql`
    query externalStorageProductsPaginated($limit: Int, $offset: Int, $where: ExternalStorageProductWhereInput!, $orderBy: ExternalStorageProductsOrderByInput) {
  externalStorageProducts(
    limit: $limit
    offset: $offset
    where: $where
    orderBy: $orderBy
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      quantity
      storage {
        id
      }
      product {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExternalStorageProductsPaginatedGQL extends Apollo.Query<ExternalStorageProductsPaginatedQuery, ExternalStorageProductsPaginatedQueryVariables> {
    override document = ExternalStorageProductsPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormsDocument = gql`
    query forms($where: FormWhereInput, $orderBy: FormOrderByInput) {
  forms(where: $where, orderBy: $orderBy) {
    items {
      id
      name
      archived
      questions {
        id
        title
        type
        position
        required
        options {
          id
          value
          position
        }
        conditions {
          operator
          value
          question {
            id
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FormsGQL extends Apollo.Query<FormsQuery, FormsQueryVariables> {
    override document = FormsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormDocument = gql`
    query form($id: ID!) {
  form(id: $id) {
    id
    name
    archived
    questions {
      id
      title
      type
      position
      required
      options {
        id
        value
        position
      }
      conditions {
        operator
        value
        question {
          id
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FormGQL extends Apollo.Query<FormQuery, FormQueryVariables> {
    override document = FormDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvitesDocument = gql`
    query invites($where: InvitesWhereInput) {
  invites(where: $where) {
    id
    email
    status
    sentAt
    expiredAt
    acceptedAt
    refusedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvitesGQL extends Apollo.Query<InvitesQuery, InvitesQueryVariables> {
    override document = InvitesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInviteDocument = gql`
    mutation createInvite($input: CreateInviteInput!) {
  createInvite(input: $input) {
    created {
      id
      email
      status
      sentAt
      expiredAt
      acceptedAt
      refusedAt
    }
    alreadyPending
    alreadyAccepted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInviteGQL extends Apollo.Mutation<CreateInviteMutation, CreateInviteMutationVariables> {
    override document = CreateInviteDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendInviteDocument = gql`
    mutation resendInvite($inviteId: ID!) {
  resendInvite(inviteId: $inviteId) {
    id
    status
    sentAt
    expiredAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendInviteGQL extends Apollo.Mutation<ResendInviteMutation, ResendInviteMutationVariables> {
    override document = ResendInviteDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsJourneyFormSubmittedDocument = gql`
    query IsJourneyFormSubmitted {
  journey {
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsJourneyFormSubmittedGQL extends Apollo.Query<IsJourneyFormSubmittedQuery, IsJourneyFormSubmittedQueryVariables> {
    override document = IsJourneyFormSubmittedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetJourneyDocument = gql`
    query GetJourney {
  journey {
    overallProgress
    status
    steps {
      essential {
        maintenanceType
        locations
        segments
        companies
      }
      operation {
        operationsStructure {
          equipment
          equipmentTypes
        }
        costResource {
          services
          expenses
        }
        stockControl {
          products
          storageMovements
          storageProducts
        }
        standardization {
          form
        }
        rules {
          contracts
          deadlines
          warranties
        }
      }
      configuration {
        accountRules {
          users
          permissionGroups
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetJourneyGQL extends Apollo.Query<GetJourneyQuery, GetJourneyQueryVariables> {
    override document = GetJourneyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JourneyFormQuestionsDocument = gql`
    query JourneyFormQuestions {
  journeyFormQuestions {
    key
    position
    metadata
    translations {
      locale
      title
      description
    }
    options {
      key
      is_recommended
      translations {
        locale
        label
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JourneyFormQuestionsGQL extends Apollo.Query<JourneyFormQuestionsQuery, JourneyFormQuestionsQueryVariables> {
    override document = JourneyFormQuestionsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitJourneyFormDocument = gql`
    mutation SubmitJourneyForm($input: SubmitJourneyFormInput!) {
  submitJourneyForm(input: $input) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitJourneyFormGQL extends Apollo.Mutation<SubmitJourneyFormMutation, SubmitJourneyFormMutationVariables> {
    override document = SubmitJourneyFormDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompleteJourneyDocument = gql`
    mutation CompleteJourney {
  completeJourney {
    overallProgress
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompleteJourneyGQL extends Apollo.Mutation<CompleteJourneyMutation, CompleteJourneyMutationVariables> {
    override document = CompleteJourneyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedLocationsDocument = gql`
    query paginatedLocations($where: LocationWhereInput, $orderBy: LocationOrderByObjectInput, $limit: Int, $offset: Int) {
  locationsNew(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      address {
        formattedAddress
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedLocationsGQL extends Apollo.Query<PaginatedLocationsQuery, PaginatedLocationsQueryVariables> {
    override document = PaginatedLocationsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationsAddressesDocument = gql`
    query GetLocationsAddresses($where: LocationWhereInput, $orderBy: LocationOrderByObjectInput, $limit: Int, $offset: Int) {
  locationsNew(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      address {
        formattedAddress
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationsAddressesGQL extends Apollo.Query<GetLocationsAddressesQuery, GetLocationsAddressesQueryVariables> {
    override document = GetLocationsAddressesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationsWithChildrensDocument = gql`
    query getLocationsWithChildrens($where: LocationWhereInput, $orderBy: LocationOrderByObjectInput, $limit: Int, $offset: Int) {
  locationsNew(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      segments {
        id
      }
      address {
        formattedAddress
      }
      equipments {
        id
        number
        name
        type {
          segment {
            id
          }
        }
      }
      sectors {
        id
        name
        description
        equipmentsWithoutEnvironment {
          id
          number
          name
          type {
            segment {
              id
            }
          }
        }
        locationEnvironments {
          id
          name
          description
          equipments {
            id
            number
            name
            type {
              segment {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationsWithChildrensGQL extends Apollo.Query<GetLocationsWithChildrensQuery, GetLocationsWithChildrensQueryVariables> {
    override document = GetLocationsWithChildrensDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedMaintenanceTypesDocument = gql`
    query paginatedMaintenanceTypes($where: MaintenanceTypeWhereInput, $orderBy: MaintenanceTypeOrderByInput, $limit: Int, $offset: Int) {
  maintenanceTypes(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedMaintenanceTypesGQL extends Apollo.Query<PaginatedMaintenanceTypesQuery, PaginatedMaintenanceTypesQueryVariables> {
    override document = PaginatedMaintenanceTypesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaginatedMaintenancesDocument = gql`
    query getPaginatedMaintenances($where: MaintenanceWhereInput, $orderBy: MaintenanceOrderByInput, $limit: Int, $offset: Int) {
  maintenances(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      number
      status
      message
      openedAt
      location {
        id
        name
      }
      segment {
        id
        name
      }
      maintenanceType {
        id
        name
      }
      warrantySummary {
        status
        startDate
        extendedEndDate
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaginatedMaintenancesGQL extends Apollo.Query<GetPaginatedMaintenancesQuery, GetPaginatedMaintenancesQueryVariables> {
    override document = GetPaginatedMaintenancesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StoragesMovementsPaginatedDocument = gql`
    query StoragesMovementsPaginated($limit: Int, $offset: Int, $where: StoragesMovementsWhereInput, $orderBy: StoragesMovementsOrderByInput) {
  storagesMovements(
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    where: $where
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      type
      createdAt
      quantity {
        changed
      }
      storage {
        id
        name
      }
      externalStorage {
        id
        name
      }
      maintenance {
        id
        number
      }
      product {
        id
        name
        imageUrl
        measure
        productType {
          id
          name
        }
      }
      company {
        id
        name
        avatarUrl
      }
      createdBy {
        name
        avatarUrl
      }
      createdByAvatarUrl
      createdByName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StoragesMovementsPaginatedGQL extends Apollo.Query<StoragesMovementsPaginatedQuery, StoragesMovementsPaginatedQueryVariables> {
    override document = StoragesMovementsPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StorageMovementDocument = gql`
    query StorageMovement($id: ID!) {
  storageMovement(id: $id) {
    id
    description
    company {
      id
      name
      avatarUrl
    }
    maintenance {
      id
      number
    }
    createdByName
    createdByAvatarUrl
    storage {
      id
      name
    }
    externalStorage {
      name
      employee {
        name
        avatarUrl
      }
    }
    externalStorageMovement {
      quantity
      oldQuantity
    }
    relatedStorageMovement {
      quantity {
        previous
        changed
        current
      }
      storage {
        id
        name
      }
      externalStorage {
        id
        name
      }
    }
    type
    quantity {
      previous
      changed
      current
    }
    product {
      id
      name
      code
      imageUrl
      measure
      productType {
        id
        name
      }
    }
    createdAt
    updatedAt
    createdBy {
      name
      avatarUrl
    }
    updatedBy {
      name
      avatarUrl
    }
    sync {
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StorageMovementGQL extends Apollo.Query<StorageMovementQuery, StorageMovementQueryVariables> {
    override document = StorageMovementDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStorageMovementDocument = gql`
    mutation CreateStorageMovement($input: CreateStorageMovementInput!) {
  createStorageMovement(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStorageMovementGQL extends Apollo.Mutation<CreateStorageMovementMutation, CreateStorageMovementMutationVariables> {
    override document = CreateStorageMovementDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStorageMovementDocument = gql`
    mutation UpdateStorageMovement($input: UpdateStorageMovementInput!) {
  updateStorageMovement(input: $input) {
    id
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStorageMovementGQL extends Apollo.Mutation<UpdateStorageMovementMutation, UpdateStorageMovementMutationVariables> {
    override document = UpdateStorageMovementDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaginatedOccurrencesDocument = gql`
    query GetPaginatedOccurrences($where: OccurrenceWhereInput!, $orderBy: OccurrenceOrderByInput, $limit: Int, $offset: Int) {
  occurrences(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    items {
      id
      iteration
      scheduledAt
      scheduledDate
      scheduledType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaginatedOccurrencesGQL extends Apollo.Query<GetPaginatedOccurrencesQuery, GetPaginatedOccurrencesQueryVariables> {
    override document = GetPaginatedOccurrencesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccurrencesWithMaintenanceDocument = gql`
    query GetOccurrencesWithMaintenance($where: OccurrenceWhereInput!, $orderBy: OccurrenceOrderByInput, $limit: Int, $offset: Int) {
  occurrences(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    items {
      id
      iteration
      scheduledAt
      scheduledDate
      scheduledType
      maintenance {
        id
        status
        assignee {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccurrencesWithMaintenanceGQL extends Apollo.Query<GetOccurrencesWithMaintenanceQuery, GetOccurrencesWithMaintenanceQueryVariables> {
    override document = GetOccurrencesWithMaintenanceDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaymentLogsDocument = gql`
    query GetPaymentLogs($where: PaymentLogWhereInput, $orderBy: PaymentLogOrderByInput, $limit: Int, $offset: Int) {
  paymentLogs(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      type
      createdAt
      clientApplicationName
      data {
        cancellationReason
      }
      autor {
        name
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentLogsGQL extends Apollo.Query<GetPaymentLogsQuery, GetPaymentLogsQueryVariables> {
    override document = GetPaymentLogsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedPaymentsDocument = gql`
    query paginatedPayments($where: PaymentWhereInput, $orderBy: PaymentOrderByInput, $limit: Int, $offset: Int) {
  payments(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      number
      description
      status
      description
      totalValue
      archived
      createdAt
      createdBy {
        id
        name
        avatarUrl
      }
      company {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedPaymentsGQL extends Apollo.Query<PaginatedPaymentsQuery, PaginatedPaymentsQueryVariables> {
    override document = PaginatedPaymentsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaymentByIdDocument = gql`
    query GetPaymentById($id: ID!) {
  payment(id: $id) {
    id
    number
    description
    status
    totalValue
    archived
    createdAt
    attachments {
      id
      title
      path
      createdAt
    }
    maintenancesConnection {
      totalCount
    }
    createdBy {
      id
      name
      avatarUrl
    }
    company {
      id
      name
      avatarUrl
    }
    maintenancesConnection {
      items {
        id
      }
    }
    quotationsConnection {
      items {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentByIdGQL extends Apollo.Query<GetPaymentByIdQuery, GetPaymentByIdQueryVariables> {
    override document = GetPaymentByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NextPaymentNumberDocument = gql`
    query NextPaymentNumber {
  nextPaymentNumber {
    number
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NextPaymentNumberGQL extends Apollo.Query<NextPaymentNumberQuery, NextPaymentNumberQueryVariables> {
    override document = NextPaymentNumberDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListPaymentMaintenancesDocument = gql`
    query ListPaymentMaintenances($where: MaintenanceWhereInput, $orderBy: MaintenanceOrderByInput, $limit: Int, $offset: Int) {
  maintenances(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      number
      status
      openedAt
      closedAt
      productsTotalValue
      servicesTotalValue
      totalValue
      orderId
      location {
        id
        name
      }
      maintenanceType {
        id
        name
      }
      segment {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListPaymentMaintenancesGQL extends Apollo.Query<ListPaymentMaintenancesQuery, ListPaymentMaintenancesQueryVariables> {
    override document = ListPaymentMaintenancesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePaymentDocument = gql`
    mutation CreatePayment($input: CreatePaymentInput!) {
  createPayment(input: $input) {
    id
    number
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePaymentGQL extends Apollo.Mutation<CreatePaymentMutation, CreatePaymentMutationVariables> {
    override document = CreatePaymentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($input: UpdatePaymentInput!) {
  updatePayment(input: $input) {
    id
    number
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePaymentGQL extends Apollo.Mutation<UpdatePaymentMutation, UpdatePaymentMutationVariables> {
    override document = UpdatePaymentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePaymentDocument = gql`
    mutation ArchivePayment($id: ID!) {
  archivePayment(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePaymentGQL extends Apollo.Mutation<ArchivePaymentMutation, ArchivePaymentMutationVariables> {
    override document = ArchivePaymentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchivePaymentDocument = gql`
    mutation UnarchivePayment($id: ID!) {
  unarchivePayment(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchivePaymentGQL extends Apollo.Mutation<UnarchivePaymentMutation, UnarchivePaymentMutationVariables> {
    override document = UnarchivePaymentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkPaymentAsPaidDocument = gql`
    mutation MarkPaymentAsPaid($input: MarkPaymentAsPaidInput!) {
  markPaymentAsPaid(input: $input) {
    id
    status
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkPaymentAsPaidGQL extends Apollo.Mutation<MarkPaymentAsPaidMutation, MarkPaymentAsPaidMutationVariables> {
    override document = MarkPaymentAsPaidDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListPaymentQuotationsDocument = gql`
    query ListPaymentQuotations($where: QuotationWhereInput, $orderBy: QuotationOrderByInput, $limit: Int, $offset: Int) {
  quotations(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      identifier
      name
      status
      createdAt
      approvedAt
      expensesTotalValue
      productsServicesTotalValues {
        productsTotalValue
        servicesTotalValue
      }
      maintenance {
        id
        status
        maintenanceType {
          id
          name
        }
        segment {
          id
          name
        }
      }
      total
      location {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListPaymentQuotationsGQL extends Apollo.Query<ListPaymentQuotationsQuery, ListPaymentQuotationsQueryVariables> {
    override document = ListPaymentQuotationsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveMaintenancesFromPaymentDocument = gql`
    mutation RemoveMaintenancesFromPayment($input: RemoveMaintenancesFromPaymentInput!) {
  removeMaintenancesFromPayment(input: $input) {
    id
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveMaintenancesFromPaymentGQL extends Apollo.Mutation<RemoveMaintenancesFromPaymentMutation, RemoveMaintenancesFromPaymentMutationVariables> {
    override document = RemoveMaintenancesFromPaymentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddMaintenancesToPaymentDocument = gql`
    mutation AddMaintenancesToPayment($input: AddMaintenancesToPaymentInput!) {
  addMaintenancesToPayment(input: $input) {
    id
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddMaintenancesToPaymentGQL extends Apollo.Mutation<AddMaintenancesToPaymentMutation, AddMaintenancesToPaymentMutationVariables> {
    override document = AddMaintenancesToPaymentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddQuotationsToPaymentDocument = gql`
    mutation AddQuotationsToPayment($input: AddQuotationsToPaymentInput!) {
  addQuotationsToPayment(input: $input) {
    id
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddQuotationsToPaymentGQL extends Apollo.Mutation<AddQuotationsToPaymentMutation, AddQuotationsToPaymentMutationVariables> {
    override document = AddQuotationsToPaymentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveQuotationsFromPaymentDocument = gql`
    mutation RemoveQuotationsFromPayment($input: RemoveQuotationsFromPaymentInput!) {
  removeQuotationsFromPayment(input: $input) {
    id
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveQuotationsFromPaymentGQL extends Apollo.Mutation<RemoveQuotationsFromPaymentMutation, RemoveQuotationsFromPaymentMutationVariables> {
    override document = RemoveQuotationsFromPaymentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductsServicesPaginatedDocument = gql`
    query ProductsServicesPaginated($where: ProductServiceWhereInput, $orderBy: ProductServiceOrderByInput, $limit: Int, $offset: Int) {
  productsServices(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductsServicesPaginatedGQL extends Apollo.Query<ProductsServicesPaginatedQuery, ProductsServicesPaginatedQueryVariables> {
    override document = ProductsServicesPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedProductTypesDocument = gql`
    query paginatedProductTypes($where: ProductTypeWhereInput, $orderBy: ProductTypeOrderByInput, $limit: Int, $offset: Int) {
  productTypes(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedProductTypesGQL extends Apollo.Query<PaginatedProductTypesQuery, PaginatedProductTypesQueryVariables> {
    override document = PaginatedProductTypesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductsPaginatedDocument = gql`
    query ProductsPaginated($limit: Int, $offset: Int, $where: ProductsWhereInput, $orderBy: ProductsOrderByInput, $companyId: ID!, $includeCompanyProduct: Boolean = false) {
  products(limit: $limit, offset: $offset, orderBy: $orderBy, where: $where) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      code
      imageUrl
      measure
      productCompany(companyId: $companyId) @include(if: $includeCompanyProduct) {
        fieldProductServiceId
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductsPaginatedGQL extends Apollo.Query<ProductsPaginatedQuery, ProductsPaginatedQueryVariables> {
    override document = ProductsPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaginatedSegmentsDocument = gql`
    query getPaginatedSegments($where: SegmentWhereInput, $orderBy: SegmentOrderByInput, $limit: Int, $offset: Int) {
  segments(where: $where, limit: $limit, offset: $offset, orderBy: $orderBy) {
    totalCount
    items {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaginatedSegmentsGQL extends Apollo.Query<GetPaginatedSegmentsQuery, GetPaginatedSegmentsQueryVariables> {
    override document = GetPaginatedSegmentsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServicesPaginatedDocument = gql`
    query ServicesPaginated($where: ServiceWhereInput, $orderBy: ServiceOrderByInput, $limit: Int, $offset: Int) {
  services(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      measure
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServicesPaginatedGQL extends Apollo.Query<ServicesPaginatedQuery, ServicesPaginatedQueryVariables> {
    override document = ServicesPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServicesCompaniesPaginatedDocument = gql`
    query ServicesCompaniesPaginated($where: ServiceWhereInput, $orderBy: ServiceOrderByInput, $limit: Int, $offset: Int) {
  services(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      companies {
        id
        value
        valueType
        company {
          id
        }
        preferences {
          allowEditValue
          weekDayValues {
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
            sunday
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServicesCompaniesPaginatedGQL extends Apollo.Query<ServicesCompaniesPaginatedQuery, ServicesCompaniesPaginatedQueryVariables> {
    override document = ServicesCompaniesPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InternalStoragesPaginatedDocument = gql`
    query InternalStoragesPaginated($limit: Int, $offset: Int, $where: StoragesWhereInput, $orderBy: StoragesOrderByInput) {
  storages(limit: $limit, offset: $offset, orderBy: $orderBy, where: $where) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InternalStoragesPaginatedGQL extends Apollo.Query<InternalStoragesPaginatedQuery, InternalStoragesPaginatedQueryVariables> {
    override document = InternalStoragesPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InternalStoragePaginatedDocument = gql`
    query InternalStoragePaginated($ID: ID!) {
  storage(id: $ID) {
    id
    name
    archived
    description
    createdBy {
      id
      name
      avatarUrl
      type
    }
    updatedBy {
      id
      name
      avatarUrl
      type
    }
    createdAt
    updatedAt
    products {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      items {
        id
        quantity
        product {
          id
          name
          code
          imageUrl
          measure
        }
        minimalQuantity
        minimalQuantityAtRisk
        createdAt
        updatedAt
        createdBy {
          id
          name
          avatarUrl
          type
        }
        updatedBy {
          id
          name
          avatarUrl
          type
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InternalStoragePaginatedGQL extends Apollo.Query<InternalStoragePaginatedQuery, InternalStoragePaginatedQueryVariables> {
    override document = InternalStoragePaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExternalStoragesPaginatedDocument = gql`
    query ExternalStoragesPaginated($limit: Int, $offset: Int, $where: ExternalStoragesWhereInput!, $orderBy: ExternalStoragesOrderByInput) {
  externalStorages(
    limit: $limit
    offset: $offset
    where: $where
    orderBy: $orderBy
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      description
      archived
      employee {
        id
        name
        avatarUrl
      }
      storageProduct {
        quantity
        product {
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExternalStoragesPaginatedGQL extends Apollo.Query<ExternalStoragesPaginatedQuery, ExternalStoragesPaginatedQueryVariables> {
    override document = ExternalStoragesPaginatedDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TicketDocument = gql`
    query ticket($id: ID!) {
  ticket(id: $id) {
    id
    number
    message
    clientApplicationName
    addressHash
    cancelationReason
    archived
    formAnswers {
      id
      name
      archived
      status
      createdAt
      updatedAt
      questionAnswers {
        id
        title
        answer
        type
        position
        required
        options {
          id
          value
          position
          score
        }
        conditions {
          operator
          question {
            id
          }
          value
        }
        createdAt
        answeredAt
      }
      equipment {
        id
        name
      }
      type
    }
    address {
      zipCode
      street
      city
      number
      complement
      neighborhood
      state
      formattedAddress
      coords {
        latitude
        longitude
      }
    }
    status
    segment {
      id
      name
    }
    attachments {
      id
      path
      title
      type
      size
      createdAt
    }
    maintenanceType {
      id
      name
    }
    requester {
      id
      name
      email
      avatarUrl
      guest {
        documentNumber
        phoneNumber
        locations {
          id
          name
          address {
            formattedAddress
          }
        }
      }
    }
    updatedBy {
      id
      name
      avatarUrl
    }
    equipments {
      id
      number
      name
      type {
        id
        name
      }
      warranties {
        id
        name
        status
        startDate
        endDate
        extendedEndDate
        coverageDurationDays
        extendedCoverageDurationDays
        value
        extendedValue
        description
        equipment {
          id
          name
        }
      }
      warrantySummary {
        id
        status
        startDate
        endDate
        extendedEndDate
        createdAt
        updatedAt
      }
      locationSector {
        id
        name
      }
      locationEnvironment {
        id
        name
      }
      location {
        id
        name
        address {
          formattedAddress
        }
      }
    }
    locationSectors {
      id
      name
      description
      location {
        id
        name
        address {
          formattedAddress
        }
      }
    }
    locationEnvironments {
      id
      name
      description
      locationSector {
        id
        name
        location {
          name
          address {
            formattedAddress
          }
        }
      }
    }
    updatedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TicketGQL extends Apollo.Query<TicketQuery, TicketQueryVariables> {
    override document = TicketDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TicketCommentsDocument = gql`
    query ticketComments($id: ID!, $limit: Int = 20, $offset: Int = 0) {
  ticket(id: $id) {
    comments(orderBy: createdAt_desc, limit: $limit, offset: $offset) {
      id
      message
      type
      createdAt
      archived
      postedBy {
        id
        name
        avatarUrl
        type
      }
      company {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TicketCommentsGQL extends Apollo.Query<TicketCommentsQuery, TicketCommentsQueryVariables> {
    override document = TicketCommentsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMaintenanceCommentDocument = gql`
    mutation createMaintenanceComment($input: CommentInput!) {
  createMaintenanceComment(input: $input) {
    id
    message
    type
    createdAt
    archived
    postedBy {
      id
      name
      avatarUrl
      type
    }
    company {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMaintenanceCommentGQL extends Apollo.Mutation<CreateMaintenanceCommentMutation, CreateMaintenanceCommentMutationVariables> {
    override document = CreateMaintenanceCommentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveMaintenanceCommentDocument = gql`
    mutation removeMaintenanceComment($id: ID!) {
  removeMaintenanceComment(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveMaintenanceCommentGQL extends Apollo.Mutation<RemoveMaintenanceCommentMutation, RemoveMaintenanceCommentMutationVariables> {
    override document = RemoveMaintenanceCommentDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TicketsDocument = gql`
    query tickets($where: TicketWhereInput, $orderBy: TicketOrderByInput, $limit: Int, $offset: Int) {
  tickets(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    items {
      id
      number
      message
      status
      archived
      equipments {
        id
        warrantySummary {
          status
        }
      }
      maintenanceType {
        id
        name
      }
      segment {
        id
        name
      }
      requester {
        id
        name
        avatarUrl
      }
      updatedBy {
        id
        name
        avatarUrl
      }
      address {
        formattedAddress
      }
      updatedAt
      createdAt
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TicketsGQL extends Apollo.Query<TicketsQuery, TicketsQueryVariables> {
    override document = TicketsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveTicketDocument = gql`
    mutation archiveTicket($id: ID!) {
  archiveTicket(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveTicketGQL extends Apollo.Mutation<ArchiveTicketMutation, ArchiveTicketMutationVariables> {
    override document = ArchiveTicketDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveTicketDocument = gql`
    mutation unarchiveTicket($id: ID!) {
  unarchiveTicket(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveTicketGQL extends Apollo.Mutation<UnarchiveTicketMutation, UnarchiveTicketMutationVariables> {
    override document = UnarchiveTicketDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptTicketDocument = gql`
    mutation acceptTicket($id: ID!) {
  acceptTicket(id: $id) {
    id
    maintenance {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptTicketGQL extends Apollo.Mutation<AcceptTicketMutation, AcceptTicketMutationVariables> {
    override document = AcceptTicketDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RejectTicketDocument = gql`
    mutation rejectTicket($input: TicketRejectInput!) {
  rejectTicket(input: $input) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectTicketGQL extends Apollo.Mutation<RejectTicketMutation, RejectTicketMutationVariables> {
    override document = RejectTicketDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveTicketsDocument = gql`
    mutation unarchiveTickets($input: [ID!]!) {
  unarchiveTickets(input: $input) {
    message
    clientApplicationName
    number
    archived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveTicketsGQL extends Apollo.Mutation<UnarchiveTicketsMutation, UnarchiveTicketsMutationVariables> {
    override document = UnarchiveTicketsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveTicketsDocument = gql`
    mutation archiveTickets($input: [ID!]!) {
  archiveTickets(input: $input) {
    message
    clientApplicationName
    number
    archived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveTicketsGQL extends Apollo.Mutation<ArchiveTicketsMutation, ArchiveTicketsMutationVariables> {
    override document = ArchiveTicketsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MainGetAuthenticatedUserDocument = gql`
    query mainGetAuthenticatedUser {
  me {
    id
    name
    email
    avatarUrl
    type
    emailHash
    fieldNewsEmailHash
    role
    loginIntegrationEnabled
    account {
      id
      name
      createdAt
      slug
      featureFlags {
        name
        active
      }
      preferences {
        openMaintenance {
          featureDisableOpenMaintenanceOnPanel
          featureProblemRequired
          maintenanceNumberGenerator
        }
        forms {
          questionsLimit
          featureFormsWithScoredOptions
        }
        quotations {
          featureApproveQuotationByPanel
          featureApproveQuotationByLink
        }
        other {
          featureLocationsPermissionsEnabled
        }
        storages {
          featureSharedStorages
          featureInternalStorages
        }
      }
    }
    preferences {
      featureOpenedMaintenanceSendEmailNotification
    }
    authenticationInfo {
      enabled
      status
    }
    groups {
      id
      name
      permissions {
        name
        category
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MainGetAuthenticatedUserGQL extends Apollo.Query<MainGetAuthenticatedUserQuery, MainGetAuthenticatedUserQueryVariables> {
    override document = MainGetAuthenticatedUserDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWarrantiesTemplatesTotalCountDocument = gql`
    query getWarrantiesTemplatesTotalCount($where: WarrantiesTemplatesWhereInput, $limit: Int!, $offset: Int, $orderBy: WarrantiesTemplatesOrderByInput) {
  warrantiesTemplates(
    where: $where
    limit: $limit
    offset: $offset
    orderBy: $orderBy
  ) {
    totalCount
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWarrantiesTemplatesTotalCountGQL extends Apollo.Query<GetWarrantiesTemplatesTotalCountQuery, GetWarrantiesTemplatesTotalCountQueryVariables> {
    override document = GetWarrantiesTemplatesTotalCountDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListLocationsOverlayDocument = gql`
    query ListLocationsOverlay($where: LocationWhereInput, $orderBy: LocationOrderByObjectInput!, $limit: Int, $offset: Int) {
  locations(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      name
      archived
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListLocationsOverlayGQL extends Apollo.Query<ListLocationsOverlayQuery, ListLocationsOverlayQueryVariables> {
    override document = ListLocationsOverlayDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListMaintenanceTypeOverlayDocument = gql`
    query ListMaintenanceTypeOverlay($where: MaintenanceTypeWhereInput, $orderBy: MaintenanceTypeOrderByInput!, $limit: Int, $offset: Int) {
  maintenanceTypes(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      name
      archived
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListMaintenanceTypeOverlayGQL extends Apollo.Query<ListMaintenanceTypeOverlayQuery, ListMaintenanceTypeOverlayQueryVariables> {
    override document = ListMaintenanceTypeOverlayDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListSegmentOverlayDocument = gql`
    query ListSegmentOverlay($where: SegmentWhereInput, $orderBy: SegmentOrderByInput!, $limit: Int, $offset: Int) {
  segments(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      name
      archived
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListSegmentOverlayGQL extends Apollo.Query<ListSegmentOverlayQuery, ListSegmentOverlayQueryVariables> {
    override document = ListSegmentOverlayDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyFilterDocument = gql`
    query CompanyFilter($where: CompanyWhereInput, $orderBy: CompanyOrderByInput, $limit: Int, $offset: Int) {
  companies(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      avatarUrl
      archived
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyFilterGQL extends Apollo.Query<CompanyFilterQuery, CompanyFilterQueryVariables> {
    override document = CompanyFilterDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExportDocument = gql`
    mutation createExport($input: CreateExportInput!) {
  createExport(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExportGQL extends Apollo.Mutation<CreateExportMutation, CreateExportMutationVariables> {
    override document = CreateExportDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateUploadCredentialDocument = gql`
    mutation generateUploadCredential($input: UploadCredentialInput!) {
  generateUploadCredential(input: $input) {
    baseUrl
    fields
    link
    bucketName
    fileKey
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateUploadCredentialGQL extends Apollo.Mutation<GenerateUploadCredentialMutation, GenerateUploadCredentialMutationVariables> {
    override document = GenerateUploadCredentialDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuditLogsDocument = gql`
    query auditLogs($where: AuditLogsWhereInput, $orderBy: AuditLogsOrderByInput, $limit: Int, $offset: Int) {
  auditLogs(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      type
      action
      browser
      userAgent
      applicationName
      operatingSystem
      clientIpAddress
      createdAt
      metadata {
        value
        change
        preference
        permission {
          name
        }
        group {
          id
          name
        }
        user {
          id
          name
          type
          role
        }
        company {
          id
          name
        }
        responseFromSesType
        emailStatus
      }
      createdBy {
        id
        name
        email
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AuditLogsGQL extends Apollo.Query<AuditLogsQuery, AuditLogsQueryVariables> {
    override document = AuditLogsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportsDocument = gql`
    query exports($where: ExportsWhereInput, $orderBy: ExportsOrderByInput, $limit: Int, $offset: Int) {
  exports(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      type
      status
      expiredAt
      createdAt
      updatedAt
      completedAt
      download {
        signedUrl
        expiresAt
      }
      createdBy {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportsGQL extends Apollo.Query<ExportsQuery, ExportsQueryVariables> {
    override document = ExportsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeadlineViolationReasonsDocument = gql`
    query DeadlineViolationReasons($where: DeadlineViolationReasonWhereInput, $orderBy: DeadlineViolationReasonOrderByInput, $limit: Int, $offset: Int) {
  deadlineViolationReasons(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      color
      description
      createdAt
      archived
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeadlineViolationReasonsGQL extends Apollo.Query<DeadlineViolationReasonsQuery, DeadlineViolationReasonsQueryVariables> {
    override document = DeadlineViolationReasonsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeadlineViolationReasonByIdDocument = gql`
    query DeadlineViolationReasonById($id: ID!) {
  deadlineViolationReason(id: $id) {
    id
    name
    color
    archived
    description
    deadlineContracts {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeadlineViolationReasonByIdGQL extends Apollo.Query<DeadlineViolationReasonByIdQuery, DeadlineViolationReasonByIdQueryVariables> {
    override document = DeadlineViolationReasonByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDeadlineViolationReasonDocument = gql`
    mutation CreateDeadlineViolationReason($input: CreateDeadlineViolationReasonInput!) {
  createDeadlineViolationReason(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDeadlineViolationReasonGQL extends Apollo.Mutation<CreateDeadlineViolationReasonMutation, CreateDeadlineViolationReasonMutationVariables> {
    override document = CreateDeadlineViolationReasonDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDeadlineViolationReasonDocument = gql`
    mutation UpdateDeadlineViolationReason($input: UpdateDeadlineViolationReasonInput!) {
  updateDeadlineViolationReason(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDeadlineViolationReasonGQL extends Apollo.Mutation<UpdateDeadlineViolationReasonMutation, UpdateDeadlineViolationReasonMutationVariables> {
    override document = UpdateDeadlineViolationReasonDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveDeadlineViolationReasonDocument = gql`
    mutation ArchiveDeadlineViolationReason($id: ID!) {
  archiveDeadlineViolationReason(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveDeadlineViolationReasonGQL extends Apollo.Mutation<ArchiveDeadlineViolationReasonMutation, ArchiveDeadlineViolationReasonMutationVariables> {
    override document = ArchiveDeadlineViolationReasonDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveDeadlineViolationReasonDocument = gql`
    mutation UnarchiveDeadlineViolationReason($id: ID!) {
  unarchiveDeadlineViolationReason(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveDeadlineViolationReasonGQL extends Apollo.Mutation<UnarchiveDeadlineViolationReasonMutation, UnarchiveDeadlineViolationReasonMutationVariables> {
    override document = UnarchiveDeadlineViolationReasonDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductTypesPageDocument = gql`
    query ProductTypesPage($where: ProductTypeWhereInput, $orderBy: ProductTypeOrderByInput, $limit: Int, $offset: Int) {
  productTypes(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      archived
      description
      createdAt
      updatedAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductTypesPageGQL extends Apollo.Query<ProductTypesPageQuery, ProductTypesPageQueryVariables> {
    override document = ProductTypesPageDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductTypeByIdDocument = gql`
    query ProductTypeById($id: ID!) {
  productType(id: $id) {
    id
    name
    archived
    description
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductTypeByIdGQL extends Apollo.Query<ProductTypeByIdQuery, ProductTypeByIdQueryVariables> {
    override document = ProductTypeByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProductTypeDocument = gql`
    mutation CreateProductType($input: CreateProductTypeInput!) {
  createProductType(input: $input) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProductTypeGQL extends Apollo.Mutation<CreateProductTypeMutation, CreateProductTypeMutationVariables> {
    override document = CreateProductTypeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductTypeDocument = gql`
    mutation UpdateProductType($input: UpdateProductTypeInput!) {
  updateProductType(input: $input) {
    id
    name
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductTypeGQL extends Apollo.Mutation<UpdateProductTypeMutation, UpdateProductTypeMutationVariables> {
    override document = UpdateProductTypeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveProductTypeDocument = gql`
    mutation ArchiveProductType($id: ID!) {
  archiveProductType(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveProductTypeGQL extends Apollo.Mutation<ArchiveProductTypeMutation, ArchiveProductTypeMutationVariables> {
    override document = ArchiveProductTypeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveProductTypeDocument = gql`
    mutation UnarchiveProductType($id: ID!) {
  unarchiveProductType(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveProductTypeGQL extends Apollo.Mutation<UnarchiveProductTypeMutation, UnarchiveProductTypeMutationVariables> {
    override document = UnarchiveProductTypeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExpensesDocument = gql`
    query expenses($where: ExpenseWhereInput, $orderBy: ExpenseOrderByInput, $limit: Int, $offset: Int) {
  expenses(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    items {
      id
      name
      description
      maxValue
      receiptRequired
      createdAt
      updatedAt
      archived
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExpensesGQL extends Apollo.Query<ExpensesQuery, ExpensesQueryVariables> {
    override document = ExpensesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExpenseDocument = gql`
    query expense($id: ID!) {
  expense(id: $id) {
    id
    name
    description
    maxValue
    receiptRequired
    createdAt
    updatedAt
    archived
    createdBy {
      id
      name
    }
    updatedBy {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExpenseGQL extends Apollo.Query<ExpenseQuery, ExpenseQueryVariables> {
    override document = ExpenseDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExpenseDocument = gql`
    mutation createExpense($input: CreateExpenseInput!) {
  createExpense(input: $input) {
    id
    name
    description
    maxValue
    receiptRequired
    archived
    createdBy {
      id
      name
    }
    updatedBy {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExpenseGQL extends Apollo.Mutation<CreateExpenseMutation, CreateExpenseMutationVariables> {
    override document = CreateExpenseDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExpenseDocument = gql`
    mutation updateExpense($input: UpdateExpenseInput!) {
  updateExpense(input: $input) {
    id
    name
    description
    maxValue
    receiptRequired
    archived
    createdBy {
      id
      name
    }
    updatedBy {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExpenseGQL extends Apollo.Mutation<UpdateExpenseMutation, UpdateExpenseMutationVariables> {
    override document = UpdateExpenseDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveExpenseDocument = gql`
    mutation archiveExpense($id: ID!) {
  archiveExpense(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveExpenseGQL extends Apollo.Mutation<ArchiveExpenseMutation, ArchiveExpenseMutationVariables> {
    override document = ArchiveExpenseDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveExpenseDocument = gql`
    mutation unarchiveExpense($id: ID!) {
  unarchiveExpense(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveExpenseGQL extends Apollo.Mutation<UnarchiveExpenseMutation, UnarchiveExpenseMutationVariables> {
    override document = UnarchiveExpenseDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGuestsDocument = gql`
    query getGuests($where: UserWhereInput, $limit: Int!, $offset: Int, $orderBy: UserOrderByInput) {
  guests(where: $where, limit: $limit, offset: $offset, orderBy: $orderBy) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      email
      avatarUrl
      guest {
        documentNumber
        phoneNumber
        location {
          id
          address {
            formattedAddress
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGuestsGQL extends Apollo.Query<GetGuestsQuery, GetGuestsQueryVariables> {
    override document = GetGuestsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GuestDocument = gql`
    query guest($id: ID!) {
  guest(id: $id) {
    id
    name
    email
    avatarUrl
    guest {
      documentNumber
      phoneNumber
      location {
        address {
          formattedAddress
        }
      }
      locations {
        id
        name
        archived
        default
        locked
        updatedBy {
          name
        }
        createdBy {
          name
        }
        notes
        address {
          streetName
          number
          neighborhood
          city
          state
          postalCode
          formattedAddress
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GuestGQL extends Apollo.Query<GuestQuery, GuestQueryVariables> {
    override document = GuestDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StorageProductDocument = gql`
    query storageProduct($storageId: ID!, $productId: ID!) {
  storageProducts(where: {storageId: $storageId, productId: $productId}) {
    items {
      id
      storage {
        id
        name
      }
      product {
        id
        name
      }
      quantity
      minimalQuantity
      minimalQuantityAtRisk
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StorageProductGQL extends Apollo.Query<StorageProductQuery, StorageProductQueryVariables> {
    override document = StorageProductDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExternalStorageProductDocument = gql`
    query externalStorageProduct($storageId: ID!, $sammathnaurProductId: ID!) {
  externalStorageProductsV2(
    where: {storageId: $storageId, sammathnaurProductId: $sammathnaurProductId}
  ) {
    items {
      id
      storage {
        id
        name
      }
      product {
        id
        name
      }
      quantity
      minimalQuantity
      minimalQuantityAtRisk
      status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExternalStorageProductGQL extends Apollo.Query<ExternalStorageProductQuery, ExternalStorageProductQueryVariables> {
    override document = ExternalStorageProductDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProductCompanyDocument = gql`
    mutation createProductCompany($input: CreateProductCompanyInput!) {
  createProductCompany(input: $input) {
    id
    value
    archived
    preferences {
      allowEditValue
    }
    company {
      id
      name
      avatarUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProductCompanyGQL extends Apollo.Mutation<CreateProductCompanyMutation, CreateProductCompanyMutationVariables> {
    override document = CreateProductCompanyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductCompanyDocument = gql`
    mutation updateProductCompany($input: UpdateProductCompanyInput!) {
  updateProductCompany(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductCompanyGQL extends Apollo.Mutation<UpdateProductCompanyMutation, UpdateProductCompanyMutationVariables> {
    override document = UpdateProductCompanyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveProductCompanyDocument = gql`
    mutation archiveProductCompany($id: ID!) {
  archiveProductCompany(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveProductCompanyGQL extends Apollo.Mutation<ArchiveProductCompanyMutation, ArchiveProductCompanyMutationVariables> {
    override document = ArchiveProductCompanyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveProductCompanyDocument = gql`
    mutation unarchiveProductCompany($id: ID!) {
  unarchiveProductCompany(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveProductCompanyGQL extends Apollo.Mutation<UnarchiveProductCompanyMutation, UnarchiveProductCompanyMutationVariables> {
    override document = UnarchiveProductCompanyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedProductsDocument = gql`
    query paginatedProducts($where: ProductsWhereInput, $orderBy: ProductsOrderByInput, $limit: Int, $offset: Int) {
  products(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      name
      code
      measure
      imageUrl
      archived
      productType {
        id
        name
      }
      createdBy {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedProductsGQL extends Apollo.Query<PaginatedProductsQuery, PaginatedProductsQueryVariables> {
    override document = PaginatedProductsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductByIdDocument = gql`
    query getProductById($id: ID!) {
  product(id: $id) {
    id
    name
    code
    qrCode
    measure
    imageUrl
    updatedAt
    createdAt
    archived
    description
    companies {
      id
      value
      archived
      preferences {
        allowEditValue
      }
      company {
        id
        name
        avatarUrl
      }
    }
    productType {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductByIdGQL extends Apollo.Query<GetProductByIdQuery, GetProductByIdQueryVariables> {
    override document = GetProductByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductStoragesDocument = gql`
    query getProductStorages($id: ID!, $orderBy: CreatedAtOrderByInput, $limit: Int, $offset: Int) {
  product(id: $id) {
    id
    name
    storages(orderBy: $orderBy, limit: $limit, offset: $offset) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        quantity
        storage {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductStoragesGQL extends Apollo.Query<GetProductStoragesQuery, GetProductStoragesQueryVariables> {
    override document = GetProductStoragesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NextProductCodeDocument = gql`
    query nextProductCode {
  nextProductCode {
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NextProductCodeGQL extends Apollo.Query<NextProductCodeQuery, NextProductCodeQueryVariables> {
    override document = NextProductCodeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProductDocument = gql`
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    id
    name
    imageUrl
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProductGQL extends Apollo.Mutation<CreateProductMutation, CreateProductMutationVariables> {
    override document = CreateProductDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    id
    name
    imageUrl
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductGQL extends Apollo.Mutation<UpdateProductMutation, UpdateProductMutationVariables> {
    override document = UpdateProductDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveProductDocument = gql`
    mutation archiveProduct($id: ID!) {
  archiveProduct(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveProductGQL extends Apollo.Mutation<ArchiveProductMutation, ArchiveProductMutationVariables> {
    override document = ArchiveProductDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveProductDocument = gql`
    mutation unarchiveProduct($id: ID!) {
  unarchiveProduct(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveProductGQL extends Apollo.Mutation<UnarchiveProductMutation, UnarchiveProductMutationVariables> {
    override document = UnarchiveProductDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedServicesDocument = gql`
    query paginatedServices($where: ServiceWhereInput, $orderBy: ServiceOrderByInput, $limit: Int, $offset: Int) {
  services(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      name
      description
      imageUrl
      archived
      createdBy {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedServicesGQL extends Apollo.Query<PaginatedServicesQuery, PaginatedServicesQueryVariables> {
    override document = PaginatedServicesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetServiceByIdDocument = gql`
    query getServiceById($id: ID!) {
  service(id: $id) {
    id
    name
    imageUrl
    updatedAt
    createdAt
    archived
    description
    companies {
      id
      value
      valueType
      archived
      preferences {
        allowEditValue
        weekDayValues {
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
        }
      }
      company {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetServiceByIdGQL extends Apollo.Query<GetServiceByIdQuery, GetServiceByIdQueryVariables> {
    override document = GetServiceByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateServiceDocument = gql`
    mutation createService($input: CreateServiceInput!) {
  createService(input: $input) {
    id
    name
    imageUrl
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateServiceGQL extends Apollo.Mutation<CreateServiceMutation, CreateServiceMutationVariables> {
    override document = CreateServiceDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateServiceDocument = gql`
    mutation updateService($input: UpdateServiceInput!) {
  updateService(input: $input) {
    id
    name
    imageUrl
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateServiceGQL extends Apollo.Mutation<UpdateServiceMutation, UpdateServiceMutationVariables> {
    override document = UpdateServiceDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveServiceDocument = gql`
    mutation archiveService($id: ID!) {
  archiveService(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveServiceGQL extends Apollo.Mutation<ArchiveServiceMutation, ArchiveServiceMutationVariables> {
    override document = ArchiveServiceDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveServiceDocument = gql`
    mutation unarchiveService($id: ID!) {
  unarchiveService(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveServiceGQL extends Apollo.Mutation<UnarchiveServiceMutation, UnarchiveServiceMutationVariables> {
    override document = UnarchiveServiceDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedExternalStorageProductsDocument = gql`
    query paginatedExternalStorageProducts($where: ExternalStorageProductV2WhereInput!, $orderBy: ExternalStorageProductsOrderByInput, $limit: Int, $offset: Int) {
  externalStorageProductsV2(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      quantity
      status
      company {
        id
        name
        avatarUrl
      }
      storage {
        id
        name
      }
      product {
        id
        name
        code
        measure
        imageUrl
        productType {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedExternalStorageProductsGQL extends Apollo.Query<PaginatedExternalStorageProductsQuery, PaginatedExternalStorageProductsQueryVariables> {
    override document = PaginatedExternalStorageProductsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExternalStorageProductByIdDocument = gql`
    query getExternalStorageProductById($id: ID!) {
  externalStorageProduct(id: $id) {
    id
    quantity
    createdAt
    minimalQuantity
    minimalQuantityAtRisk
    product {
      id
      code
      name
      qrCode
      measure
      imageUrl
      description
      productType {
        id
        name
      }
    }
    company {
      id
      name
    }
    storage {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExternalStorageProductByIdGQL extends Apollo.Query<GetExternalStorageProductByIdQuery, GetExternalStorageProductByIdQueryVariables> {
    override document = GetExternalStorageProductByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateExternalStorageProductDocument = gql`
    mutation updateExternalStorageProduct($input: UpdateExternalStorageProductInput!) {
  updateExternalStorageProduct(input: $input) {
    id
    quantity
    minimalQuantity
    minimalQuantityAtRisk
    product {
      id
      code
      name
      qrCode
      measure
      imageUrl
      description
      productType {
        id
        name
      }
    }
    storage {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExternalStorageProductGQL extends Apollo.Mutation<UpdateExternalStorageProductMutation, UpdateExternalStorageProductMutationVariables> {
    override document = UpdateExternalStorageProductDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedStorageProductsDocument = gql`
    query paginatedStorageProducts($where: StorageProductsWhereInput, $orderBy: StoragesProductsOrderByInput, $limit: Int, $offset: Int) {
  storageProducts(
    where: $where
    orderBy: $orderBy
    limit: $limit
    offset: $offset
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      account {
        id
        name
        loginCustomization {
          logoUrl
        }
      }
      quantity
      status
      storage {
        id
        name
      }
      product {
        id
        name
        code
        measure
        imageUrl
        productType {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedStorageProductsGQL extends Apollo.Query<PaginatedStorageProductsQuery, PaginatedStorageProductsQueryVariables> {
    override document = PaginatedStorageProductsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStorageProductByIdDocument = gql`
    query getStorageProductById($id: ID!) {
  storageProduct(id: $id) {
    id
    quantity
    createdAt
    updatedAt
    minimalQuantity
    minimalQuantityAtRisk
    product {
      id
      code
      name
      qrCode
      measure
      imageUrl
      description
      productType {
        id
        name
      }
    }
    storage {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStorageProductByIdGQL extends Apollo.Query<GetStorageProductByIdQuery, GetStorageProductByIdQueryVariables> {
    override document = GetStorageProductByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStorageProductDocument = gql`
    mutation updateStorageProduct($input: UpdateStorageProductInput!) {
  updateStorageProduct(input: $input) {
    id
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStorageProductGQL extends Apollo.Mutation<UpdateStorageProductMutation, UpdateStorageProductMutationVariables> {
    override document = UpdateStorageProductDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedStoragesDocument = gql`
    query paginatedStorages($where: StoragesWhereInput, $orderBy: StoragesOrderByInput, $limit: Int, $offset: Int) {
  storages(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      name
      description
      location {
        id
        name
        address {
          formattedAddress
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedStoragesGQL extends Apollo.Query<PaginatedStoragesQuery, PaginatedStoragesQueryVariables> {
    override document = PaginatedStoragesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStorageByIdDocument = gql`
    query getStorageById($id: ID!) {
  storage(id: $id) {
    id
    name
    description
    archived
    createdAt
    updatedAt
    location {
      id
      name
      address {
        formattedAddress
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStorageByIdGQL extends Apollo.Query<GetStorageByIdQuery, GetStorageByIdQueryVariables> {
    override document = GetStorageByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStorageProductsByStorageIdDocument = gql`
    query getStorageProductsByStorageId($id: ID!, $orderBy: CreatedAtOrderByInput, $where: StorageProductsWhereInput, $limit: Int, $offset: Int) {
  storage(id: $id) {
    products(orderBy: $orderBy, limit: $limit, offset: $offset, where: $where) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        quantity
        createdBy {
          id
          name
        }
        product {
          id
          name
          code
          measure
          imageUrl
          productType {
            id
            name
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStorageProductsByStorageIdGQL extends Apollo.Query<GetStorageProductsByStorageIdQuery, GetStorageProductsByStorageIdQueryVariables> {
    override document = GetStorageProductsByStorageIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStorageMovementsByStorageIdDocument = gql`
    query getStorageMovementsByStorageId($id: ID!, $orderBy: CreatedAtOrderByInput, $take: Int, $after: String) {
  storage(id: $id) {
    movements(orderBy: $orderBy, take: $take, after: $after) {
      totalCount
      pageInfo {
        startCursor
        endCursor
      }
      items {
        id
        description
        company {
          id
          name
          avatarUrl
        }
        storage {
          id
          name
          products {
            totalCount
            items {
              id
              quantity
              product {
                id
                name
                code
                imageUrl
              }
            }
          }
        }
        externalStorage {
          name
          employee {
            name
            avatarUrl
          }
        }
        relatedStorageMovement {
          quantity {
            previous
            changed
            current
          }
          storage {
            name
            products {
              totalCount
              items {
                id
                quantity
                product {
                  id
                  name
                  code
                  imageUrl
                }
              }
            }
          }
        }
        type
        quantity {
          previous
          changed
          current
        }
        product {
          id
          name
          code
          imageUrl
          measure
          productType {
            id
            name
          }
        }
        createdAt
        updatedAt
        createdBy {
          name
          avatarUrl
        }
        updatedBy {
          name
          avatarUrl
        }
        sync {
          status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStorageMovementsByStorageIdGQL extends Apollo.Query<GetStorageMovementsByStorageIdQuery, GetStorageMovementsByStorageIdQueryVariables> {
    override document = GetStorageMovementsByStorageIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateStorageDocument = gql`
    mutation createStorage($input: CreateStorageInput!) {
  createStorage(input: $input) {
    id
    name
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateStorageGQL extends Apollo.Mutation<CreateStorageMutation, CreateStorageMutationVariables> {
    override document = CreateStorageDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStorageDocument = gql`
    mutation updateStorage($input: UpdateStorageInput!) {
  updateStorage(input: $input) {
    id
    name
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStorageGQL extends Apollo.Mutation<UpdateStorageMutation, UpdateStorageMutationVariables> {
    override document = UpdateStorageDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveStorageDocument = gql`
    mutation archiveStorage($id: ID!) {
  archiveStorage(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveStorageGQL extends Apollo.Mutation<ArchiveStorageMutation, ArchiveStorageMutationVariables> {
    override document = ArchiveStorageDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveStorageDocument = gql`
    mutation unarchiveStorage($id: ID!) {
  unarchiveStorage(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveStorageGQL extends Apollo.Mutation<UnarchiveStorageMutation, UnarchiveStorageMutationVariables> {
    override document = UnarchiveStorageDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePendencyDocument = gql`
    mutation createPendency($input: CreatePendencyInput!) {
  createPendency(input: $input) {
    id
    title
    identifier
    createdAt
    updatedAt
    company {
      name
      avatarUrl
    }
    pendencyType {
      name
    }
    assignees {
      id
      name
      avatarUrl
    }
    readers {
      id
      name
      avatarUrl
    }
    treatmentType
    treatmentStatus
    status
    archived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePendencyGQL extends Apollo.Mutation<CreatePendencyMutation, CreatePendencyMutationVariables> {
    override document = CreatePendencyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePendencyDocument = gql`
    mutation updatePendency($input: UpdatePendencyInput!) {
  updatePendency(input: $input) {
    id
    title
    status
    archived
    createdAt
    updatedAt
    identifier
    description
    treatmentStatus
    createdBy {
      id
      name
    }
    updatedBy {
      id
      name
    }
    assignees {
      id
      name
      avatarUrl
    }
    readers {
      id
      name
      avatarUrl
    }
    treatmentType
    maintenance {
      id
      number
      location {
        name
      }
      segment {
        name
      }
      maintenanceType {
        name
      }
    }
    company {
      id
      name
      avatarUrl
    }
    pendencyType {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePendencyGQL extends Apollo.Mutation<UpdatePendencyMutation, UpdatePendencyMutationVariables> {
    override document = UpdatePendencyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchivePendencyDocument = gql`
    mutation archivePendency($id: ID!) {
  archivePendency(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchivePendencyGQL extends Apollo.Mutation<ArchivePendencyMutation, ArchivePendencyMutationVariables> {
    override document = ArchivePendencyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConcludePendencyDocument = gql`
    mutation concludePendency($id: ID!) {
  concludePendency(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConcludePendencyGQL extends Apollo.Mutation<ConcludePendencyMutation, ConcludePendencyMutationVariables> {
    override document = ConcludePendencyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchivePendencyDocument = gql`
    mutation unarchivePendency($id: ID!) {
  unarchivePendency(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchivePendencyGQL extends Apollo.Mutation<UnarchivePendencyMutation, UnarchivePendencyMutationVariables> {
    override document = UnarchivePendencyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePendencyAssigneeDocument = gql`
    mutation updatePendencyAssignee($input: UpdatePendencyAssigneeInput!) {
  updatePendencyAssignee(input: $input) {
    id
    updatedAt
    assignee {
      id
      name
      avatarUrl
    }
    assignees {
      id
      name
      avatarUrl
    }
    readers {
      id
      name
      avatarUrl
    }
    maintenance {
      id
      number
      location {
        name
      }
      segment {
        name
      }
      maintenanceType {
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePendencyAssigneeGQL extends Apollo.Mutation<UpdatePendencyAssigneeMutation, UpdatePendencyAssigneeMutationVariables> {
    override document = UpdatePendencyAssigneeDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransferPendencyDocument = gql`
    mutation transferPendency($id: ID!) {
  transferPendency(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TransferPendencyGQL extends Apollo.Mutation<TransferPendencyMutation, TransferPendencyMutationVariables> {
    override document = TransferPendencyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPendencyByIdDocument = gql`
    query getPendencyById($id: ID!) {
  pendency(id: $id) {
    id
    title
    status
    archived
    createdAt
    updatedAt
    identifier
    description
    treatmentStatus
    createdBy {
      id
      name
    }
    updatedBy {
      id
      name
    }
    assignees {
      id
      name
      avatarUrl
    }
    readers {
      id
      name
      avatarUrl
    }
    treatmentType
    maintenance {
      id
      number
      location {
        name
      }
      segment {
        name
      }
      maintenanceType {
        name
      }
    }
    company {
      id
      name
      avatarUrl
    }
    pendencyType {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPendencyByIdGQL extends Apollo.Query<GetPendencyByIdQuery, GetPendencyByIdQueryVariables> {
    override document = GetPendencyByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PendencyEventDocument = gql`
    query pendencyEvent($id: ID!) {
  pendencyEvent(id: $id) {
    id
    createdAt
    updatedAt
    type
    createdBy {
      id
      type
      name
      avatarUrl
      company {
        id
        name
      }
    }
    updatedBy {
      id
      type
      name
      avatarUrl
      company {
        id
        name
      }
    }
    content {
      ... on PendencyEventLog {
        type
        changes {
          column
          oldValue {
            ... on Company {
              id
              name
            }
            ... on Maintenance {
              id
              number
            }
            ... on PendencyType {
              id
              name
            }
            ... on User {
              id
              name
            }
            ... on ScalarStringWrapper {
              value
            }
          }
          newValue {
            ... on Company {
              id
              name
            }
            ... on Maintenance {
              id
              number
            }
            ... on PendencyType {
              id
              name
            }
            ... on User {
              id
              name
            }
            ... on ScalarStringWrapper {
              value
            }
          }
        }
      }
      ... on PendencyEventReply {
        message
        attachments {
          size
          path
          type
          title
          createdAt
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PendencyEventGQL extends Apollo.Query<PendencyEventQuery, PendencyEventQueryVariables> {
    override document = PendencyEventDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPendencyEventsDocument = gql`
    query getPendencyEvents($id: ID!, $where: PendencyEventWhereInput, $take: Int!, $after: String) {
  pendency(id: $id) {
    id
    title
    identifier
    events(where: $where, take: $take, after: $after) {
      totalCount
      pageInfo {
        startCursor
        endCursor
      }
      items {
        id
        type
        createdAt
        updatedAt
        createdBy {
          id
          type
          name
          avatarUrl
          company {
            id
            name
          }
        }
        content {
          ... on PendencyEventLog {
            type
            changes {
              column
              oldValue {
                ... on Company {
                  id
                  name
                }
                ... on Maintenance {
                  id
                  number
                }
                ... on PendencyType {
                  id
                  name
                }
                ... on User {
                  id
                  name
                }
                ... on ScalarStringWrapper {
                  value
                }
              }
              newValue {
                ... on Company {
                  id
                  name
                }
                ... on Maintenance {
                  id
                  number
                }
                ... on PendencyType {
                  id
                  name
                }
                ... on User {
                  id
                  name
                }
                ... on ScalarStringWrapper {
                  value
                }
              }
            }
          }
          ... on PendencyEventNote {
            message
          }
          ... on PendencyEventReply {
            message
            attachments {
              size
              path
              type
              title
              createdAt
              download {
                signedUrl
                expiresAt
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPendencyEventsGQL extends Apollo.Query<GetPendencyEventsQuery, GetPendencyEventsQueryVariables> {
    override document = GetPendencyEventsDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PaginatedPendenciesDocument = gql`
    query paginatedPendencies($where: PendenciesWhereInput, $orderBy: PendenciesOrderByInput, $after: String, $take: Int) {
  pendencies(where: $where, orderBy: $orderBy, after: $after, take: $take) {
    totalCount
    pageInfo {
      startCursor
      endCursor
    }
    items {
      id
      title
      archived
      identifier
      createdAt
      updatedAt
      company {
        name
        avatarUrl
      }
      pendencyType {
        name
      }
      assignees {
        id
        name
        avatarUrl
      }
      readers {
        id
        name
        avatarUrl
      }
      treatmentType
      treatmentStatus
      status
      archived
      maintenance {
        id
        number
        segment {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaginatedPendenciesGQL extends Apollo.Query<PaginatedPendenciesQuery, PaginatedPendenciesQueryVariables> {
    override document = PaginatedPendenciesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePendencyEventReplyDocument = gql`
    mutation createPendencyEventReply($input: CreatePendencyEventReplyInput!) {
  createPendencyEventReply(input: $input) {
    id
    type
    createdAt
    createdBy {
      id
      type
      name
      avatarUrl
      company {
        id
        name
      }
    }
    content {
      ... on PendencyEventReply {
        message
        attachments {
          size
          path
          type
          title
          createdAt
          download {
            signedUrl
            expiresAt
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePendencyEventReplyGQL extends Apollo.Mutation<CreatePendencyEventReplyMutation, CreatePendencyEventReplyMutationVariables> {
    override document = CreatePendencyEventReplyDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePendencyEventNoteDocument = gql`
    mutation createPendencyEventNote($input: CreatePendencyEventNoteInput!) {
  createPendencyEventNote(input: $input) {
    id
    type
    createdAt
    updatedAt
    pendency {
      id
      title
      identifier
    }
    createdBy {
      id
      type
      name
      avatarUrl
      company {
        id
        name
      }
    }
    updatedBy {
      id
      type
      name
      avatarUrl
      company {
        id
        name
      }
    }
    content {
      ... on PendencyEventNote {
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePendencyEventNoteGQL extends Apollo.Mutation<CreatePendencyEventNoteMutation, CreatePendencyEventNoteMutationVariables> {
    override document = CreatePendencyEventNoteDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePendencyEventNoteDocument = gql`
    mutation updatePendencyEventNote($input: UpdatePendencyEventNoteInput!) {
  updatePendencyEventNote(input: $input) {
    type
    createdAt
    updatedAt
    pendency {
      id
      title
      identifier
    }
    createdBy {
      id
      type
      name
      avatarUrl
      company {
        id
        name
      }
    }
    updatedBy {
      id
      type
      name
      avatarUrl
      company {
        id
        name
      }
    }
    content {
      ... on PendencyEventNote {
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePendencyEventNoteGQL extends Apollo.Mutation<UpdatePendencyEventNoteMutation, UpdatePendencyEventNoteMutationVariables> {
    override document = UpdatePendencyEventNoteDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePendencyEventNoteDocument = gql`
    mutation deletePendencyEventNote($id: ID!) {
  deletePendencyEventNote(id: $id) {
    id
    type
    createdAt
    updatedAt
    pendency {
      id
      title
      identifier
    }
    createdBy {
      id
      type
      name
      avatarUrl
      company {
        id
        name
      }
    }
    updatedBy {
      id
      type
      name
      avatarUrl
      company {
        id
        name
      }
    }
    content {
      ... on PendencyEventNote {
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePendencyEventNoteGQL extends Apollo.Mutation<DeletePendencyEventNoteMutation, DeletePendencyEventNoteMutationVariables> {
    override document = DeletePendencyEventNoteDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWarrantiesTemplatesDocument = gql`
    query getWarrantiesTemplates($where: WarrantiesTemplatesWhereInput, $limit: Int!, $offset: Int, $orderBy: WarrantiesTemplatesOrderByInput) {
  warrantiesTemplates(
    where: $where
    limit: $limit
    offset: $offset
    orderBy: $orderBy
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    items {
      id
      name
      description
      value
      type
      coverageDurationDays
      extendedCoverageDurationDays
      extendedValue
      createdAt
      createdBy {
        id
        name
        avatarUrl
      }
      updatedBy {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWarrantiesTemplatesGQL extends Apollo.Query<GetWarrantiesTemplatesQuery, GetWarrantiesTemplatesQueryVariables> {
    override document = GetWarrantiesTemplatesDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWarrantyTemplateByIdDocument = gql`
    query getWarrantyTemplateById($id: ID!) {
  warrantyTemplate(id: $id) {
    id
    name
    description
    value
    type
    archived
    coverageDurationDays
    extendedCoverageDurationDays
    extendedValue
    createdAt
    updatedAt
    warranties {
      id
    }
    companies {
      id
      name
      address {
        formattedAddress
      }
    }
    maintenancesTypes {
      id
      name
    }
    attachments {
      id
      bucketName
      fileKey
      createdAt
      title
      size
      download {
        signedUrl
        expiresAt
      }
    }
    createdBy {
      id
      name
    }
    updatedBy {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWarrantyTemplateByIdGQL extends Apollo.Query<GetWarrantyTemplateByIdQuery, GetWarrantyTemplateByIdQueryVariables> {
    override document = GetWarrantyTemplateByIdDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateWarrantyTemplateDocument = gql`
    mutation createWarrantyTemplate($input: CreateWarrantyTemplateInput!) {
  createWarrantyTemplate(input: $input) {
    name
    type
    description
    archived
    value
    coverageDurationDays
    extendedCoverageDurationDays
    extendedValue
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateWarrantyTemplateGQL extends Apollo.Mutation<CreateWarrantyTemplateMutation, CreateWarrantyTemplateMutationVariables> {
    override document = CreateWarrantyTemplateDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateWarrantyTemplateDocument = gql`
    mutation updateWarrantyTemplate($input: UpdateWarrantyTemplateInput!) {
  updateWarrantyTemplate(input: $input) {
    name
    type
    description
    archived
    value
    coverageDurationDays
    extendedCoverageDurationDays
    extendedValue
    description
    attachments {
      id
      bucketName
      fileKey
      createdAt
      title
      size
      download {
        signedUrl
        expiresAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateWarrantyTemplateGQL extends Apollo.Mutation<UpdateWarrantyTemplateMutation, UpdateWarrantyTemplateMutationVariables> {
    override document = UpdateWarrantyTemplateDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveWarrantyTemplateDocument = gql`
    mutation archiveWarrantyTemplate($input: ArchivedWarrantyTemplateInput!) {
  archiveWarrantyTemplate(input: $input) {
    id
    archived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveWarrantyTemplateGQL extends Apollo.Mutation<ArchiveWarrantyTemplateMutation, ArchiveWarrantyTemplateMutationVariables> {
    override document = ArchiveWarrantyTemplateDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnarchiveWarrantyTemplateDocument = gql`
    mutation unarchiveWarrantyTemplate($id: ID!) {
  unarchiveWarrantyTemplate(id: $id) {
    id
    archived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnarchiveWarrantyTemplateGQL extends Apollo.Mutation<UnarchiveWarrantyTemplateMutation, UnarchiveWarrantyTemplateMutationVariables> {
    override document = UnarchiveWarrantyTemplateDocument;
    override client = 'sammathnaur';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
